import { ERROR_KEYS } from '@lemontaps/lib/constants';

export const de = {
  translation: {
    academy: 'Academy',
    phoneNumberRenderedAs: 'Wird so dargestellt: {{nr}}',
    none: 'Nichts',
    generating: 'Generiere...',
    filling: 'Formular ausfüllen...',
    nFiltersApplied: '{{count}} Filter aktiv',
    checked: 'Ausgewählt',
    unchecked: 'Nicht ausgewählt',
    both: 'Alles',
    manage: 'Verwalten',
    copied: 'Kopiert!',
    copiedToClipboard: 'In Zwischenablage kopiert',
    ariaCopy: '{{label}} kopieren',
    copy: 'Kopieren',
    paste: 'Einfügen',
    setup: 'Setup',
    updated: 'Aktualisiert',
    deleted: 'Gelöscht',
    disabled: 'Deaktiviert',
    requiresApproval: 'Erfordert Genehmigung',
    requests: 'Freigaben',
    requestApproval: 'Genehmigung anfragen',
    requestDeleteApproval: 'Löschung anfragen',
    newUser: 'Neue:r Nutzer:in',
    new: 'Neu',
    changeRequested: 'Änderung angefragt',
    AI: 'KI',
    leadCollectedVia: 'Unit',
    collectedViaGlobalForm: 'Globales Formular',
    showAll: 'Alle anzeigen',
    changeRole: 'Rolle ändern',
    addField: 'Feld hinzufügen',
    selectUser: 'Mitarbeiter:in auswählen',
    paperBusinessCard: 'Papiervisitenkarte',
    imageSizeInfo: {
      coverImage: 'Seitenverhältnis: 16:9. Empfohlene Auflösung: 1920x1080px.',
      logoImage: 'Beliebiges Bildformat. Empfohlene Mindestauflösung der kleineren Seite: 300px.',
      profileImage:
        'Seitenverhältnis: 1:1. Wird als Kreis ausgeschnitten. Empfohlene Mindestauflösung pro Seite: 600px.',
      faviconImage: 'Seitenverhältnis: 1:1. Empfohlene Auflösung: 16x16px.',
    },
    quotaExceeded:
      'Kontingent überschritten. Kontaktiere den Vertrieb oder warte, bis sich dein Kontingent zurücksetzt.',
    paperCards: 'Papiervisitenkarten',
    profilePicture: 'Profilbild',
    colSortMenu: {
      dialogTitle: 'Tabelle anpassen',
      description: 'Du kannst die Reihenfolge der Spalten ändern und Spalten ein- oder ausblenden.',
      showColumnHeader: 'Spalte anzeigen',
    },
    resetPassword: 'Passwort zurücksetzen',
    control: {
      title: 'Steuerung',
      scim: 'SCIM',
      scimHelper:
        'Dieses Feld wird durch SCIM kontrolliert. Deine Änderungen können überschrieben werden.',
      entraIdSync: 'Entra-ID-Sync',
      entraIdSyncHelper:
        'Dieses Feld wird durch Entra-ID-Sync kontrolliert. Deine Änderungen können überschrieben werden.',
      manual: 'Manuell',
      defaultContentHelper:
        'Dieser Wert ist ein Standardwert und kann nur in den Profildesign-Einstellungen geändert werden.',
    },
    ariaProfileFile: 'Profildatei',
    ariaProfileLink: 'Profillink',
    ariaSelectStartDay: 'Wähle {{date}} als Start des Zeitraums aus',
    ariaSelectEndDay: 'Wähle {{date}} als Ende des Zeitraums aus',
    ariaSelectMonth: 'Monat auswählen',
    ariaSelectYear: 'Jahr auswählen',
    ariaMoveMonthBack: 'Um einen Monat zurück',
    ariaMoveMonthForward: 'Um einen Monat vor',
    ariaFrom: 'Von',
    ariaTo: 'Nach',
    ariaHeaderDateRangePicker: 'Zeitraum auswählen',
    ariaSelectPredefinedRange: 'Vordefinierten Zeitraum wählen: ',
    ariaHelpTooltip: 'Hilfe',
    ariaInfoTooltip: 'Info',
    ariaGdprConsent: 'Zustimmung zur Datenschutzerklärung',
    ariaAddProfilePicture: 'Profilbild hinzufügen',
    ariaEditProfilePicture: 'Profilbild bearbeiten',
    ariaEditContactDetails: 'Kontaktdaten bearbeiten',
    ariaGoBack: 'Zurück',
    ariaShowAllSharingOptions: 'Alle Optionen zum Teilen des Profils anzeigen',
    ariaAcademySwiperPreviousVideo: 'Zeige vorheriges Academy-Video',
    ariaAcademySwiperNextVideo: 'Zeige nächstes Academy-Video',
    ariaNavHeaderProfile: 'Navigationselemente des Einzelnutzers ein-/ausblenden',
    ariaNavHeaderAdmin: 'Navigationselemente des Admins ein-/ausblenden',
    ariaNavHeaderTeamSettings: 'Navigationselemente der Team-Einstellungen ein-/ausblenden',
    ariaNavHeaderSettings: 'Navigationselemente der Einstellungen ein-/ausblenden',
    ariaHeaderAdminDropdown: 'Profil-Einstellungsmenü öffnen',
    ariaHeaderHelpDropdown: 'Hilfe-Menü öffnen',
    ariaAddLink: 'Link hinzufügen',
    ariaAddFile: 'Datei hinzufügen',
    onlyPreview: 'Dies ist nur eine Vorschau',
    ariaCollapseTo_one: 'Liste auf ein Element reduzieren',
    ariaCollapseTo_other: 'Liste auf {{count}} Elemente reduzieren',
    ariaExpandFor_one: 'Kontaktdaten erweitern, um ein weiteres Element anzuzeigen',
    ariaExpandFor_other: 'Kontaktdaten erweitern, um {{count}} weitere Elemente anzuzeigen',
    ariaOpenCookieSettings: 'Öffne die Einstellungen für Cookies',
    adminDisabledEditRight: 'Dein Admin erlaubt Dir nicht, hier Bearbeitungen vorzunehmen.',
    ariaDigitalBusinesscardOf: 'Digitale Visitenkarte von',
    ariaLogoImage: 'Unternehmens-Logo',
    ariaProfilePicture: 'Profilbild',
    ariaOpenToEnlarge: 'Du kannst das Bild in einem Dialog öffnen',
    ariaBannerImageOption: 'Bildoption {{n}} für das Profil-Banner',
    ariaBannerImageOptionsLabel:
      'Wähle ein Bild aus den Optionen aus, um es als Profil-Banner anzuzeigen.',
    addAnotherUser: 'Nutzer:in hinzufügen',
    livePreview: 'Live Vorschau',
    sendViaEmail: 'Per E-Mail senden',
    ariaLogoOf: 'Logo von {{name}}',
    teamSettingsSubmenu: 'Teameinstellungen - öffnet das Untermenü „Team-Einstellungen“',
    settingsSubmenu: 'Einstellungen - öffnet das Untermenü „Einstellungen“',
    default: 'Standard',
    template: 'Vorlage',
    embed: 'Einbetten',
    bulkEdit: 'Bearbeiten',
    bulkEditProfiles: 'Bearbeiten',
    back: 'Zurück',
    disconnect: 'Trennen',
    done: 'Fertig',
    internalContactPerson: 'Interne:r Ansprechpartner:in',
    generalDesign: 'Allgemeines Design',
    defaultContent: 'Standardinhalt',
    contentTemplate: 'Inhaltsvorlagen',
    editBio: 'Bio bearbeiten',
    fileupload: 'Dateiupload',
    value: 'Wert',
    selectField: 'Feld auswählen',
    override: 'Überschreiben',
    card: 'NFC-Karte',
    addFileDialog: {
      title: 'Titel',
      videoUrl: 'Video-Link',
      modeFile: 'Datei hochladen',
      modeVideoLink: 'Video einbetten',
      embedVideo: {
        label: 'Video einbetten',
        tooltip:
          'Durch das Einbetten wird das Video im Profil angezeigt und kann dort direkt abgespielt werden.',
        placeholder: 'Füge die Video-URL ein (Youtube, Vimeo, etc.)',
      },
      embedVideoAlert: {
        title: 'Video einbetten',
        content: 'Du kannst Videos aus unterschiedlichen Quellen einbetten (YouTube, Vimeo, etc.).',
        helpReference: 'Schau <0>hier</0> für weitere Informationen.',
      },
      error: {
        invalidEmbedUrl: 'Muss Video-Link sein',
      },
    },
    upgradeNow: 'Jetzt upgraden',
    contactSales: 'Mit Vertrieb sprechen',
    testBusinessSolution: 'Firmenlösung testen',
    select: 'Auswählen',
    standard: 'Standard',
    fillRequired: 'Fülle die erforderlichen Felder aus',
    navSidebar: {
      ariaGoHome: 'Öffne Homepage',
      settings: 'Einstellungen',
      teamSettings: {
        ariaGoBack: 'Zurück zu den Hauptnavigationselementen',
      },
      collapseButton: {
        aria: {
          label: 'Navigationsseitenleiste ein-/ausklappen',
        },
      },
    },
    approve: 'Bestätigen',
    reject: 'Ablehnen',
    changeRequests: {
      featureTeaser: 'Upgrade erforderlich um dieses Feature freizuschalten',
      title: 'Freigabeportal',
      requestSuccess: 'Änderungsanfrage erfolgreich eingereicht',
      requestError: 'Fehler beim Einreichen der Änderungsanfrage',
      approveSuccess: 'Änderungsanfragen erfolgreich bestätigt',
      approveError: 'Fehler beim Bestätigen der Änderungsanfragen',
      rejectSuccess: 'Änderungsanfragen erfolgreich abgelehnt',
      rejectError: 'Fehler beim Ablehnen der Änderungsanfragen',
      noChangeRequestsTitle: 'Keine Freigabeanfragen',
      noChangeRequestsDescription:
        'Freizugebende Inhalte werden hier angezeigt. Attribute, die freizugeben sind, kannst Du in den Bearbeitungsrechten verwalten.',
      manageChangeRequests: 'Bearbeitungsrechte verwalten',
      description:
        'Deine Team-Mitglieder:innen haben Anfragen zum Ändern von Informationen eingereicht. Bestätige oder lehne die Änderungen unten ab.',
      approveConfirmDialog: {
        title: 'Änderungsanfragen bestätigen',
        description: 'Bist Du sicher, dass Du diese Änderungsanfragen bestätigen möchtest?',
      },
      rejectConfirmDialog: {
        title: 'Änderungsanfragen ablehnen',
        description: 'Bist Du sicher, dass Du diese Änderungsanfragen ablehnen möchtest?',
        reason: 'Optional: Einen Grund eingeben',
        reasonHelper: 'Der Grund wird in der Benachrichtigungs-E-Mail erwähnt.',
      },
      manageEmailRecipients: 'E-Mail-Empfänger:innen verwalten',
    },

    profileSettings: 'Profil-Einstellungen',
    addCover: 'Hintergrundbild hinzufügen',
    addLogo: 'Logo hinzufügen',
    addImage: 'Bild hinzufügen',
    addAvatar: 'Profilbild hinzufügen',
    addFavicon: 'Favicon hinzufügen',
    add: 'Hinzufügen',
    note: 'Notiz',
    at: 'bei',
    preferredLang: 'Sprache',
    admin: 'Admin',
    nonAdmin: 'Endbenutzer:in',
    controlVisibility: 'Sichtbarkeit steuern',
    scanCard: 'Karte scannen',
    scanCardShort: 'Scannen',
    search: 'Suche',
    noSearchOptions: 'Keine Suchoptionen',
    customizeTable: 'Tabelle anpassen',
    upgradeToContinue: 'Für diese Aktion musst Du upgraden',
    deselectAll: 'Alle abwählen',
    selectAll: 'Alle auswählen',
    namePrefix: 'Namenspräfix',
    salutation: 'Anrede',
    namePrefixHelper: 'z.B. Dr., Prof.',
    nameSuffix: 'Namenssuffix',
    nameSuffixConnector: {
      space: 'Leerzeichen',
      comma: 'Komma',
      colon: 'Doppelpunkt',
      newline: 'Zeilenumbruch',
    },
    academicDegree: 'Akademischer Grad',
    academicDegreeHelper: 'z.B. Ing., B.Sc.',
    academicDegree2: 'Akademischer Grad 2',
    academicDegree2Helper: 'Zeile 2',
    toPaperCardOrderForm: 'Zum Papiervisitenkarten-Bestellformular',
    close: 'Schließen',
    help: 'Hilfe',
    gdpr: 'DSGVO',
    upstreamLeadObjectType: 'Kontakt/Lead',
    upstreamLeadObjectTypeLead: 'Lead',
    upstreamLeadObjectTypeContact: 'Kontakt',
    upstreamLeadObjectTypeNotSpecified: 'Nicht spezifiziert',
    gdprLegalBasis: 'DSGVO',
    addressee: 'Adressat',
    addressLine1: 'Adresszeile 1',
    addressLine2: 'Adresszeile 2',
    postCode: 'PLZ',
    city: 'Stadt',
    country: 'Land',
    address: {
      addressee: 'Adressat',
      addressLine1: 'Adresszeile 1',
      addressLine2: 'Adresszeile 2',
      postCode: 'PLZ',
      city: 'Stadt',
      country: 'Land',
      label: 'Adressbeschriftung',
      2: {
        addressee: '2. Adressat',
        addressLine1: '2. Adresszeile 1',
        addressLine2: '2. Adresszeile 2',
        postCode: '2. PLZ',
        city: '2. Stadt',
        country: '2. Land',
        label: '2. Adressbeschriftung',
      },
    },
    address1: 'Adresse 1',
    address2: 'Adresse 2',
    editDisabledTooltip:
      'Dein Admin hat diese Funktion eingeschränkt. Die Kontaktinformationen Deines Admins findest Du im Hilfe-Button oben rechts.',
    editDisabledTooltipWithEmail:
      'Nur ein Admin kann dies bearbeiten. Bitte kontaktiere: {{email}}.',
    scanner: 'Scanner',
    stillMultiAssigned: 'Manche Accounts sind noch mehr als einer Unit zugewiesen',
    editNotAllowed:
      'Dein Administrator erlaubt es nicht, diese Einstellungen auf Unit-Ebene zu überschreiben.',
    onlyExt: 'Nur ',
    unsavedChangesText: 'Du hast möglicherweise ungespeicherte Änderungen. Trotzdem verlassen?',
    featureNotAllowed: 'Upgrade um dieses Feature freizuschalten',
    upgrade: 'Upgrade',
    openLinkInNewTab: 'Link in neuem Tab öffnen',
    needHelp: 'Fragen?',
    confirm: 'Bestätigen',
    finish: 'Fertig',
    apply: 'Anwenden',
    duplicate: 'Duplizieren',
    deleteSettings: 'Unit-Einstellungen löschen',
    settingDeleteConfirmation:
      'Möchtest Du die Unit-Einstellungen wirklich löschen? Die Einstellungen werden anschließend wieder synchron mit den globalen Organisationseinstellungen sein.',
    settingDeleteConfirmationTitle: 'Unit-Einstellungen Löschen',
    resetSettings: 'Zurücksetzen',
    settingResetConfirmation:
      'Möchtest Du die Einstellungen wirklich komplett auf Anfang zurücksetzen? Auch alle Unit-Einstellungen werden gelöscht.',
    settingResetConfirmationTitle: 'Auf Anfangseinstellungen Zurücksetzen',
    setupSettings: {
      title:
        'Aktuell sind die Einstellungen dieser Unit mit den Einstellungen der Gesamtorganisation synchronisiert.',
      description:
        'Du kannst spezielle Einstellungen für diese Unit festlegen, dann werden sie nicht mehr mit den Einstellungen der Gesamtorganisation synchron sein.',
      buttonText: 'Unit-Einstellungen einrichten +',
    },
    upgradedOnMobile: {
      title: 'Willkommen zu Lemontaps Teams 🎉',
      text: 'Um Dir eine gute und sichere Nutzererfahrung zu garantieren, ist es nur auf dem Desktop möglich, die Admin-Management Ansicht und Funktionalitäten zu nutzen. Logge Dich deshalb gleich auf dem Desktop ein, um auf die neuen Features zugreifen zu können.',
    },
    wallet: {
      description:
        'Füge Lemontaps zu Deiner {{company}} Wallet hinzu und teile Deinen Kontakt über den QR-Code in der Wallet.',
      step1: 'Wähle den QR-Code Typen aus',
      step2: 'Lade deine Visitenkarte in die Wallet',
      hint: {
        title: 'Direkt in die Wallet in meinem {{device}} Gerät?',
        p1: 'Scanne dazu erst den folgenden QR-Code, um Dich auf Deinem {{device}} Gerät in Lemontaps einzuloggen',
        p2: 'Gehe dann auf "Profil teilen" -> "Wallet" und klicke dann auf den "Hinzufügen zu {{company}} Wallet" Button auf Deinem {{device}} Gerät.',
        browsers:
          '⚠️ Die Wallet-Funktion funktioniert in Deinem Browser möglicherweise nicht korrekt. Nutze stattdessen Safari oder Chrome zum Generieren der Visitenkarte für das Wallet.',
      },
    },
    sendFollowUpEmailPopup: {
      title: 'Follow-Up E-Mail',
      body: 'Möchtest du die Follow-Up E-Mail jetzt an {{leadEmail}} versenden?',
    },
    toProfile: 'Zu meinem Profil',
    profileOf: 'Profil von {{name}}',
    contactUs: 'Kontaktiere uns',
    openOnDesktop:
      'Der Zugriff auf die Admin Management Plattform ist nur über Desktop-Geräte möglich, aufgrund von Sicherheitsmaßnahmen.',
    upgradeRequestPopup: {
      title: 'Kontaktiere uns mit Deinem Anliegen',
    },
    upgradePopup: {
      title: 'Willkommen zu Lemontaps {{plan}} 🎉',
      q1: 'Wie heißt Deine Organisation?',
      q2: 'Um wie viele potentielle Nutzer handelt es sich?',
      submit: 'Jetzt loslegen!',
    },
    myCards: 'NFC-Karten',
    profileOverview: 'Profilübersicht',
    profileOverviewFromUnits: 'Unit Mitglieder:Innen',
    header: {
      help: 'Hilfe',
      helpCenter: 'Hilfe-Center',
      chatWithUs: 'Chatte mit uns',
      bookCall: '10-Minuten-Gespräch buchen',
      support: 'Support-Anfragen',
      settings: 'Account-Einstellungen',
      teamManagement: 'Team Management',
      langSelector: {
        aria: {
          label: 'Sprache ändern',
          en: 'Englisch auswählen',
          de: 'Deutsch auswählen',
        },
      },
    },
    saved: 'Gespeichert',
    permissionLevel: 'Berechtigungslevel',
    ue: 'Unerwarteter Fehler',
    unexpectedError: 'Unerwarteter Fehler',
    invalidCharEntered: 'Ungültiges Symbol',
    explainTemplatedLink:
      'Dies ist ein Standardlink. Er kann nur entfernt, nicht aber bearbeitet werden',
    explainThemeLink: 'Dieser Link ist von einem Admin festgelegt und kann nicht bearbeitet werden',
    explainThemeLinkToAdmin:
      'Dieser Link wird auf jedem Profil angezeigt. Er kann auf der Profildesign-Seite bearbeitet werden.',
    explainThemeFile: 'Diese Datei ist von einem Admin festgelegt und kann nicht bearbeitet werden',
    explainThemeFileToAdmin:
      'Diese Datei wird auf jedem Profil angezeigt. Sie kann auf der Profildesign-Seite bearbeitet werden.',
    username: 'Benutzername',
    uploading: 'Hochladen',
    mobileBg: 'Handyhintergrund',
    videoBg: 'Videohintergrund',
    minute_one: '{{count}} Minute',
    minute_other: '{{count}} Minuten',
    addData: 'Daten hinzufügen',
    notEnoughLicences: 'Du hast nicht genügend Lizenzen',
    startNow: 'Jetzt starten',
    resetToDefault: 'Auf Standard zurücksetzen',
    editColumns: 'Spalten bearbeiten',
    role: 'Rolle',
    accountDetails: 'Account-Details',
    title: 'Titel',
    Employee: 'Mitarbeiter:in',
    you: 'Du',
    Loading: 'Laden',
    LoadingLong: 'Das kann einige Minuten dauern',
    deleting: 'Löschen',
    saving: 'Speichern',
    Dismiss: 'Schließen',
    tryForFree: 'Kostenlos testen',
    edit: 'Details bearbeiten',
    myLinks: 'Meine Links',
    addLink: 'Link hinzufügen',
    editLinks: 'Links bearbeiten',
    addAddress: 'Adresse hinzufügen',
    editAddress: 'Adresse bearbeiten',
    assign: 'zuordnen',
    unitAssign: 'Unit zuweisen',
    unassign: 'aus aktuellen Units entfernen',
    chooseLink: 'Wähle einen Linktyp',
    useTemplate: 'Vorlage verwenden',
    createNewTemplate: 'Neue Vorlage erstellen',
    selectTemplate: 'Vorlage auswählen',
    createOwnLink: 'Eigenen Link erstellen',
    shareVia: 'Per {{app}} teilen',
    copyText: 'Text kopieren',
    pasteToWebsite: 'Füge nun den Text in Deinen Post ein',
    openLink: 'Seite öffnen',
    chooseLinks: 'Wähle Links aus',
    addFile: 'Datei hinzufügen',
    editFile: 'Datei bearbeiten',
    files: 'Dateien',
    links: 'Links',
    contactsForm: 'Kontaktformular',
    additionalCover: 'Zusätzliche Titelbilder',
    showContactsForm: 'Formular anzeigen',
    showContactsFormAsPopup: 'Als Popup anzeigen',
    website: 'Webseite',
    linkedInLink: 'LinkedIn-URL',
    numberOfEmployees: 'Anzahl der Mitarbeiter:innen',
    addProfile: 'Nutzer Hinzufügen',
    myFiles: 'Meine Dateien',
    showProfile: 'Profilvorschau ansehen',
    myProfile: 'Mein Profil',
    coverPicture: 'Titelbild',
    editCoverPicture: 'Titelbild bearbeiten',
    editLogo: 'Logo bearbeiten',
    editHeaderLogo: 'Logo',
    editLogoTooltip:
      'Hier kannst Du jedem:er einzelnen Mitarbeiter:in oder einer Gruppe ein spezifisches Firmenlogo hochladen z.B. falls es unterschiedliche Marken gibt. Dieses Logo wird jedoch für alle einheitlich überschrieben, falls ein Logo in den globalen Einstellung gesetzt ist.',
    errorUploadingImage: 'Fehler beim Hochladen',
    uploadingImage: 'Bild hochladen',
    updatingImage: 'Bild wird aktualisiert',
    chooseCoverPicture: 'Hintergrundbild auswählen',
    chooseLogoPicture: 'Logo auswählen',
    nameLink: 'Benenne Deinen Link',
    enterUsername: 'Gib Deinen Benutzernamen ein',
    enterPhone: 'Ländervorwahl & Deine Nummer',
    save: 'Speichern',
    enrich: 'Anreichern',
    cancel: 'Abbrechen',
    record: 'Aufnahme',
    delete: 'Löschen',
    enterLink: 'Gib Deinen Link ein',
    createLink: 'Link erstellen',
    editLink: 'Bearbeite den Link',
    redirectMessage:
      'Leite Deine Visitenkarte direkt auf diesen Link weiter. Zurzeit ist Deine digitale Visitenkarte erreichbar.',
    redirectOffMessage:
      'Zeige wieder Deine digitale Visitenkarte an, wenn Du Dein Profil teilst. Zurzeit wird automatisch auf diesen Link weitergeleitet.',
    hideMessageLink: 'Blende diesen Link auf Deinem Profil aus. Er wird zurzeit angezeigt.',
    showMessageLink:
      'Blende diesen Link auf Deinem Profil wieder ein. Er wird zurzeit nicht angezeigt.',
    hideMessageFile: 'Blende diese Datei auf Deinem Profil aus. Sie wird zurzeit angezeigt.',
    showMessageFile:
      'Blende diese Datei auf Deinem Profil wieder ein. Sie wird zurzeit nicht angezeigt.',
    nameFile: 'Benenne Deine Datei',
    upload: 'Hochladen',
    uploadNew: 'Neu hochladen',
    browseFiles: 'Dateien durchsuchen',
    deleteLink: 'Link löschen',
    saveContact: 'Kontakt speichern',
    editProfile: 'Profil bearbeiten',
    editProfiles: 'Profile bearbeiten',
    myContactDetails: 'Meine Kontaktdaten',
    contactDetails: 'Kontaktdaten',
    sendContactProfile: 'Übermittle mir Deinen Kontakt und\nerhalte meinen per Mail:',
    submitYourContact: 'Sende Deine Kontaktdaten und\nerhalte meine per E-Mail:',
    account: 'Konto',
    connectAccount: 'Konto mit Tap oder Karte verbinden',
    howToTap: 'Wie halte ich meinen Lemontaps NFC-Produkt gegen ein Handy?',
    tapIphone: 'So tappst Du auf ein iPhone',
    tapAndroid: 'So tappst Du auf ein Android',
    myContacts: 'Meine Kontakte',
    addContact: 'Kontakt hinzufügen',
    addContactShort: 'Kontakt',
    howtotap: 'Wie benutze ich mein Lemontaps NFC-Produkt?',
    showNow: 'Jetzt Lemontaps Produkte einkaufen',
    changePassword: 'Passwort ändern',
    logout: 'Abmelden',
    nfcInfo1: '1. NFC muss aktiviert sein',
    nfcInfo2: 'iPhone XR und neuer: Es ist bereits automatisch aktiviert',
    nfcInfo3:
      'iPhone 7 - Iphone X: iOS14 muss installiert sein. Gehe zu "Einstellungen" - "Kontrollzentrum" und füge "NFC" hinzu.',
    nfcInfo4:
      'Wische nun über das Kontrollzentrum und drücke das NFC-Zeichen, um das Profil auf der Karte aufzurufen:',
    nfcInfo5: 'Telefon hat kein NFC?',
    nfcInfo6: '2. Tap',
    nfcInfo7: 'Halte Deine Karte gegen den oberen Teil des iPhones der Empfänger:in',
    nfcInfo8: 'Aktiviere "NFC" einmal im oberen Menü',
    nfcInfo9:
      'Wenn NFC noch nicht im Menü zu sehen ist, musst Du es zuerst in den Einstellungen aktivieren:',
    nfcInfo10: 'Einstellungen - Verbindungen - NFC und Zahlungen',
    nfcInfo11: 'Einstellungen - Geräteverbindungen - NFC',
    nfcInfo12: 'Einstellungen - Verbundene Geräte - Verbindungseinstellungen - NFC',
    nfcInfo13: 'Einstellungen - Mehr - Mobile Daten - NFC',
    nfcInfo14: 'Verknüpfe Dein Lemontaps NFC-Produkt mit Deinem Profil',
    nfcInfo15: 'Den Code findest Du auf der Verpackung von Deinem Produkt.',
    nfcInfo16:
      'Du kannst später jederzeit ein Lemontaps NFC-Produkt kaufen und mit Deinem Profil im Menü verbinden.',
    nfcInfo17: 'Halte Deine Karte gegen den oberen Teil des Android der Empfänger:in',
    gotIt: 'Verstanden!',
    accountRole: 'Berechtigung',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'Email 1',
    workEmail: 'Email 2',
    workEmail2: 'Email 3',
    businessCardLink: 'Visitenkartenlink',
    birthday: 'Geburtstag',
    position: 'Position',
    company: 'Unternehmen',
    costCenter: 'Kostenstelle',
    internalNotes: 'Interne Notizen',
    division: 'Abteilung',
    businessCardUrl: 'Visitenkarte',
    businessCardUrls: 'Visitenkarten',
    profileImageUrl: 'Profilbild',
    mobilePhone: { text: 'Telefon Mobil', label: 'Mobil' },
    workPhone: { text: 'Telefon Arbeit', label: 'Arbeit' },
    homePhone: { text: 'Telefon Privat', label: 'Privat' },
    hotlinePhone: { text: 'Telefon Hotline', label: 'Hotline' },
    assistantPhone: { text: 'Telefon Assistenz', label: 'Assistenz' },
    phone: 'Phone',
    assistantEmail: { text: 'Email Assistenz', label: 'Assistenz' },
    assistantName: { text: 'Name Assistenz', label: 'Assistenz' },
    assistantGeneric: { text: 'Sonstiges Assistenz', label: 'Assistenz' },
    workFax: { text: 'Fax', label: 'Fax' },
    authEmail: 'Account-Email',
    createdOn: 'Erstellt am',
    editedAt: 'Bearbeitet am',
    email1: 'Email 1',
    email2: 'Email 2',
    email3: 'Email 3',
    workUrl: 'Homepage URL',
    bioText: 'Bio (Freitext)',
    update: 'Aktualisieren',
    allProfilesMD: 'Alle Nutzerprofile',
    rowsPerPage: 'Zeilen pro Seite:',
    of: 'von',
    searchMD: 'Suche nach...',
    emptySearchMD: {
      tooltip: 'Gib "#leer#" ein, um nach leeren Werten zu filtern, oder klicke einfach hier',
      tag: '#leer#',
    },
    editMD: 'Bearbeiten',
    editSelected: 'Profile bearbeiten',
    editSelected_one: 'Profil bearbeiten',
    editSelected_other: '{{count}} Profile bearbeiten',
    deleteSelected_one: 'Profil löschen',
    deleteSelected: 'Ausgewählte löschen',
    deleteSelected_other: '{{count}} Profile löschen',
    deleteBulkMessageConfirmation_one:
      'Möchtest Du dieses Profil wirklich löschen? Keine Daten gehen verloren, außer der Profilinformationen (Gesammelte Kontakte und Statistiken bleiben erhalten).',
    deleteBulkMessageConfirmation_other:
      'Möchtest Du diese {{count}} Profile wirklich löschen? Keine Daten gehen verloren, außer der Profilinformationen (Gesammelte Kontakte und Statistiken bleiben erhalten).',
    yes: 'Ja',
    no: 'Nein',
    asc: 'Aufsteigend',
    desc: 'Absteigend',
    sortOrder: 'Sortierreihenfolge',
    sortBy: 'Sortieren nach',
    shareProfile: {
      text: 'Teilen',
      title: 'Profil teilen via...',
      wallet: {
        googleWallet: 'QR-Code und Google Wallet',
        appleWallet: 'QR-Code und Apple Wallet',
        online: 'Online',
        offline: 'Offline',
        title: 'QR-Code',
        titleTooltip:
          'Online: Öffnet direkt Dein digitales Lemontaps-Profil im Browser.\nOffline: Der Offline QR-Code funktioniert ohne Internet. Durch Scannen wird der Kontakt direkt geöffnet, nicht Dein online Lemontaps-Profil. Im gespeicherten Kontakt ist trotzdem der Link zu Deinem Lemontaps-Profil enthalten, damit Dein Gegenüber es jederzeit öffnen kann.',
        buttonsTooltip:
          'Füge Lemontaps zu Deiner {{company}} Wallet hinzu und teile Deinen Kontakt über den QR-Code in der Wallet.',
        dialog: {
          title: 'Was ist ein Online- und Offline-QR-Code?',
          description:
            'Online: Öffnet direkt Dein digitales Lemontaps-Profil im Browser.\nOffline: Der Offline QR-Code funktioniert ohne Internet. Durch Scannen wird der Kontakt direkt geöffnet, nicht Dein online Lemontaps-Profil. Im gespeicherten Kontakt ist trotzdem der Link zu Deinem Lemontaps-Profil enthalten, damit Dein Gegenüber es jederzeit öffnen kann.',
        },
      },
      profileLink: {
        title: 'Profil-Link',
        label: 'Link kopieren',
        copied: 'Kopiert',
        shareVia: 'Teilen via',
        shareViaMedia: 'Über soziale Medien teilen',
        tip: '💡 Tipp: Füge den Link in Deine E-Mail-Signatur ein',
      },
      nfcCards: {
        title: 'NFC-Karten',
        description:
          'Du kannst physische Karten nutzen, um Dein Profil per Tap oder QR-Code zu teilen.',
      },
      qrBackgrounds: {
        title: 'QR-Hintergründe',
        description: 'Gestalte Videocall-Hintergründe und Smartphone-Sperrbildschirme.',
      },
      shareMenu: {
        qrMobile: 'QR-Sperrbildschirm erstellen',
        qrDesktop: 'QR-Hintergrund für Videocall erstellen',
        nfcCard: 'NFC-Karte',
      },
    },
    dateDesc: 'Absteigend',
    dateAsc: 'Aufsteigend',
    textDesc: 'Sortiere Z bis A',
    textAsc: 'Sortiere A bis Z',
    reset: 'Zurücksetzen',
    exports: 'Exporte',
    numberDesc: 'Absteigend',
    numberAsc: 'Aufsteigend',
    enrichment: 'Kontakt-Enrichment',
    voiceNotes: 'Sprachnotizen',
    badgeScanner: 'Messe-Badge-Scanner',
    leads: {
      import: 'Importieren',
      importError: 'Fehler beim Importieren',
      importErrorNoOwner: 'Es muss mindestens ein Owner ausgewählt sein',
      importSuccess: 'Import erfolgreich',
      enrichmentInProgress: 'Anreicherung läuft...',
      scrapingInProgress: 'LinkedIn-Scraping läuft...',
      enrichmentInProgressContent:
        'Kann bis zu 1 Minute dauern. Du kannst neue Kontakte bearbeiten und scannen während die Anreicherung im Hintergrund läuft.',
      scrapingInProgressContent:
        'Kann bis zu 1 Minute dauern. Du kannst neue Kontakte bearbeiten und scannen während das Scraping im Hintergrund läuft.',
      saveAndEnrich: 'Speichern und Anreichern ✨',
      enrichWithAI: 'Mit KI anreichern ✨',
      saveAndEnrichWithAI: 'Speichern und mit KI anreichern ✨',
      enrichConfirmationTitle: 'Mit KI anreichern',
      enrichConfirmationBody: 'Bestätige, dass Du mit KI anreichern möchtest.',
      enrichStartedSuccessful: 'KI-Anreicherung gestartet',
      enrichMaxLeadEror: 'Maximal 25 Kontakte können gleichzeitig angereichert werden',
      enrichedSuccessfully: 'KI-Anreicherung erfolgreich',
      enrichError: 'Fehler bei der KI-Anreicherung',
      enrichErrorFillSomeData:
        'Um die KI-Anreicherung zu starten muss mindestens eine dieser Felder-Kombinationen ausgefüllt sein: \n{{fields}}',
      xSelected: '{{count}} Kontakte ausgewählt',
      xAllSelected: 'Alle Kontakte ausgewählt',
      searchPlaceholder: 'Suche nach Name, Mail, etc.',
      addEditNote: 'Notiz hinzufügen/bearbeiten',
      leadNoteAddSuccess: 'Notiz hinzugefügt',
      leadNoteAddError: 'Notiz nicht hinzugefügt',
      noLeadsCollected:
        'Du hast noch keine Kontakte erfasst. Füge jetzt Deinen ersten Kontakt hinzu!',
      createDate: 'Erstellungsdatum',
      noLeadsSearchResult: 'Keine Ergebnisse gefunden',
    },
    enrichedWithAi: 'Angereichert mit Lemontaps AI',
    mdUnits: {
      error: {
        general: 'Fehler beim Löschen von Units',
        'used-for-acc-claiming':
          'Die Unit ist als Target in den Account Claiming Einstellungen konfiguriert.',
        'not-empty': 'Nur leere Units können gelöscht werden',
      },
      noUnitsFound: 'Keine Units gefunden',
      searchPlaceholder: 'Suche nach Unitnamen...',
      noUnitsAreAdded: 'Es wurden noch keine Units hinzugefügt',
      deleteUnitsMsg_one: 'Möchtest Du die ausgewählte Unit wirklich löschen?',
      deleteUnitsMsg_other: 'Möchtest Du die ausgewählten {{count}} Units wirklich löschen?',
      xAllSelected: 'Alle ausgewählt',
      xSelected: '{{count}} ausgewählt',
      members: 'Mitglieder:innen',
      admins: 'Admins',
      viewMembers: 'Mitglieder:innen anzeigen',
      manageMembers: 'Mitglieder:innen verwalten',
      addMembers: 'Mitglieder:innen hinzufügen',
      addMembersExplainer:
        'Um Mitglieder:innen zu Deiner Einheit hinzuzufügen, musst Du die Benutzerprofilseite besuchen, dort die Mitglieder:innen auswählen und sie der ausgewählten Einheit zuweisen.',
      goToUsers: 'Zu den Nutzer:innen',
      addExistingUser: 'Bestehenden Nutzer:innen hinzufügen',
      createNewUser: 'Neuen Nutzer:innen erstellen',
      deleteSuccess: 'Unit gelöscht',
    },
    downloadPNG: 'PNG herunterladen',
    downloadSVG: 'SVG herunterladen',
    mdLeads: {
      owner: 'Owner',
      xUnitsSelected: '{{count}} ausgewählt',
      xAllUnitsSelected: 'Alle ausgewählt',
      successCreate: 'Unit erstellt',
      noUnit: 'Keine Unit',
      edit: 'Bearbeiten',
      unit: 'Unit',
      status: 'Status',
      members: 'Mitglieder:innen',
      membersView: 'Mitglieder:innen anzeigen',
      view: 'Ansicht',
      unitAdmins: 'Unit-Admins',
      noSelectedUnits: 'Es sind noch keine Nutzer:innen in dieser Unit',
      firstCreateUnit: 'Du musst zuerst eine Unit erstellen',
      addEmployeeToUnit: 'Hinzufügen bestehender Mitarbeiter:innen zu einer Unit',
      editUnitHeader:
        'Gehe zur Profilseite, wähle die Benutzer:innen aus, die Du einer Unit zuweisen möchtest, und wähle dann die Option "Unit zuweisen“.',
      errorReadUnits: 'Fehler beim Laden von Units',
      noUnitSelected: 'Mindestens eine Unit muss ausgewählt sein',
      noRoleSelected: 'Mindestens eine Rolle muss ausgewählt sein',
      unassignFromUnit: 'Aus Unit entfernen',
      confirmRemoveUnit_one: 'Möchtest Du das ausgewählte Profil wirklich aus der Unit entfernen?',
      confirmRemoveUnit_other:
        'Möchtest Du die ausgewählten Profile wirklich aus der Unit entfernen?',
      removeFromUnit: 'Aus Unit entfernen',
      removingFromUnit: 'Aus Unit entfernen',
      successRemovingFromUnit: 'Aus Unit entfernt',
      toProfiles: 'zur Profilseite',
      addUsersToUnit: 'Füge der Unit vorhandene Benutzer hinzu',
      loadingUnits: 'Lade Units',
      AssignUnitError: 'Fehler beim Zuweisen von Units',
      assignUnitWarning:
        'Die ausgewählten Accounts werden den Units zugeordnet, die hier ausgewählt werden, und aus den Units entfernt, die hier nicht ausgewählt werden.',
      deleteUnits_one: 'Möchtest Du die Unit wirklich löschen?',
      deleteUnits_other: 'Möchtest Du die Units wirklich löschen?',
      loadingUnitsError: 'Fehler beim Laden der Units',
      unitNameExists: 'Eine Unit mit diesem Namen existiert bereits',
      contact: 'Kontakt',
      notes: 'Notiz',
      multiNotes: 'Evtl. untersch. Notizen',
      date: 'Datum',
      vcf: '.vcf',
      deletedAccount: 'Account existiert nicht mehr',
      accountDeleted: 'Gelöschter Account',
      connectedAccounts: 'Owner',
      connectTo: 'Owner',
      downloadCSV: 'csv Herunterladen',
      editFormTitle: 'Kontakt bearbeiten',
      editSuccess: 'Kontakt wurde aktualisiert',
      editError: 'Kontakt nicht aktualisiert',
      addFormTitle: 'Kontakt hinzufügen',
      addSuccecss: 'Kontakt erfolgreich hinzugefügt',
      addError: 'Kontakt konnte nicht hinzugefügt werden',
      uploadPhoto: 'Foto hochladen',
      download: 'Herunterladen',
      metOn: 'Erstellt am',
      metAt: 'Erstellt am',
      fetchError: 'Bitte aktualisiere die Seite und probiere es noch einmal',
      deleteContact: 'Kontakt löschen',
      deleteSuccess: 'Kontakt wurde gelöscht',
      deleteError: 'Kontakt nicht gelöscht',
      tooltipMultiAccountsConnected:
        'Dieser Kontakt wurde von mehreren Mitarbeiter:innen aufgenommen. Im Dropdown-Menü unten kannst Du zwischen den Kontaktinformationen wechseln, die die verschiedenen Mitarbeiter:innen eingetragen haben.',
      export: 'Export',
      errorSaving: 'Fehler beim Speichern, mindestens ein Feld ist erforderlich',
      errorSavingValidation:
        'Fehler beim Speichern, mindestens ein Feld ist nicht korrekt formatiert',
      crmExport: {
        confirmDialog: {
          title: 'Exportieren',
          text_one: 'Möchtest Du einen Kontakt zu {{name}} exportieren?',
          text_other: 'Möchtest Du {{count}} Kontakte zu {{name}} exportieren?',
          textAll: 'Möchtest Du alle Kontakte zu {{name}} exportieren?',
          campaignAccordionTitle: 'Einer Kampagne zuordnen',
          campaignTitle: 'Möchtest Du die ausgewählten Kontakte einer Kampagne zuordnen?',
          selectCampaign: 'Wähle eine Kampagne aus',
          campaignHelper:
            'Hinweis: Du musst keine Kampagne auswählen und kannst einfach mit dem Export fortfahren',
          campaignAutoAssignInfo: 'Ein Admin hat diese Kampagnenzuordnung konfiguriert.',
          configurationsAccordionTitle: 'Pflichtfelder aus CRM befüllen',
          configurationsInfo:
            'Wenn Du in Deinem CRM benutzerdefinierte Pflichtfelder konfiguriert hast, musst Du hier einen Wert angeben, andernfalls schlägt der Export fehl. Wenn du ein Feld hier nicht siehst, klicke auf den Button unten, um die Felder zu aktualisieren.\n\nFalls Du Administrator:in bist, kannst Du auch globale Standardwerte auf der CRM-Einstellungsseite konfigurieren.',
          noConfigurations: 'Keine Pflichtfelder verfügbar.',
          refreshConfigurations: 'Benutzerdefinierte Felder aktualisieren',
          leadObjectTypeWarning:
            'Bei mindestens einem Kontakt in der Auswahl ist nicht angegeben, ob als Kontakt oder Lead ins CRM exportiert werden soll. Treffe hier eine Auswahl für alle diese Kontakte, oder gehe zurück und treffe eine individuelle Auswahl für die einzelnen Kontakte.',
        },
        startSuccess: 'Export gestartet',
        startFail: 'Fehler beim Starten des Kontaktexports',
        emptySelection: 'Wähle die zu exportierenden Kontakte aus',
      },
      metBy: 'Owner',
      showDeleted: 'Gelöschte anzeigen',
      deleteLeadsMsg_one: 'Bist Du sicher, dass Du den ausgewählten Kontakt löschen möchtest?',
      deleteLeadsMsg_other:
        'Bist Du sicher, dass Du die ausgewählten {{count}} Kontakte löschen möchtest?',
      crmExportStatus: 'Exportstatus',
    },
    owner: 'Owner',
    deletedAt: 'Gelöscht am',
    translations: {
      title: 'Übersetzung',
      description:
        'Übersetze die digitalen Visitenkartenprofile Deines Teams. Du kannst den Standardtext, Kontaktinformationen, Linknamen, Links und Dateinamen übersetzen. Du kannst auch festlegen, dass Informationen in bestimmten Sprachen nicht angezeigt werden sollen.',
      language: {
        updateSuccess: 'Sprachen erfolgreich aktualisiert',
        updateError: 'Fehler beim Aktualisieren der Sprache!',
        title: 'Unterstützte Sprachen',
        description:
          'Die Sprache, in der ein Profil angezeigt wird, hängt von den Geräteeinstellungen des:der Empfänger:in ab. Wenn die Sprache des Geräts nicht unterstützt wird, wird das Profil in der Fallback-Sprache angezeigt. Stelle die Eingabesprache auf die Sprache ein, die Du zum Ausfüllen der Profilattribute im Admin-Dashboard nutzst.',
        types: {
          input: 'Eingabe-Sprache',
          fallback: 'Fallback-Sprache',
        },
        button: 'Sprache hinzufügen',
        addModal: {
          title: 'Neue Sprache hinzufügen',
          languageLabel: 'Sprache',
          typeLabel: 'Typ (optional)',
        },
        notEditable:
          'Du kannst die Eingabe- und Fallback-Sprachen hier nicht entfernen. Wähle stattdessen die neue Sprache aus, die du als Eingabe- oder Fallback-Sprache markieren möchtest.',
        editModal: {
          title: 'Sprache bearbeiten',
          languageLabel: 'Sprache auswählen',
          typeLabel: 'Typ (optional)',
        },
        deleteModal: {
          errorMainLangDelete:
            'Du kannst die Eingabe- und Fallback-Sprachen nicht löschen. Markiere zuerst eine andere Sprache als Eingabe- oder Fallback-Sprache.',
          title: 'Du möchtest diese Sprache nicht mehr unterstützen?',
          description:
            'Diese Sprache wird in den Profilen Ihrer Mitarbeiter:innen nicht mehr unterstützt. Profilbesucher, deren Geräte auf diese Sprache konfiguriert sind, sehen das Profil stattdessen in der Fallback-Sprache.',
        },
      },
      packs: {
        title: 'Sprachpakete',
        description:
          'Lade die Sprachpakete herunter und füge Übersetzungen hinzu oder ändere sie. Wenn Du ein Feld in der Übersetzung leer lässt, wird der Wert der Eingabesprache für dieses Feld angezeigt. Wenn Du ein Feld löschen möchtest, schreibe "{{token}}" als Übersetzung. Lade im Anschluss eine Zip-Datei hoch, die nur csv-Dateien mit denselben Namen wie im Download enthält.',
        uploadLabel: 'Zum Hochladen klicken oder per Drag & Drop',
        link: 'Aktuelle Sprachpaket-Konfiguration herunterladen',
        notAllowedTitle: 'Bitte deinen Admin um Erlaubnis',
        notAllowedBody:
          'Dein Admin erlaubt die Bearbeitung von Übersetzungen für Unit-Admins nicht.',
        uploadSuccess: 'Sprachpakete aktualisiert.',
        filename: 'Sprachpaket',
        errors: {
          generic: 'Error',
          fileNotFound: 'Datei nicht gefunden',
          uploadError: 'Upload fehlgeschlagen. Überprüfe die Dateiformate und Inhalte.',
          invalidFilename:
            'Mindestens ein ungültiger Dateiname. Benenne die Dateien genau so, wie im heruntergeladenen Sprachpaket.',
          api: {
            LIMIT_FILE_SIZE: 'Die Datei ist zu groß.',
            [ERROR_KEYS.TRANSLATIONS_UPLOAD_NO_DATA]: 'Datei konnte nicht gelesen werden.',
            [ERROR_KEYS.TRANSLATIONS_UPLOAD_INVALID_FILE_TYPE]: 'Ungültiger Dateityp.',
            [ERROR_KEYS.TRANSLATIONS_UPLOAD_READ_ERROR]:
              'Fehler beim Lesen der Datei. Die hochgeladene zip-Datei könnte beschädigt sein.',
            [ERROR_KEYS.TRANSLATIONS_UPLOAD_INVALID_FILENAMES_OR_NO_PERMISSION]:
              'Es sind nur Dateinamen erlaubt, die auch im heruntergeladenen Sprachpaket enthalten sind. Entweder wurden falsch benannte Dateien hochgeladen, oder Du bist nicht berechtigt, einige der Kategorien zu bearbeiten.',
            [ERROR_KEYS.TRANSLATIONS_UPLOAD_CSV_PARSE_ERROR]:
              '"{{filename}}": Fehler beim Lesen der Daten. Achte darauf, dass die Spalten und Zeilen korrekt formatiert sind.',
            [ERROR_KEYS.TRANSLATIONS_UPLOAD_INVALID_KEYS]:
              '"{{filename}}": Einige oder alle Werte in der Spalte "key" sind ungültig.',
          },
        },
      },
    },
    errorDeletingUsers_one: 'Fehler beim Versuch, Profil zu löschen',
    errorDeletingUsers_other: 'Fehler beim Versuch, Profile zu löschen',
    errorFetchingProfiles: 'Fehler beim Abrufen von Profilen',
    successfullyUsersDeleted_one: 'Profil erfolgreich gelöscht',
    successfullyUsersDeleted_other: 'Profile erfolgreich gelöscht',
    deleteAccounts_one: 'Profil löschen',
    deleteAccounts_other: 'Profile löschen',
    onlineQrCodes: 'Online QR-Codes',
    offlineQrCodes: 'Offline QR-Codes',
    employeesCsv: 'CSV',
    employeesXlsx: 'Excel',
    profileLinks: 'Profil-Links',
    onlineAppleWallets: 'Online Apple Wallet-Pässe',
    onlineGoogleWallets: 'Online Google Wallet-Pässe',
    offlineAppleWallets: 'Offline Apple Wallet-Pässe',
    offlineGoogleWallets: 'Offline Google Wallet-Pässe',
    actionTooltips: {
      onlineQrCodesSVG:
        'Du exportierst einen Lemontaps QR-Code (enthält den Link zum Lemontaps-Profil) als Bild für jedes der ausgewählten Profile.',
      onlineQrCodesPNG:
        'Du exportierst einen Lemontaps QR-Code (enthält den Link zum Lemontaps-Profil) als Bild für jedes der ausgewählten Profile.',
      offlineQrCodesSVG:
        'Du exportierst einen Lemontaps QR-Code (enthält die Kontaktinformationen als vcard) als Bild für jedes der ausgewählten Profile.',
      offlineQrCodesPNG:
        'Du exportierst einen Lemontaps QR-Code (enthält die Kontaktinformationen als vcard) als Bild für jedes der ausgewählten Profile.',
      csv: 'Du exportierst alle Profilinformationen in der Tabelle im CSV-Format.',
      xlsx: 'Du exportierst alle Profilinformationen in der Tabelle im Excel-Format.',
      links: 'Du exportierst eine CSV-Datei mit den Profillinks.',
      mobileBg: 'Du exportierst einen QR-Code Hintergrund für den Handy Sperrbildschirm.',
      videoBg: 'Du exportierst einen QR-Code-Hintergrund für das Videokonferenz-Tool.',
      onlineAppleWallet:
        'Du wirst eine ZIP-Datei exportieren, die alle Apple Wallet-Pässe der ausgewählten Benutzer enthält. Die Pässe enthalten einen QR-Code, der auf das jeweilige digitale Profil weiterleitet.',
      offlineAppleWallet:
        'Du wirst eine ZIP-Datei exportieren, die alle Apple Wallet-Pässe der ausgewählten Benutzer enthält. Die Pässe enthalten einen QR-Code, der die vCard des jeweiligen Benutzers enthält.',
      onlineGoogleWallet:
        'Du wirst eine CSV-Datei exportieren, die alle URLs zu Google Wallet-Pässen der ausgewählten Benutzer enthält. Die Pässe enthalten einen QR-Code, der auf das jeweilige digitale Profil weiterleitet.',
      offlineGoogleWallet:
        'Du wirst eine CSV-Datei exportieren, die alle URLs zu Google Wallet-Pässen der ausgewählten Benutzer enthält. Die Pässe enthalten einen QR-Code, der die vCard des jeweiligen Benutzers enthält.',
    },
    gettingCommonLinks: 'Überprüfung von gemeinsamen Links...',
    commonLinksFound: 'Gemeinsame Links gefunden!',
    commonLinksNotFound: 'Keine gemeinsamen Links gefunden!',
    xProfilesSelected: '{{count}} ausgewählt',
    xProfilesSelectedLong: '{{count}} Profile ausgewählt',
    xAllProfilesSelected: 'Alle ausgewählt',
    bulkActions: {
      chooseActionType: 'Wähle eine Aktion aus',
      chooseField: 'Wähle ein Feld aus',
      value: 'Wert',
      distribute: {
        title: 'Verteilen per E-Mail',
        wallet: {
          tooltip:
            'Verteile Google und Apple Wallet Visitenkarten per E-Mail an die ausgewählten Profile.',
          successMsg:
            'Die Wallet E-Mails wurden erfolgreich an die ausgewählten Profile versendet.',
          errorMsg:
            'Beim Senden ist ein Fehler aufgetreten. Bitte lade die Seite neu und versuche es erneut.',
        },
      },
      invite: {
        title: 'Einladungen versenden',
        confirm: 'Möchst Du an die ausgewählten Profile Einladungen per E-Mail versenden?',
      },
    },
    inviteSelected: 'Einladungen versenden',
    inviteSelected_one: 'Einladung versenden',
    inviteSelected_other: '{{count}} Einladungen versenden',
    bulkUpdated: 'Profile wurden aktualisiert',
    bulkFailed: 'Fehler beim Aktualisieren der Profile',
    bulkInvitedSync: 'Die Zugangsmails wurden versendet',
    bulkInvitedAsync:
      'Du erhälst eine E-Mail, sobald die Profile eingeladen wurden. Das kann eine Weile dauern.',
    invited: 'Die Zugangsmail wurde versendet',
    passwordMessage: 'Dein Passwort sollte mindestens Folgendes enthalten',
    characters: '8 Zeichen',
    oneNumber: 'Eine Zahl',
    oneSpecialCharacter: 'Ein Sonderzeichen',
    next: 'Weiter',
    welcomeMD: 'Willkommen zur Management Plattform!',
    problemsMD: 'Falls Du Probleme oder sonstige Fragen hast.',
    clickHere: 'Klicke hier!',
    welcomeBackMD: 'Willkommen zurück!',
    forgotMD: 'Zugangsdaten vergessen?',
    resetPasswordMD: 'Passwort zurücksetzen',
    emailAddress: 'Email Adresse',
    password: 'Passwort',
    welcomeMessage: 'Willkommen zu Lemontaps!',
    logIn: 'Einloggen',
    fonts: 'Schriftart',
    selectFont: 'Wähle eine Schriftart',
    passwordForgot: 'Passwort vergessen?',
    choosePersonalLink: 'Wähle Deinen eigenen Benutzernamen für Deinen Link aus',
    yourUsername: 'Dein Nutzername',
    signUpMessage: 'Registriere Dich für Dein Lemontaps Konto innerhalb Sekunden.',
    alreadyRegistered: 'Du hast schon ein Konto?',
    signUp: 'Registrieren',
    confirmPW: 'Passwort wiederholen',
    consentMessage:
      'Mit der Nutzung unseres Dienstes erklärst Du Dich mit den Nutzungsbedingungen und der Datenschutzerklärung einverstanden.',
    firstNameONB: 'Hallo, willkommen an Board! 🎉 Wie ist Dein Vorname?',
    lastNameONB: 'Hallo {{firstName}} 🎉 Wie ist Dein Nachname?',
    addProfileImageONB: 'Füge Dein Profilbild hinzu',
    changeMessage: 'Du kannst dieses jederzeit später ändern.',
    skip: 'Überspringen',
    addHeadlineONB: 'Füge eine Beschreibung hinzu',
    addHeadlineMessage: 'Hier kannst Du Deine Position oder einen Slogan über Dich einfügen',
    headline: 'Beschreibung',
    addPhoneONB: 'Füge Deine Geschäftsnummer hinzu',
    addPhoneMessage:
      'Diese Telefonnummer kann mit Deinen neu gewonnen Kontakten geteilt werden. Du kannst diese jederzeit später ändern oder entfernen.',
    linkLemontap: 'Verbinde Dein Lemontap mit Deinem Konto',
    activationCodeMessage: 'Du kannst den Aktivierungscode auf der Verpackung finden.',
    enterCode: 'Aktivierungscode eingeben',
    connect: 'Vernetzen',
    continueWithoutLemontap: 'Ohne das Verbinden eines Lemontaps NFC-Produkts fortführen',
    learnHowONB:
      'Finde heraus, wie man sein Lemontaps NFC-Produkt gegen unterschiedliche Smartphones hält',
    connectSuccessfully:
      'Du hast erfolgreich Dein Lemontaps NFC-Produkt mit Deinem Konto verknüpft! Du kannst nun mit der Einrichtung Deines Profils beginnen.',
    validateAccount: 'Bestätige Dein Konto',
    sentEmail:
      'Wir haben Dir eine E-Mail mit einem Link zur Bestätigung Deines Kontos gesendet. Bitte überprüfe Deinen Posteingang oder Deinen Spam-Ordner.',
    failreceiveEmail: 'Ich habe die E-Mail nicht erhalten',
    findInstructions: 'Klicke hier, um immer die Anweisungen für das Tippen zu finden.',
    contactInfo: 'Kontaktinformationen',
    contactInfoBulkHint:
      'Die hierdurch gesetzten Informationen überschreiben das entsprechende Feld der ausgwählten Profile.',
    contactInfoBulkHintDeleted:
      'Das hier selektierte Feld wird bei allen ausgewählten Profilen geleert.',
    accountInfo: 'Accountinformationen',
    german: 'Deutsch',
    english: 'Englisch',
    language: 'Sprache',
    createProfile: 'Neues Profil erstellen',
    shareNFC: 'Auf Smartphones ohne NFC teilen',
    scanQRC: 'Lass sie Deinen QR-Code scannen, den sie in Deinem Profil finden',
    loginEmail: 'Mit E-Mail anmelden',
    pleaseLogin: 'Bitte logge Dich mit der E-Mail-Adresse und dem Passwort aus der Verpackung ein.',
    pageNotFound: 'Hoppla! Seite nicht gefunden 🙈',
    weareSorry:
      'Wir entschuldigen uns für die Unannehmlichkeiten . Offenbar versuchst Du, auf eine Seite zuzugreifen, die entweder gelöscht wurde oder nie existiert hat.',
    backHome: 'Zurück zur Startseite',
    enterLinkerror: 'Bitte gib einen Link ein',
    nameLinkerror: 'Bitte benenne Deinen Link-Button',
    enterMessage: 'Bitte gib {{subject}} ein',
    phoneSubject: 'eine Telefonnummer',
    usernameSubject: 'einen Nutzernamen',
    linkSubject: 'einen Link',
    one: ' ein',
    nameFileerror: 'Bitte benenne Deine Datei',
    correctLink: 'Bitte gib einen korrekten Link an',
    serverError: 'Server Problem.',
    usernameCharcters: 'Der Benutzername muss mindestens 3 Zeichen enthalten',
    matchingPasswords: 'Die Passwörter sind noch nicht identisch.',
    connectMD: 'Bitte gib den Aktivierungscode ein, um dem Profil eine Karte zu zuweisen.',
    errorMDMail: 'Bitte gib eine Email-Adresse ein',
    errorMDFullName: 'Die Informationen zu Vor- und Nachname fehlen',
    changesSaved: 'Änderungen gespeichert',
    codeRead: {
      missed: 'QR-Code ist inkorrekt!',
      title: 'Halte den QR-Code der Karte, die Du verbinden möchtest, in die Kamera',
      loadingMD: 'Code validieren...',
      successMD: 'Der Code wurde validiert!',
      errorMD:
        'Der QR-Code ist entweder belegt oder nicht korrekt. Bitte kontaktiere den Kundenservice, falls die Karte nicht belegt ist, aber nicht verknüpft wird.',
      btnText: 'Neue Karte verknüpfen',
      btnSuccessText: '1 Karte wird verknüpft',
      connectHeadlineMD: 'Optional: Eine neue Karte mit dem Profil verknüpfen',
      connectMessageMD:
        'Einfach den QR-Code auf der Karte in die Kamera halten und der Code wird automatisch mit dem Profil verknüpft.',
      enterCodeText: 'oder manuell eingeben',
      switchCamera: 'Kamera wechseln',
      problems: 'Probleme? Scanne den QR-Code mit Deinem Smartphone.',
      startNow: 'Jetzt starten',
      uploadImage: 'Bild von QR-Code hochladen',
    },
    verified: 'verifiziert',
    notVerified: 'nicht verifiziert',
    imageUpdatedMD: 'Das Profilbild wurde aktualisiert!',
    createdSuccessMD: 'Das Profil wurde erfolgreich erstellt!',
    status: 'Status',
    statusActive: 'Aktiv',
    statusInvited: 'Einladung versendet',
    statusUninvited: 'Nicht eingeladen',
    sendInvite: 'Einladung senden',
    sendInviteTooltip:
      'Möchtest Du einen Zugangslink automatisch nach der Erstellung des Profils an die registrierte Email mit senden? Du kannst dies auch später manuell machen.',
    resendInvite: 'Einladung erneut senden',
    invitationMD: `Möchtest Du einen Zugangslink automatisch nach der Erstellung des Profils an die registrierte Email mit senden?
                       Du kannst dies auch später manuell machen.`,
    cropImage: 'Ziehe ein Rechteck um die gewünschte Stelle',
    requestDelete: 'Bist Du Dir sicher?',
    deleteMessageLink: 'Dein Link wird gelöscht.',
    deleteMessageFile: 'Deine Datei wird gelöscht.',
    deleteMessageAddress: 'Diese Adresse wird gelöscht.',
    genericDelete: 'Diese Aktion ist irreversibel. Möchtest Du fortfahren?',
    deleteFile: 'Datei löschen',
    deleteIt: 'Ja, löschen.',
    DBScanQR:
      'Halte die Karte in der Hand und scanne den QR-Code auf der Karte mit Deinem Handy ein',
    DBOpenlink: 'Öffne den gescannten Link und gehe zur URL-Leiste',
    DBUseCharac: 'Verwende die Zeichen nach dem Schrägstrich "/" der URL lemontaps.com/',
    DBUseCharac2: 'als Aktivierungscode und gib  diesen Code hier unten ein',
    YourPlan: 'Dein Plan',
    FirstYear: 'im ersten Jahr',
    billingHeadingSecond: 'und danach 29,99€/Jahr',
    active: 'Aktiv',
    activeUppercase: 'AKTIV',
    cancelPlan: 'Abo kündigen',
    mailTemplateFirst: 'Bitte sende uns eine E-Mail an ',
    mailTemplateSecond: ' um Dein Abonnement zu kündigen.',
    mailTemplateActive: 'um Dein Abonnement zu aktivieren.',
    billing: 'Abrechnung',
    onBoard: 'Hallo, willkommen an Bord!',
    yourName: 'Wie heißt Du?',
    cardInfo: 'Füge Deiner digitalen Visitenkarte weitere Informationen hinzu.',
    learnHowToTap: 'Erfahre, wie Du Dein Lemontaps NFC-Produkt per NFC',
    lemonTapsPhones: 'gegen ein Handy halten und verwenden kannst',
    subscription: 'Mein Abonnement',
    newCardDetected:
      'Eine neue NFC-Karte wurde erkannt. Möchtest Du sie mit Deinem Profil verknüpfen?',
    connectCard: 'NFC-Karte verknüpfen?',
    addCodeSuccess:
      'Glückwunsch, Du hast Dein Lemontaps NFC-Produkt erfolgreich mit Deinem Profil verknüpft!',
    verification: {
      verifyEmail: 'Verifiziere Deine E-Mail',
      subHeader:
        'Wir haben einen Verifizierungslink an <0>{{email}}</0> geschickt.<1></1> Bitte überprüfe deinen Posteingang oder deinen Spam-Ordner.',
      notReceived: 'Keine E-Mail erhalten?',
      resendEmail: 'Erneut senden',
      sendSuccess: 'Gesendet',
      sendError: 'Fehler',
      changeEmail: 'Andere E-Mail benutzen',
      wrongEmail: 'Falsche E-Mail?',
      logout: 'Logout',
      back: 'Zurück zur Anmeldung',
    },
    emailTooltipCreate:
      'Dies ist die Email-Adresse, welche für die Registrierung und den Login verwendet wird',
    emailTooltipEdit: `Dieses Feld bestimmt nur die Email-Adresse, die auf der Profilseite und im heruntergeladenen Kontakt dargestellt wird.
                        Die Email-Adresse, die für den Login verwendet wird, kannst Du über den Reiter "Account" bearbeiten.`,
    metaTagTitle: 'Deine digitale und nachhaltige Visitenkarte',
    metaTagDescription:
      'Verwalte und teile deine Kontaktinformationen, Links und Dokumente effizient und ohne Papierverschwendung! Die Nr.1 in Deutschland und das Original für digitale Visitenkarten!',
    metaTagProfileDescription: 'Vernetzen wir uns und schaue Dir mein Profil an!',
    register: 'Registrieren',
    newToLt: 'Falls Du neu bei Lemontaps bist',
    login: 'Einloggen',
    fileUploaded: 'Datei erfolgreich hochgeladen',
    // success messages from backend
    'Login credentials validated successfully': 'Login Daten erfolgreich validiert',
    'Activation credentials validated successfully': 'Aktivierungsdaten erfolgreich validiert',
    'Password reset mail sent successfully': 'Passwort Reset Email erfolgreich versendet',
    'Password Updated Successfully': 'Passwort erfolgreich aktualisiert',
    'Links saved successfully': 'Links erfolgreich gespeichert',
    'Link deleted successfully': 'Link erfolgreich gelöscht',
    'User details updated successfully': 'Account Details erfolgreich aktualisiert',
    'File saved successfully!': 'Datei erfolgreich gespeichert',
    'File deleted successfully!': 'Datei erfolgreich gelöscht',
    'Username is available': 'Username ist verfügbar',
    'Account saved successfully': 'Account erfolgreich gespeichert',
    'Validation mail resent successfully': 'Validiertungsemail erfolgreich versendet',
    'Account details saved successfully': 'Account Details erfolgreich gespeichert',
    'The code is linked successfully.': 'Code erfolgreich verlinkt',
    'The given value is code': 'Valide Nummer',
    'Account validated successfully.': 'Account erfolgreich validiert',
    'Account Validation Mail sent successfully': 'Accountvalidierungsemail erfolgreich versendet',
    'Contact mail sent successfully': 'Kontaktemail erfolgreich versendet',
    // error messages from backend
    'User not found': 'Account nicht gefunden',
    'Email address is not registered.': 'Diese Email ist nicht registriert',
    'Failed to save the links': 'Links nicht gespeichert',
    'Failed to delete the links': 'Links nicht gelöscht',
    'Failed to save the user details': 'Accountdetails nicht gespeichert',
    'Failed to save the file': 'Datei nicht gespeichert',
    'Failed to delete the user links': 'Accountlinks nicht gelöscht',
    'Email address is already registered.': 'Emailaddresse bereits registriert',
    'Failed to update the password.': 'Passwort nicht aktualisiert',
    'Insufficient Permission': 'Berechtigungen nicht ausreichend',
    'Username is already taken!': 'Username nicht verfügbar',
    'Account not saved': 'Account nicht gespeichert',
    'Account does not exist!': 'Account existiert nicht',
    'The code is incorrect. Try again or contact us.':
      'Der Code ist falsch. Erneut versuchen oder Lemontaps kontaktieren',
    'This code is already used.': 'Code wird bereits genutzt',
    'The given code does not exist.': 'Code existiert nicht',
    'The given username or code does not exist.': 'Code oder Username existiert nicht',
    'The given code is not connected to any account.': 'Code ist mit keinem Account verknüpft',
    'Invalid token': 'Token nicht valide',
    addContactLead: 'Neuen Kontakt hinzufügen',
    leadType: 'Lead Typ',
    exportToCRM: 'Export & Import ins CRM',
    importToCRM: 'Datei ins CRM importieren',
    step1: 'Schritt 1',
    step2: 'Schritt 2',
    downloadFile: 'Datei herunterladen',
    chooseFileFormat: 'Wähle bitte das Format für den Export aus.',
    downloadCSV: 'CSV herunterladen',
    downloadXLSX: 'XLS herunterladen',
    importInstructions: 'Es ist einfach - wir haben Dir Anleitungen für CRMs vorbereitet',
    learnMore: 'Mehr erfahren',
    howToImport: 'Wie importiert man die Datei ins CRM',
    qrCodeBG: 'QR-Code Hintergrund',
    qrWallpaper: 'QR-Hintergrund',
    videocallBG: 'Videocall Hintergrund',
    videocallTxt:
      'Gib auch bei Online Events oder Meetings Deinen Gesprächspartner:innen die Möglichkeit Dein digitales Profil einzuscannen. Die empfohlene Mindestgrösse ist 1500x1000.',
    bgImageTitles: {
      choosePosition: 'Wähle die QR-Code Position aus',
    },
    qrCodeBackground: {
      alerts: {
        noSelection: {
          title: 'Kein Bild ausgewählt',
          content: 'Du musst zuerst ein Bild hochladen hochladen.',
        },
        noActionAllowed: {
          title: 'Nicht erlaubt',
          content:
            'Du kannst hier keinen QR-Code-Hintergrund herunterladen. Bitte Deinen Admin, entweder eine Auswahl an Bildern hochzuladen oder das Hochladen eigener Bilder zu erlauben.',
        },
      },
      type: 'QR-Code Typ auswählen',
      typeTooltip:
        'Online: Öffnet direkt Dein digitales Lemontaps-Profil im Browser.\n Offline: Der Offline QR-Code funktioniert ohne Internet. Durch Scannen wird der Kontakt direkt geöffnet, nicht Dein online Lemontaps-Profil. Im gespeicherten Kontakt ist trotzdem der Link zu Deinem Lemontaps-Profil enthalten, damit der Gegenüber jederzeit es öffnen kann.',
      image: 'Bild auswählen',
      download: 'QR-Code gestalten & herunterladen',
      online: 'Online',
      offline: 'Offline',
      uploadSubtext: 'SVG, PNG, JPG oder GIF (beliebiges Format, Mindestbreite: {{limit}}px)',
      howToUseVC: 'Wie benutze ich meinen Videocall Hintergrund in Zoom, Teams oder Hangouts?',
      imageTooltip:
        'Beliebiges Format, Mindestbreite {{limit}}px empfohlen.\nTipp: Verwende das Format Deines Handys!',
      positions: {
        top: 'Oben',
        middle: 'Mitte',
        bottom: 'Unten',
        left: 'Links',
        right: 'Rechts',
        default: 'Standard',
      },
      mobile: {
        title: 'QR Smartphone Hintergrund',
        header:
          'Halte Dein Lemontaps-Profil über einen QR-Code auf dem Lockscreen Deines Smartphones immer griffbereit.',
        label: 'Smartphone-Hintergrund',
      },
      videocall: {
        title: 'QR Videocall Hintergrund',
        header: 'Teile deinen QR-Code zur digitalen Visitenkarte auch bei Videocalls.',
        label: 'Videocall-Hintergrund',
      },
    },
    download: 'Herunterladen',
    imageUpload: 'Bild hochladen',
    generalQRImgError: 'Bitte aktualisiere die Seite und probieren es nochmal',
    uploadImgError: 'Bitte lade ein Bildformat hoch (.jpg, .jpeg, .png)',
    uploadImgSuccess: ' Das Bild wurde erfolgreich hochgeladen',
    downloadImgSuccess: 'Das Bild wird heruntergeladen',
    mobileBG: 'Handy Hintergrund',
    mobileTxt:
      'Hast Du Deine Lemontaps Karte vergessen? Keine Sorge, habe Dein Lemontaps Profil immer griffbereit über einen QR-Code auf Deinem Handy Sperrbildschirm. Die empfohlene Mindestgrösse ist 1000x2000',
    uploadedImgSizeErr: `Dein hochgeladenes Bild muss mindestens {{x}}px Breite haben`,
    uploadedMobileImgErr: 'Das Bild muss vertikal sein und eine Mindestbreite von {{x}}px haben.',
    notes: 'Notizen',
    writeNoteHere: 'Füge hier Notizen hinzu',
    contactInformation: 'Kontaktdaten eingeben',
    scanBusinessCard: 'Visitenkartenbild hochladen',
    dataWillBeEntered: 'Daten müssen eingetragen werden',
    editContact: 'Kontakt bearbeiten',
    leadSegment: 'Lead Segment',
    or: 'oder',
    createInProgress: 'Die "Erstellen-Funktion" ist in der Umsetzung',
    editInProgress: 'Die "Bearbeiten-Funktion" ist in der Umsetzung',
    missingInputPrompt: '{{param}} ist nicht ausgefüllt',
    fullName: 'Vollständiger Name',
    firstAndLastName: 'Vor- & Nachname (in einer Zeile)',
    name: 'Name',
    correctEmail: 'Bitte gib eine korrekte Email-Adresse ein',
    succAdded: 'Erfolgreich hinzugefügt!',
    consentToData: 'Bitte bestätige die Verarbeitung Deiner Kontaktdaten.',
    shareBusinessCard: 'Teile Deine Visitenkarte mit {{name}}',
    shareContactDetails: 'Teile Deine Kontaktdaten mit {{name}}',
    retakePic: 'Erneut aufnehmen',
    gdprConsent: {
      pt1: 'Durch Absenden bestätige ich, dass ich die',
      pt2: 'zur Kenntnis genommen habe und mit der Verarbeitung meiner Daten im Kontakt-Management des Lemontaps Nutzers und gegebenfalls seiner Firma',
      pt3: 'zu den genannten Zwecken einverstanden bin. Du kannst jederzeit Deine Einwilligung widerrufen.',
      gdpr: 'Datenschutzerklärung',
    },
    privacyPolicy: ' DSGVO',
    termsAndConditions: 'AGBs ',
    and: ' und ',
    Send: 'Senden',
    saveContactOf: `{{name}} Kontakt speichern`,
    modalEmailPlaceholder: 'Kontakt an Deine Email senden',
    dataDisclaimer: 'Wir werden Deine Daten weder verkaufen, noch mit Dritten teilen.',
    lgFollowUp_contSave: 'Möchtest Du auch {{name}} Kontaktinformationen speichern?',
    lgFollowUp_contConn: 'Möchtest Du auch Deine Kontaktinformationen mit {{name}} teilen?',
    lgFollowUp_doneSave: 'Wir haben Dir eine Email mit {{name}} Kontaktdaten gesendet!',
    lgFollowUp_doneSaveDown: '{{name}} Kontakt heruntergeladen!',
    lgFollowUp_doneConn: 'Deine Kontaktinformationen wurden erfolgreich an {{name}} versendet!',
    leadSuccess: 'Dein Kontakt wurde digital übermittelt!',
    leadSaveSuccess: 'Erfolgreich gespeichert',
    leadError: 'Fehler beim Speichern.',
    deleteLead: 'Kontakt löschen',
    deleteLeadSuccess: 'Kontakt gelöscht.',
    deleteLeadError: 'Fehler beim Löschen.',
    deleteLeadMsg: 'Dein Kontakt wird gelöscht.',
    fileTypeNotSupported: 'Das Format wird nicht unterstützt.',
    uploadRestrictedTo: 'Bitte nur jpg, jpeg, png, gif Dateien hochladen.',
    maxUpload: 'Max. Uploadgröße: {{mb}} MB.',
    EditBioSuccess: 'Erfolgreich gespeichert.',
    editDetails: 'Details bearbeiten',
    profiles: 'Nutzerprofile',
    units: 'Units',
    unit: 'Unit',
    mainUnit: 'Haupt-Unit',
    subUnit: 'Unter-Unit',
    mainUnitTooltip:
      'Die Haupt-Unit ist entscheidend für Unit-spezifische Einstellungen. Werden bspw. für alle Units eigene Profildesigns festgelegt, so entscheidet die Haupt-Unit eines Accounts über dessen Profildesign.',
    otherUnits: 'Neben-Units',
    otherUnitsTooltip:
      'Accounts können mehreren Units zugeordnet sein. Neben der Haupt-Unit können also weitere Units festgelegt werden. Ein Unit-Admin kann immer sämtliche Profile in allen Units bearbeiten, in denen er:sie Mitglied ist.',
    unitsText:
      'Gruppiere Nutzer:innen in Units. Diese können durch Sub-Admins auch selbst verwaltet werden.',
    addUnit: 'Unit hinzufügen',
    editUnit: 'Unit bearbeiten',
    searchUnits: 'Suche Units',
    createUnit: 'Unit erstellen',
    noUnitData: 'Es sind aktuell noch keine Units vorhanden',
    guides: 'Erste Schritte',
    guideHeader: 'Los geht’s mit Lemontaps',
    guideSubHeader:
      'Hier findest Du eine Übersicht zu Guides und Hilfen, wie Du Lemontaps einrichten und benutzen kannst.',
    connectionsSubHeader:
      'Finde alle erfassten Kontakte/Leads aller Mitarbeiter:innen an einem Ort, welche mithilfe des Kontaktformulars unten im öffentlichen Profil erfasst wurden.',
    // MD Customization strings start
    companySettings: 'Firmen Einstellungen',
    globalCompanyData: 'Globale Firmen Daten',
    globalCompanyDataSub: 'Füge Standard Daten hinzu, die Du hier verwalten kannst. ',
    globalCompanyAddButton: 'Daten hinzufügen',
    organisationPageHeader: 'Organisation',
    filesPageHeader: 'Dateien',
    addressesPageHeader: 'Adressen',
    footerPageHeader: 'Footer',
    linksPageHeader: 'Links',
    qrCodePageHeader: 'QR-Code-Hintergründe',
    contactFormPageHeader: 'Kontaktformular',
    standardData: 'Datenvorlagen',
    emailTemplatesPageHeader: 'E-Mail Vorlagen',
    teamSettings: 'Team-Einstellungen',
    leadForm: 'Kontaktformular',
    customizationSub: 'Passe Deine Lemontaps Plattform genau nach Deine Bedürfnissen an.',
    customizeDesign: 'Design anpassen',
    general: 'Allgemein',
    organisation: {
      title: 'Organisation',
      name: 'Name Deiner Organisation',
      nameTooltip:
        'Der Name taucht bspw. in den E-Mail-Betreffs auf, oder im Titel des Browser Tabs.',
      nameRequired: 'Name der Organisation ist erforderlich.',
      nameFailed: 'Name der Organisation konnte nicht aktualisiert werden.',
      internalDesign: 'Internes Design der Plattform',
      internalDesignFailed: 'Aktualisierung des internen Designs fehlgeschlagen.',
      bannerUpgradeNow: 'Jetzt upgraden.',
      bannerText: 'Das Interne Design ist in Deinem aktuellen Paket nicht verfügbar. ',
      lightBackground: 'Logo für hellen Hintergrund:',
      lightBackgroundTooltip:
        'Das Lemontaps-Logo kann durch das Logo Eures Unternehmens ersetzt werden.',
      otherLightBackground: 'Andere Logo-Datei für dunklen Hintergrund hochladen:',
      logoLimit: 'nur .png mit transparentem Hintergrund, maximal {{x}}MB',
      primaryButtonColor: 'Primäre Buttonfarbe',
      sidebarColor: 'Farbe der Navigationsseitenleiste',
      sidebarColorText: 'Textfarbe der Navigationsseitenleiste',
      sidebarColorActive: 'Farbe des aktiven Status der Navigationsseitenleiste',
      sidebarColorActiveText: 'Textfarbe für aktiven Status der Navigationsseitenleiste',
      resetColors: 'Farben zurücksetzen',
    },
    loginAndProvisioning: {
      title: 'Login und Provisionierung',
      domainControl: {
        title: 'Domainverwaltung',
        description:
          'Verifiziere Eure Unternehemens-E-Mail-Domain(s) um volle Kontrolle über alle Accounts zu erlangen. Du kannst so festlegen, dass alle Eure Mitarbeiter:innen bei Registrierung automatisch in Euer Team aufgenommen werden. Die Domainverifizierung ist außerdem Voraussetzung für Single Sign-On (SSO) und Nutzersynchronisierung. ',
        buttonTitle: 'Domains verwalten',
      },
      sso: {
        title: 'Single Sign-On (SSO)',
        description:
          'Single Sign-On auf Basis von OIDC oder SAML 2.0 gibt Deinen Teammitglieder:innen Zugriff auf Lemontaps mit ihren Firmenanmeldedaten.',
        buttonTitle: 'SSO verwalten',
      },
      scim: {
        title: 'Benutzer:innenprovisionierung',
        description:
          'Automatisches Bereitstellen und Entfernen von Benutzer:innen und deren Profilinformationen aus Eurem Identitätsanbieter.',
        buttonTitle: 'Provisionierung verwalten',
      },
    },
    visibility: {
      accountSettings: {
        title: 'Account-Einstellungen / Mehr (Desktop & Mobile)',
        tooltip:
          'Steuert die Sichtbarkeit der Elemente in der Account-Einstellungen-Seite sowie in der "Mehr"-Seite auf Mobilgeräten.',
        accountSettings: {
          title: 'Account-Einstellungen (nur auf Desktop)',
          tooltip:
            'Du kannst die gesamte Account-Einstellungen-Seite auf Desktop ausblenden. Auf Mobilgeräten ist dies nicht möglich. Du kannst aber weiterhin einzelne Elemente aus der Mobil-Account-Einstellungen-Seite manuell ausblenden.',
        },
        externalLink: {
          title: 'Externe Links',
          tooltip:
            'Dieser Menüpunkt ist nur relevant, wenn er manuell von einem Lemontaps-Konfigurationsadministrator eingerichtet wurde. Du kannst diese Einstellung ansonsten ignorieren.',
        },
        paperCardOrderSystem: {
          title: 'Papiervisitenkarten-Bestellsystem',
          tooltip:
            'Der Link zum Papiervisitenkarten-Bestellsystem für einzelne Mitarbeiter:innen. Dies ist nur relevant, wenn Du ein Papiervisitenkarten-Bestellsystem konfiguriert hast. Du kannst diese Einstellung ansonsten ignorieren.',
        },
        prefilledFormLink: {
          title: 'Formular-Links',
          tooltip:
            'Dieser Menüpunkt ist nur relevant, wenn er manuell von einem Lemontaps-Konfigurationsadministrator eingerichtet wurde. Du kannst diese Einstellung ansonsten ignorieren.',
        },
        changeEmail: {
          tooltip: 'Menüpunkt, der Benutzer:innen erlaubt, ihre E-Mail-Adresse zu ändern.',
        },
        changePassword: {
          tooltip: 'Menüpunkt, der Benutzer:innen erlaubt, ihr Passwort zu ändern.',
        },
        cookies: {
          tooltip: 'Menüpunkt, der Benutzer:innen erlaubt, ihre Cookies zu verwalten.',
        },
        changeLanguage: {
          tooltip: 'Menüpunkt, der Benutzer:innen erlaubt, die Sprache der Plattform zu ändern.',
        },
        teamManagement: {
          title: 'Team Management (nur auf Mobile)',
          tooltip:
            'Menüpunkt, der zum Management-Dashboard führt. Kann im "Mehr"-Menü auf Mobilgeräten angezeigt werden.',
        },
        nfcCards: {
          title: 'NFC-Karten (nur auf Mobile)',
          tooltip: 'Menüpunkt, der Benutzer:innen erlaubt, ihre NFC-Karten zu verwalten.',
        },
        analytics: {
          title: 'Analytics (nur auf Mobile)',
          tooltip: 'Menüpunkt, der Benutzer:innen erlaubt, Analysedaten einzusehen.',
        },
        addApp: {
          title: 'Zum Homescreen hinzufügen (nur auf Mobile)',
          tooltip:
            'Menüpunkt, der Benutzer:innen erlaubt, die Lemontaps-App auf ihrem Mobilgerät zu installieren (als PWA).',
        },
        help: {
          title: 'Hilfe (nur auf Mobile)',
          tooltip:
            'Menüpunkt, der Benutzer:innen erlaubt, das Lemontaps-Support-Team zu kontaktieren.',
        },
      },
      title: 'Sichtbarkeit',
      description:
        'Du kannst hier bestimmte Seiten oder Elemente sowohl für Endbenutzer:innen, als auch für Administrator:innen ausblenden',
    },
    unitSettings: {
      title: 'Unit Einstellungen',
      multipleUnits: {
        title: 'Zuweisung mehrerer Units',
        description:
          'Erlaube die Zuweisung eines Accounts zu mehreren Units. Eine der zugewiesenen Units muss als Haupt-Unit festgelegt sein. Die Einstellungen dieser Haupt-Unit sind entscheidend für das Verhalten des Kontos (Profildesign, Bearbeitungsrechte etc.). Wenn diese Einstellung deaktiviert ist, kann jeder Account nur einer Unit zugewiesen werden.',
      },
    },
    setEditRights: 'Rechte anpassen',
    profileDesign: 'Profil-Design',
    profileDesignSub:
      'Gestalte selbst das Design der digitalen Profile - entscheide über Farben, Formen und Bilder.',
    profileDesignInfo: {
      unitAdmin:
        'Passe die digitalen Profile in Deiner Unit entsprechend eurem Corporate Design an. Die Einstellungen, die Du in diesem Abschnitt wählst, werden auf alle Profile in Deiner Unit angewendet.',
      themeAdmin: {
        global:
          'Passe alle digitalen Profile entsprechend Eures Corporate Designs an. Die Einstellungen, die Du in diesem Abschnitt wählst, werden auf alle digitalen Profile angewendet, die keine Unit-spezifischen Einstellungen haben.',
        unit: 'Passe alle digitalen Profile in der ausgewählten Unit entsprechend ihrem Corporate Design an. Die Einstellungen, die Du in diesem Abschnitt wählst, werden auf alle digitalen Profile in dieser Unit angewendet.',
      },
    },
    boxForm: 'Boxen-Form',
    rounded: 'Rund',
    squared: 'Eckig',
    buttonColors: 'Button-Farben',
    AdditionalImages: 'Zusätzliche Titelbilder',
    strSaveContact: '“Kontakt speichern”',
    genericWebsite: 'Generischer Webseitenlink',
    images: 'Bilder',
    Oops: 'Ups! Etwas lief schief!',
    anErrorHasOccured:
      'Es ist ein unerwarteter Fehler aufgetreten, wir bitten das zu entschuldigen. Wenn der Fehler weiterhin auftritt, wende Dich bitte an unser Support-Team. Du kannst zur Startseite gehen, indem Du auf die Schaltfläche "Zur Startseite" klickst. Falls Du uns etwas im Zusammenhang mit dieser Fehlermeldung mitteilen möchtest, dann klicke auf "Kontaktiere uns", um eine Nachricht an unser Support-Team zu senden.',
    goHome: 'Zur Startseite',
    message: 'Gib hier Deine Nachricht an unser Support-Team ein',
    submitText: 'Absenden',
    errorMessageSentSuccess:
      'Wir haben Deine Nachricht erhalten und werden uns schnellstmöglich darum kümmern.',
    more: 'mehr',
    less: 'weniger',
    defaultCoverImage: 'Standard-Titelbild',
    uploadCoverImage: 'Titelbild hochladen',
    uploadFurtherCoverImage: 'Weiteres Titelbild hochladen',
    uploadMoreImages: 'Lade Titelbilder hoch, aus denen die Mitarbeiter:innen auswählen müssen',
    defaultAvatar: 'Standard Profilbild',
    logo: 'Logo',
    uploadLogo: 'Logo hochladen',
    policies: '4. Bestimmungen',
    linkToImprint: 'Link zum Impressum',
    linkToPrivacyPolicy: 'Link zu den Datenschutzbestimmungen',
    nameOfYourCompany: 'Name Deiner Firma',
    addCopyRight: 'Copy-Right hinzufügen?',
    allRightsReserved: '(© @year [Deine Firma]. Alle Rechte vorbehalten)',
    allRightsReservedPublic: 'Alle Rechte vorbehalten',
    editRightsL: 'Bearbeitungsrechte für Mitarbeiter:innen',
    unitsGlobalSelect: 'Global (Standard)',
    unitsSelectLabel: 'Unit wählen',
    profilesSelectLabel: 'Profil wählen',
    editRights: {
      editable: 'Bearbeitbar',
      nonEditable: 'Nicht bearbeitbar',
      editApprovalNeeded: 'Freigabe erforderlich',
      title: 'Bearbeitungsrechte',
      mainHeading: 'Bearbeitungsrechte für Mitarbeiter:innen',
      unitHeading: 'Bearbeitungsrechte für Unit-Admins',
      mainTabLabel: 'Für Mitarbeiter:innen',
      unitTabLabel: 'Für Unit-Admins',
      unitOverrideLabels: {
        visibilityConfig: {
          label: 'Sichtbarkeit',
        },
        profileDesign: {
          label: 'Profildesign',
        },
        editRights: {
          label: 'Bearbeitungsrechte',
        },
        emailSignature: {
          label: 'E-Mail Signatur',
        },
        emailTemplates: {
          label: 'E-Mail Vorlagen',
        },
        walletConfig: {
          label: 'Wallet Einstellungen',
        },
        qrBgImages: {
          label: 'QR-Code Hintergründe',
        },
        qrCodeConfig: {
          label: 'QR-Code Einstellungen',
        },
        userDefinedTranslations: {
          label: 'Übersetzungen',
          subsettings: {
            heading: 'Übersetzungsrechte',
            subheading:
              'Erlaube Unit-Admins die Bearbeitung bestimmter Übersetzungspakete. Achtung: Unit-Admins können dann die Übersetzungen der gesamten Organisation in dieser Kategorie bearbeiten. Jede Änderung, die sie machen, wird die gesamte Organisation betreffen.',
            labels: {
              'profile--links': 'Links',
              'profile--files': 'Dateien',
              'profile--system-labels': 'Systembeschriftungen',
              'profile--position': 'Positionen',
              'profile--role': 'Rollen',
              'profile--division': 'Abteilungen',
              'profile--bio': 'Bio Texte',
              'profile--addresses': 'Adressen',
              'profile--firstName': 'Vornamen',
              'profile--lastName': 'Nachnamen',
              'profile--company': 'Unternehmensnamen',
              'profile--homepage': 'Homepage URLs',
              'profile--other-contact-info': 'Weitere Kontaktinformationen',
              'profile--urls': 'URLs',
            },
          },
        },
      },
      fields: {
        detailsEditMode: 'Kontaktinformationen',
        profileImageEditMode: 'Profilbild',
        bannerImageEditMode: 'Profilhintergrundbild',
        logoImageEditMode: 'Logo',
        linkEditMode: 'Links',
        fileEditMode: 'Dateien',
        allowOwnQrBgImage: 'Individuelle QR-Hintergründe',
        rebuyCards: 'Karten nachbestellen',
        singleUserCrmPush: 'Erlaube den Endbenutzer:innen, Kontakte ins CRM zu pushen',
        profileShare_uidParam: 'Zwischen Profil-Designs wechseln',
      },
      tooltips: {
        allowOwnQrBgImage:
          'Bestimme, ob Deine Mitarbeiter:innen eigene Bilder hochladen dürfen, um QR-Hintergründe zu erstellen.',
        rebuyCards:
          'Bestimme, ob Deine Mitarbeiter:innen das Kartennachbestellungsformular ausfüllen dürfen (auf der Seite unter "Profil Teilen" -> "NFC-Karte")',
        profileShare_uidParam:
          'Bestimme, ob Deine Mitarbeiter:innen zwischen den ihnen zu Verfügung stehenden Profil-Designs wechseln dürfen. Sie können dann auch das globale Standard-Design wählen.',
      },
      fieldsSubHeadings: {
        detailsEditMode:
          'Du kannst hier pro Profilattribut festlegen, ob dieses von Deinen Mitarbeiter:innen bearbeitet werden darf. So kannst du verhindern, dass einzelne Attribute von deinen Mitarbeiter:innen verwaltet werden, während du die Bearbeitung anderer Attribute erlaubst.',
        linkEditMode:
          'Du kannst hier entscheiden, welche Linkvarianten von Deinen Mitarbeiter:innen erstellt werden dürfen. Als Admin kannst Du weiterhin alle Varianten erstellen.',
      },
    },
    editRightsSub:
      'Entscheide welche Informationen Mitarbeiter:innen selbst verändern dürfen und welche nur die Admins.',
    editRightsInfo: {
      unitAdmin:
        'Welche Informationen können Mitarbeiter:innen ändern? Welche Informationen dürfen nur von den Administratoren geändert werden? Die Einstellungen, die Du in diesem Abschnitt wählst, werden auf alle Accounts in Deiner Unit angewendet.',
      themeAdmin: {
        global:
          'Welche Informationen können Mitarbeiter:innen ändern? Welche Informationen sollen nur von den Unit-Administratoren oder globalen Administratoren geändert werden? Die Einstellungen, die Du in diesem Abschnitt wählst, werden global auf alle digitalen Profile angewendet, die keine Unit-spezifischen Einstellungen haben.',
        unit: 'Lege spezifische Bearbeitungsrechte für die ausgewählte Unit fest.',
      },
    },
    editRightsBlockedFieldsTeaser:
      'Detaillierte Bearbeitungsrechte sind sind in Deinem aktuellen Paket nicht verfügbar.',
    blockedBioFieldsSubtext:
      'Du kannst hier pro Profilattribut festlegen, ob dieses von Deinen Mitarbeiter:innen bearbeitet werden darf. So kannst du verhindern, dass einzelne Attribute von deinen Mitarbeiter:innen verwaltet werden, während du die Bearbeitung anderer Attribute erlaubst.',
    blockedLinkTypesSubtext:
      'Du kannst hier entscheiden, welche Linkvarianten von Deinen Mitarbeiter:innen erstellt werden dürfen. Als Admin kannst Du weiterhin alle Varianten erstellen.',
    profilePreview: 'Vorschau Beispielprofil:',
    comingSoon: 'kommt bald',
    mdguide: {
      tasks: 'Aufgaben',
      pageHeader: 'Erste Schritte als Administrator',
      watchIntro: 'Intro Ansehen',
    },
    sharingDesign: {
      title: 'QR-Code Design',
      shortTitle: 'QR-Code Design',
      qrcode: {
        tab: 'QR-Code',
        title: 'QR-Code Design',
        chooseColor: 'Farbe wählen',
        preview: 'Vorschau',
        infoText: 'Das QR-Code Design wird überall angewendet, außer für den QR-Code im Wallet.',
      },
      wallet: {
        tab: 'Wallet',
        title: 'Wallet Design',
        onlyApple: 'Die folgenden Einstellungen gelten ausschließlich für Apple Wallet.',
        showUnitLabel: {
          title: 'Unit-Name anzeigen',
          tooltipText:
            'Entscheide, ob der Unit-Name im Wallet anstatt des Firmennamens angezeigt werden soll, wenn ein:e Nutzer:in Teil einer Unit ist.',
        },
        showRoundProfilePicture: {
          title: 'Rundes Profilbild anzeigen',
          tooltipText:
            'Entscheide, ob das Profilbild im Wallet in einem runden Rahmen angezeigt werden soll.',
        },
        hideLogo: {
          title: 'Logo ausblenden',
          tooltipText: 'Entscheide, ob das Unternehmenslogo im Wallet angezeigt werden soll.',
        },
        showAcademicDegree: {
          title: 'Akademischer Grad anzeigen',
          tooltipText:
            'Entscheide, ob der akademische Grad oberhalb des Namens angezeigt werden soll.',
        },
        showDepartment: {
          title: 'Abteilung anzeigen',
          tooltipText: 'Entscheide, ob die Abteilung neben der Position angezeigt werden soll.',
        },
        hideProfileImage: {
          title: 'Profilbild ausblenden',
          tooltipText: 'Entscheide, ob das Profilbild im Wallet angezeigt werden soll.',
        },
        background: {
          title: 'Hintergrundbild',
          tooltipText: 'Entscheide, ob ein Hintergrundbild im Wallet angezeigt werden soll.',
        },
        colors: {
          backgroundColor: {
            title: 'Hintergrundfarbe',
          },
          foregroundColor: {
            title: 'Textfarbe',
            tooltip: 'Nur für Apple Wallet',
          },
          labelColor: {
            title: 'Labelfarbe',
            tooltip: 'Nur für Apple Wallet',
          },
        },
      },
      qrbg: {
        chooseImages: 'Bilder auswählen',
        defaultImage: 'Standardbild',
        additionalImages: 'Zusätzliche Bilder',
        mobile: {
          tab: 'Handyhintergrund',
          title: 'Mobile Hintergrundeinstellungen',
          helperText:
            'Jedes vertikale Format ist erlaubt mit einer Mindestbreite von 500px. Wir empfehlen das Format des am häufigsten verwendeten Telefons in Deinem Team.',
        },
        videocall: {
          tab: 'Videohintergrund',
          title: 'Video Hintergrundeinstellungen',
          helperText:
            'Jedes horizontale Format ist erlaubt mit einer Mindestbreite von 800px. Wir empfehlen das Format für virtuelle Hintergründe des von Dir verwendeten Videokonferenz-Tools.',
        },
        dialogText:
          'Bist Du sicher, dass Du alle Bilder zurücksetzen willst?\n\nDas kann nicht rückgängig gemacht werden!',
        uploadSubtext: 'SVG, PNG, JPG oder GIF (beliebiges Format, Mindestbreite: {{limit}}px)',
      },
    },
    accountGuides: {
      headerPage: 'Los geht’s mit Deinem Lemontaps-Profil',
      subHeader:
        'Hier findest Du eine Übersicht aus Guides und Hilfen, wie Du Lemontaps einrichten und benutzen kannst.',
      guidesHeader: 'Schritt-für Schritt Erklärung zum Durcklicken',
      videoGuides: {
        header: 'Videoerklärungen',
      },
      openQuestions: {
        header: 'Weitere Fragen?',
        takeALook: 'Erkunde häufig gestellte Fragen',
        takeALookLink: 'Zur Wissensdatenbank',
        writeToSupport: 'Schreibe unserem Support-Team.',
        writeToSupportLink: 'Support Ticket erstellen',
      },
    },
    mdAnalytics: {
      title: 'Analytics',
      profileSavings: 'Daraus resultieren folgende Einsparungen',
      networking: {
        title: 'Profilaktivität',
        subtitle: 'Erfahre, wie Dein Team seine Karten benutzt.',
        shares: 'Profile geteilt',
        vcards: 'vCards gespeichert',
        contacts: 'Erfasste Kontakte',
        edits: 'Bearbeitungen',
        links: 'Link Klicks Insgesamt',
        files: 'Datei Klicks Insgesamt',
      },
      tooltips: {
        shares: 'Anzahl der Ansichten aller Deiner Unternehmensprofile',
        contacts: 'Anzahl aller eingesammelten Kontakte Deiner Unternehmenaccounts',
        vcards:
          'So oft wurde der "Kontakt speichern" Button auf allen Deiner Unternehmensprofilen bereits geklickt.',
        links:
          'Anzahl an Momenten, in denen ein Link einer Deiner Unternehmensaccounts geöffnet wurde.',
        files:
          'Anzahl an Momenten, in denen eine Datei einer Deiner Unternehmensaccounts geöffnet wurde.',
        cards:
          'Anzahl der Papierkarten, die dafür eingespart wurden, dass Du Dein Profil digital geteilt hast oder einen digitalen Kontakt eingesammelt hast.',
        flyers:
          'Anzahl der Papierseiten, die dadurch eingespart wurden, dass Du anstatt eines Papier-Ausdrucks eine digitale Version genutzt hast (bspw. PDF-Dateien statt Papier-Flyer).',
        edits:
          'Als eine Profilbearbeitung zählt jede Änderung in einem Profil deines Teams (Kontaktinformationen, Bilder, Dateien oder Links). Pro 7-Tage Periode wird höchstens eine Bearbeitung gezählt.',
      },
      saves: {
        title: '🌱 Dein Unternehmen ist ein nachhaltiger Leader, bis jetzt habt ihr schon gespart:',
        cards: 'Papierkarten',
        flyers: 'Flyerseiten',
        subtitle: '... und damit:',
        wood: '🪵 Holz',
        water: '💧 Wasser',
        energy: '🔋 Energie',
        co2: '☁️ CO2',
      },
    },
    addressesTab: {
      header: 'Standard Adressen',
      headerTooltip:
        'Definiere hier Adressen, aus denen Du später wählen kannst, wenn Du neue Profile anlegst.',
      addAddresses: 'Adresse hinzufügen',
      addNewAddress: 'Adresse hinzufügen',
      makeAddressDefault: 'Soll diese Adresse als Standard für neue Profile gelten?',
      addressDefaulTooltip:
        'Wenn neue Profile erstellt werden, werden ihnen diese Adresse per default zugeordnet.',
      default: 'Default',
      confirmDelete: 'Bist Du sicher, dass Du die Adresse löschen möchten?',
      ErrorDeletingAddress: 'Fehler beim Löschen der Adresse',
      cannotDeleteDefaultAddress: 'Du kannst die Standardadresse nicht löschen.',
      errorReadAddress: 'Adressen konnten nicht geladen werden',
      orCreateIndividual: 'oder individuelle Adresse anlegen:',
      errorWriteAddress: 'Mindestens ein Adressfeld erforderlich!',
      errorWriteLabel: 'Die Adresse muss benannt werden!',
      saveSuccess: 'Erfolgreich gespeichert',
      noAddresses: 'Noch keine Adressen vorhanden',
      emptyAddressFieldsError: 'Fülle mindestens ein Feld aus',
    },
    qrBgTab: {
      defaultBackgrounds: 'Standard Hintergründe',
      defaultMobileBg: 'Standard-Bild für QR-Handysperrbildschirm:',
      defaultVideoCallBg: 'Standard-Bild für QR-Videocallhintergrund:',
      minBgSize: 'Bildbreite: mind. {{x}}px',
      uploadBg: 'Bild hochladen',
      additionalBgImgs: 'Zusätzliche Hintergründe',
      additionalBgImgsDescription:
        'Hochladen weiterer Bilder, aus denen die Nutzer:innen wählen können',
      additionalMobileBgs: 'Weitere Handyhintergründe:',
      additionalVideoCallBgs: 'Weitere Videocallhintergründe:',
    },
    linkTab: {
      header: 'Linkvorlagen',
      headerTooltip:
        'Definiere hier Links, aus denen Du später auswählen kannst, wenn Du Links zu den Profilen Deiner Mitarbeiter:innen hinzufügst.',
      addLink: 'Hinzufügen ',
      addNewLink: 'Einen neuen Link hinzufügen',
      name: 'Titel',
      linkType: 'Link Typ',
      linkName: 'Link Name',
      linkPhone: 'Telefonnummer',
      linkUrl: 'URL',
      placeHolderUrl: 'z.B. www.website.com',
      placeHolderLink: 'z.B. Unsere Website',
      placeHolderPhone: 'z.B. 49 170 12345',
      searchStandardLinks: 'Linkvorlage suchen',
      noTemplates: 'Noch keine Linkvorlage erstellt',
      createTemplate: 'Jetzt Linkvorlage erstellen',
      deleteLink: 'Link löschen',
      confirmDelete: 'Bist Du sicher, dass Du den Link löschen möchtest?',
      yesDelete: 'Ja, löschen.',
      successAdd: 'Hinzugefügt',
      successEdit: 'Gespeichert',
      errorAdd: 'Fehler',
      errorEdit: 'Fehler',
      successDelete: 'Gelöscht',
      errorDelete: 'Error',
      orAddIndividualLink: 'oder individuellen Link anlegen:',
    },
    rename: 'Umbenennen',
    locationSelector: {
      header: 'Standardadresse auswählen',
      max2Label: '(max. 2 Adressen können angelegt werden)',
      orCreateIndividual: 'oder individuelle Adresse anlegen:',
      searchAddress: 'Adresse suchen',
      noTemplates: 'Noch keine Adressvorlage erstellt',
      createTemplate: 'Jetzt Adressvorlage erstellen',
    },
    employeeType: {
      role: 'Rolle im Unternehmen',
      employee: 'Mitarbeiter:in',
      themeAdmin: 'Administrator:in',
      unitAdmin: 'Unit-Admin',
      edit: 'edit',
      sendInviteText:
        'Beim Speichern automatisch den Zugang an die neue Email senden? Du kannst dies auch später manuell machen.',
      profile: 'Progil',
      account: 'Account',
      emailExisted: 'Die E-Mail existiert bereits!',
    },
    errorSharingData: 'Fehler beim Teilen von Daten',
    errorLoad: 'Fehler beim Laden von Kontakten',
    errorLoadMore: 'Fehler beim Laden weiterer Kontakte',
    downloading: 'Herunterladen',
    successfullyDownloaded: 'Erfolgreich heruntergeladen',
    errorWhenDownloading: 'Fehler beim Herunterladen',
    filesTab: {
      header: 'Dateivorlagen',
      headerTooltip:
        'Definiere hier Dateien, aus denen Du dann später wählen kannst, wenn Du Dateien zu den Profilen Deiner Mitarbeiter:innen hinzufügst.',
      fileName: 'Titel',
      fileNamePlaceHolder: 'z.B. One-Pager',
      uploadImage: 'Datei hochladen',
      errorUploadingFile: 'Fehler beim Hochladen der Datei',
      successfullySaved: 'Datei erfolgreich gespeichert',
      successfullyDeleted: 'Datei erfolgreich gelöscht',
      writingDataError: 'Fehler beim Speichern der Datei',
      selectFileTitle: 'Linkvorlage  auswählen',
      searchInputPlaceHolder: 'Dateivorlage suchen...',
      noTemplates: 'Noch keine Dateivorlage erstellt',
      createTemplate: 'Jetzt Dateivorlage erstellen',
      orAddIndividualFile: 'oder individuelle Datei anlegen:',
      savingFile: 'Datei wird gespeichert',
      savingChanges: 'Änderungen werden gespeichert',
      deletingFile: 'Datei wird gelöscht',
      deleteFile: 'Datei löschen',
      yesDelete: 'Ja, löschen',
      confirmDelete: 'Bist Du sicher, dass Du diese Datei löschen möchtest?',
      uploadFile: 'Datei hochladen',
    },

    // MD Customization strings end

    //How To Tap Strings Start//
    HowToTap: 'So teilt man per Berührung',
    HowToTapDescription: 'Wähle das Gerät aus, mit welchem Du Dein Profil teilen möchtest.',
    important: 'Wichtig!',
    BackupDescriptionHeading: 'Du hast immer ein Backup',

    TapNewIphoneHeading: 'Neuere iPhones “tappen”',
    TapNewIphoneSubHeading: 'iPhone XR und neuer',
    TapNewIphoneDetailHeading: 'Neuere iPhones “tappen”',
    TapNewIphoneDetailSubHeading: 'iPhone XR, XS, 11, 12, 13',
    TapNewIphoneDetailDescription:
      'Um Dein Profil mit neueren iPhones zu teilen, wische und berühre Deine Lemontaps Karte entlang des oberen Randes bis eine Push-Benachrichtigung erscheint.',
    TapNewIphoneDetailImportantDescription:
      'Dein Bildschirm muss eingeschaltet, Dein Flugmodus ausgeschaltet und Deine Kamera darf nicht geöffnet sein.',
    TapNewIphoneDetailBackupDescription:
      'Das “Tappen” erfordert etwas Übung und es kann auch mal vorkommen, dass es nicht direkt funktioniert. Keine Sorge - Du kannst jederzeit den QR-Code verwenden.',

    TapOlderIphoneHeading: 'Ältere iPhones “tappen”',
    TapOlderIphoneSubHeading: 'iPhone X und älter',
    TapOlderIphoneDetailHeading: 'Ältere iPhones “tappen”',
    TapOlderIphoneDetailSubHeading: 'iPhone 6, 7, 8, X',
    TapOlderIphoneDetailDescription:
      'Hier ist das NFC nicht automatisch aktiviert. Dafür muss der:die Besitzer:in das Kontrollzentrum hoch swipen und auf den NFC-Button klicken. Wische jetzt die Karte entlang des oberen Randes des iPhones:',
    TapOlderIphoneDetailImportantDescription:
      'Manchmal muss der NFC button erst in den Einstellungen einmalig aktiviert werden, bevor dieser im Kontrollzentrum erscheint. Außerdem muss Dein Bildschirm eingeschaltet, Dein Flugmodus ausgeschaltet und Deine Kamera darf nicht geöffnet sein.',
    TapOlderIphoneDetailBackupDescription:
      'Das “Tappen” erfordert etwas Übung und es kann auch vorkommen, dass es mal nicht direkt funktioniert. Keine Sorge - Du kannst jederzeit den QR-Code verwenden.',

    TapAndroidHeading: 'Androids “tappen”',
    TapAndroidSubHeading: 'NFC muss aktiviert sein',
    TapAndroidDetailHeading: 'Androids “tappen”',
    TapAndroidDetailSubHeading: 'Jedes Android mit NFC (fast alle)',
    TapAndroidDetailDescription:
      'Der NFC Leser kann sich bei Androids an unterschiedlichen Stellen befinden. Bewege deswegen Deine NFC-Karte von oben nach unten entlang der Rückseite:',
    TapAndroidDetailImportantDescription:
      'Frage Dein Gegenüber, ob dieser sein NFC aktiviert hat. Um NFC zu aktivieren, wische die “Quick Settings” runter und drücke auf den NFC Button.',
    TapAndroidDetailImportantDescription2:
      'Manchmal musst Du in den Telefoneinstellungen nach “NFC” suchen.',
    TapAndroidDetailBackupDescription:
      'Das “Tappen” erfordert etwas Übung und es kann auch vorkommen, dass es mal nicht direkt funktioniert. Keine Sorge - Du kannst jederzeit den QR-Code verwenden.',

    TapScanHeading: 'QR-Code scannen',
    TapScanSubHeading: 'Alle Handys',
    TapScanDetailHeading: 'QR-Code scannen',
    TapScanDetailSubHeading: 'Alle iPhone und Android Handys',
    TapScanDetailDescription:
      'Du findest Deinen QR-Code im Lemontaps Home Dashboard oder auf Deiner Karte aufgedruckt. Die meisten Geräte können den QR-Code einfach mit der Kamera einscannen.',
    TapScanDetailImportantDescription:
      'Du kannst Dir einen Handy- oder Videocallhintergrund mit Deinem QR-Code erstellen, um Deine Lemontaps-Visitenkarte immer dabei zu haben.',
    // How to Tap Strings End //
    contactShareFile: '_Profil',
    contactShareTitle: 'Kontakt',
    contactShareText: 'Digitaler Kontakt von',
    leaveYourContact: 'Hinterlasse Deinen Kontakt',
    submit: 'Jetzt vernetzen',
    profileForwardNotice: 'Hinweis: Dein Profil wird zurzeit direkt auf {{url}} weitergeleitet.',
    downloadContactFile: 'Kontaktdatei herunterladen',
    redirectionActivated: 'Weiterleitung aktiviert',
    vcardDownloadEnabled: 'Automatischer vCard-Download aktiviert',
    updateProfile: {
      autoVCardDownload: {
        title: 'vCard-Download automatisch auslösen',
        helperText:
          'Richte Dein Profil so ein, dass die vCard automatisch heruntergeladen wird. Auf Desktop und Android wird das Profil geöffnet und zeitgleich ein automatischer Download ausgelöst. Beim iPhone öffnet sich dann automatisch der Kontakt, der zum Adressbuch hinzugefügt werden kann.',
      },
    },
    md: {
      requestNow: 'Jetzt anfragen',
      requestNowBullets: [
        'Keine Kreditkarte oder Kündigung erforderlich.',
        'Keine Installation notwendig',
      ],
      profiles: {
        roleUpdated: 'Rolle erfolgreich aktualisiert',
        roleUpdateError: 'Fehler beim Aktualisieren der Rolle',
        sidebar: {
          tabs: {
            tooltipProfile:
              'Hier kannst Du die Profilinformationen dieses Accounts bearbeiten (Name, Telefonnummern, Adressen, etc.).',
            tooltipAccount: 'Hier kannst Du die Login-Email und Rolle bearbeiten.',
            tooltipCards: 'Hier kannst Du Karten zu diesem Account hinzufügen oder entfernen.',
          },
        },
        error: {
          deleteMainAccount: 'Der Team-Owner kann nicht gelöscht werden.',
        },
        resetPasswordDialogTitle: 'Möchtest Du fortfahren?',
        resetPasswordDialogBody:
          'Eine E-Mail mit Schritten zum Zurücksetzen des Passworts wird versendet.',
        resetPasswordSuccess: 'Erfolgreich versendet',
        resetPasswordError: 'Fehler beim Senden der E-Mail zum Zurücksetzen des Passworts',
      },
      bioFieldsConfigurator: {
        title: 'Kontaktattribute',
        description:
          'Attribute auf der digitalen Visitenkarte oder auf der Bearbeitungsseite für Endnutzer ausblenden, löschen, umbenennen, ihre Reihenfolge ändern oder Dropdown-Vorlagen für ausgewählte Felder hinzufügen.',
        internalFields: 'Interne Felder (nie auf der Visitenkarte angezeigt)',
        addAttribute: 'Attribut hinzufügen',
        addAttributeDescription: 'Ein neues Attribut zum Profil hinzufügen',
        renameField: 'Attribut "{{field}}" umbenennen',
        selectAttribute: 'Auswählen',
        nonEditableButtonTooltip: 'Attribut auf der Benutzerbearbeitungsseite ausblenden/anzeigen',
        visibilityButtonTooltip: 'Attribut auf der digitalen Visitenkarte ausblenden/anzeigen',
        deleteButtonTooltip:
          'Attribut aus der Benutzerbearbeitungsseite und der Visitenkarte entfernen (kann jederzeit wieder hinzugefügt werden)',
        editButtonTooltip: 'Attribut bearbeiten',
        fieldOptions: 'Attribut-Optionen',
        fieldOptionsSubtitle:
          'Wenn du übersetzte Werte hinzufügen möchtest, kannst du die Übersetzungsseite verwenden.',
        translations: 'Übersetzungen',
        addDropdownOptions: 'Dropdown-Optionen hinzufügen',
        allowCustomText: 'Erlaube benutzerdefinierte Werte',
        dropdownSettings: 'Dropdown-Einstellungen',
        addOption: 'Option hinzufügen',
        deleteMessage: 'Bist Du sicher, dass Du dieses Attribut löschen möchtest?',
        phoneNumberFormattingSettings: {
          header: 'Telefonnummer-Formatierung',
          includeCountryCode: 'Ländervorwahl erzwingen',
          mode: {
            manual: 'Manuell',
            rule: 'Eigene Regel',
            auto: 'Automatisch',
          },
          manualOptions: {
            digits: '# Ziffernblock',
            digitsLabel: '#Ziffern',
            separator: 'Trennzeichenblock',
            separatorLabel: 'Trennzeichen',
            rest: 'Rest',
            restLabel: 'Rest',
            countryCodeLabel: 'Ländervorwahl',
            areaCode: 'Ortsvorwahl',
            areaCodeLabel: 'Vorwahl',
          },
          separator: {
            space: '[ ] Leerzeichen',
            dot: '[.] Punkt',
            hyphen: '[-] Bindestrich',
            slash: '[/] Schrägstrich',
          },
          includeCountryCodeWarning:
            'Die automatische Formatierung ist nicht möglich, wenn keine Ländervorwahl eingegeben wird.',
          ruleNotApplicableWarning:
            'Wenn eine Nummer zu wenige oder zu viele Ziffern hat und die Regel dadurch nicht angewendet werden kann, wird die Nummer unformatiert angezeigt.',
        },
        groups: {
          headerFields: 'Header Felder',
          contactDetailsBoxFields: 'Kontakt Details Box Felder',
          customBioTextBoxFields: 'Benutzerdefinierte Bio Text Box Felder',
          otherFields: 'Sonstige Felder',
        },
      },
      vcardConfigurator: {
        title: 'vCard Konfigurator',
        description:
          'Die vCard ist die Kontaktdatei, die heruntergeladen wird, wenn auf „Kontakt speichern“ geklickt wird oder wenn der Offline-QR-Code geteilt wird. Du kannst einige der Einstellungen hier bearbeiten.',
        contactInfoTitle: 'Konfiguration der Kontaktinformationen',
        contactInfoDescription:
          'Entscheide, ob bestimmte Felder in der vCard ausgeblendet oder die Bezeichnung des Attributs geändert werden soll. Beachte, dass es vorkommen kann, dass die benutzerdefinierten Bezeichnungen teilweise nicht angezeigt werden (insbesondere bei Android oder Outlook). Sie werden mit Standardlabel wie z.B. "Sonstige" zufällig ersetzt.',
        chooseLabel: 'Bezeichnung auswählen',
        createLabel: 'Bezeichnung erstellen',
        editLabel: 'Bezeichnung bearbeiten',
        createCustomLabel: 'Benutzerdefinierte Bezeichnung erstellen',
        customLabel: 'Bezeichnung',
        customLabelInfo: 'Setze eine beliebige Bezeichnung oder wähle aus den Vorlagen.',
        notes: 'Notizen',
        notesGerman: 'Notizen (Deutsch)',
        notesEnglish: 'Notizen (Englisch)',
        notesTooltip:
          'Konfiguriere einen benutzerdefinierten Text, der im Abschnitt "Notizen" des heruntergeladenen Kontakts enthalten sein wird. Du kannst "{{currentDate}}" als Variable verwenden, die beim Herunterladen der vCard durch das aktuelle Datum ersetzt wird. Außerdem kannst du "{{profileLink}} verwenden, was mit dem Profillink ersetzt wird.',
        additionalSettings: 'Zusätzliche Einstellungen',
        showLinks: 'Alle Profillinks anzeigen',
        showLinksTooltip: 'Zeige die Profillinks in den heruntergeladenen Kontakten an.',
        showLinksOffline: 'Auch in Offline QR-Code alle Profillinks anzeigen',
        showLinksOfflineTooltip:
          'Nur empfohlen, wenn ihr nicht viele Links auf den Profilen habt, da der QR-Code sonst schwerer lesbar wird.',
        convertSpecialChars: 'Sonderzeichen in vCard konvertieren',
        convertSpecialCharsTooltip:
          'Ersetze Sonderzeichen wie ä, ö, ü mit ae, oe, ue, da manche Outlook Versionen die Sonderzeichen beim Import nicht lesen können.',
        samelLabelOutlookWarning:
          'Um maximale Kompatibilität zu erreichen, sollten gleichartige Attribute (E-Mails, Telefonnummern, Adressen) unterschiedliche Bezeichnungen haben, da es insbesondere bei Outlook  zu fehlerhaften Imports kommen kann.',
        sameLabelEmailWarning:
          '{{fields}} haben dieselbe Bezeichnung oder beide eine benutzerdefinierte Bezeichnung. Der Import in Outlook schlägt möglicherweise fehl!',
        sameLabelAddressWarning:
          '{{fields}} haben dieselbe Bezeichnung oder beide eine benutzerdefinierte Bezeichnung. Beim Import in Outlook wird möglicherweise nur eine der beiden Adressen angezeigt!',
        sameLabelLinkWarning:
          '{{fields}} haben dieselbe Bezeichnung oder beide eine benutzerdefinierte Bezeichnung. Beim Import in Outlook wird möglicherweise nur einer der Links angezeigt!',
        show: 'Feld "{{field}}" in vCard anzeigen',
        doNotShow: 'Feld "{{field}}" nicht in vCard anzeigen',
      },
      defaultContent: {
        noFiles: 'Für die aktuelle Unit sind keine Standard-Dateien konfiguriert.',
        noLinks: 'Für die aktuelle Unit sind keine Standard-Links konfiguriert.',
        noAddresses: 'Für die aktuelle Unit sind keine Standard-Addressen konfiguriert.',
        noBioContent: 'Für die aktuelle Unit sind keine Standard-Profilattribute konfiguriert.',
        defaultLinks: 'Standard-Links',
        defaultLink: 'Standard-Link',
        defaultFiles: 'Standard-Dateien',
        defaultFile: 'Standard-Datei',
        description: 'Hier kannst Du die Standardinhalte für Deine Mitarbeiter:innen festlegen.',
        errorLoadingFiles: 'Fehler beim Laden der Standarddateien',
        successSaveFile: 'Dateien erfolgreich gespeichert',
        errorSavingFiles: 'Fehler beim Speichern der Dateien',
        successDeleteFile: 'Datei erfolgreich gelöscht',
        errorDeleteFile: 'Fehler beim Löschen der Datei',
        errorLoadingLinks: 'Fehler beim Laden der Standardlinks',
        successSaveLink: 'Links erfolgreich gespeichert',
        errorSavingLink: 'Fehler beim Speichern der Links',
        successDeleteLink: 'Link erfolgreich gelöscht',
        errorDeleteLink: 'Fehler beim Löschen des Links',

        addAddress: 'Standard-Adresse hinzufügen',
        editAddress: 'Standard-Adresse bearbeiten',
        defaultAddresses: 'Standard-Adressen',
        errorLoadingAddress: 'Fehler beim Laden der Standardadressen',
        successSaveAddress: 'Standardadressen erfolgreich gespeichert',
        errorSavingAddress: 'Fehler beim Speichern der Standardadressen',
        successDeleteAddress: 'Standardadressen erfolgreich gelöscht',
        errorDeleteAddress: 'Fehler beim Löschen der Standardadressen',

        addBioContent: 'Standard-Profilattribut hinzufügen',
        editBioContent: 'Standard-Profilattribut bearbeiten',
        defaultBioContent: 'Standard-Profilattribute',
        defaultBioContentTooltip:
          'Die hier konfigurierten Werte werden in allen Profilen angezeigt, ungeachtet aller vorherigen Konfigurationen auf Profilebene.',
        selectAttribute: 'Attribut auswählen',
        setDefaultContent: 'Standard-Inhalt festlegen',
        errorLoadingDefaultBioContent: 'Fehler beim Laden der Standard-Profilattribute',
        successUpdateBioContent: 'Standard-Profilattribute erfolgreich aktualisiert',
        errorUpdateBioContent: 'Fehler beim Aktualisieren der Standard-Profilattribute',
        deleteBioContentConfirm: 'Möchtest Du das Standard-Profilattribut wirklich löschen?',
        defaultBioContentAlert:
          'Nachdem Du ein Standard-Profilattribut löschst, werden in den Profilen ggf. wieder Werte angezeigt, die vor Konfiguration des Standardwerts angelegt wurden. Um das Feld für alle Profile zu leeren, gehe zur Profiltabelle, wähle alle Profile aus, und gehe dann auf "Bearbeiten".',
        setupSettings: {
          links: {
            title:
              'Derzeit sind die Standard-Links dieser Unit mit den global Einstellungen synchron.',
            description:
              'Du kannst Standard-Links für diese Unit festlegen, anschließend hat diese Unit eine eigene Konfiguration, die nicht mehr synchron mit den globalen Einstellungen ist.',
            buttonText: 'Standard-Links für diese Unit festlegen',
          },
          files: {
            title:
              'Derzeit sind die Standard-Dateien dieser Unit mit den global Einstellungen synchron.',
            description:
              'Du kannst Standard-Dateien für diese Unit festlegen, anschließend hat diese Unit eine eigene Konfiguration, die nicht mehr synchron mit den globalen Einstellungen ist.',
            buttonText: 'Standard-Dateien für diese Unit festlegen',
          },
          addresses: {
            title:
              'Derzeit sind die Standard-Addressen dieser Unit mit den global Einstellungen synchron.',
            description:
              'Du kannst Standard-Addressen für diese Unit festlegen, anschließend hat diese Unit eine eigene Konfiguration, die nicht mehr synchron mit den globalen Einstellungen ist.',
            buttonText: 'Standard-Adressen für diese Unit festlegen',
          },
          bioContent: {
            title:
              'Derzeit sind die Standard-Profilattribute dieser Unit mit den global Einstellungen synchron.',
            description:
              'Du kannst Standard-Profilattribute für diese Unit festlegen, anschließend hat diese Unit eine eigene Konfiguration, die nicht mehr synchron mit den globalen Einstellungen ist.',
            buttonText: 'Standard-Profilattribute für diese Unit festlegen',
          },
        },
      },
      contentTemplate: {
        linkTemplates: 'Linkvorlagen',
        fileTemplates: 'Dateivorlagen',
        addressTemplates: 'Addressvorlagen',
        description:
          'Erstelle Inhaltsvorlagen für Adressen, Links und Dateien, aus denen Du als Administrator:in bei der Bearbeitung von Profilen auswählen kannst. Wenn Du die Vorlage aktualisierst, erhalten alle Profile, die diese Vorlage verwenden, diese Aktualisierung. ',
        errorLoadingFiles: 'Fehler beim Laden der Dateivorlagen',
        successSaveFile: 'Dateivorlage erfolgreich gespeichert',
        errorSavingFile: 'Fehler beim Speichern der Dateivorlage',
        successDeleteFile: 'Dateivorlage erfolgreich gelöscht',
        errorDeleteFile: 'Fehler beim Löschen der Dateivorlage',

        errorLoadingLink: 'Fehler beim Laden der Linkvorlagen',
        successSaveLink: 'Linkvorlage erfolgreich gespeichert',
        errorSavingLink: 'Fehler beim Speichern der Linkvorlage',
        successDeleteLink: 'Linkvorlage erfolgreich gelöscht',
        errorDeleteLink: 'Fehler beim Löschen der Linkvorlage',

        errorLoadingAddress: 'Fehler beim Laden der Adressvorlagen',
        successSaveAddress: 'Adressvorlage erfolgreich gespeichert',
        errorSavingAddress: 'Fehler beim Speichern der Adressvorlage',
        successDeleteAddress: 'Adressvorlage erfolgreich gelöscht',
        errorDeleteAddress: 'Fehler beim Löschen der Adressvorlage',
      },
      profileDesign: {
        customCss: {
          label: 'Benutzerdefiniertes CSS',
          tooltip:
            'Füge benutzerdefiniertes CSS hin, um das Design der digitalen Visitenkarte zu verändern.',
          customCssClasses: 'Wähle CSS Klasse',
        },
        previewTooltip: 'Speicher zuerst deine Änderungen und klicke dann auf Vorschau',
        freeToChoose: 'Aktuelle Einstellung: Mitarbeiter:innen dürfen frei Titelbilder hochladen',
        boxFormTooltip: 'Lege das Erscheinungsbild aller rechteckigen Elemente fest.',
        uploadImageTooltip:
          'Wenn keine Bilder hochgeladen werden, können die Mitarbeiter:innen ihr Titelbild frei wählen. Bei Upload von einem oder mehreren Bildern werden Deine Mitarbeiter:innen eine Auswahl dieser Bilder sehen, von denen sie eines auswählen müssen. Dann kann kein Bild mehr frei hochgeladen werden.',
        buttonColorSaveContactTooltip:
          'Farbe des "Kontakt speichern" und des "Jetzt vernetzen" Buttons.',
        buttonColorFilesTooltip: 'Farbe der Datei Boxen.',
        buttonColorGenericWebsitePicker: 'Farbe der generischen Website-Button.',
        coverImageTooltip:
          'Legt das Standard-Titelbild fest, wenn kein individuelles Titelbild für den Benutzer hochgeladen wurde. Du kannst auch festlegen, dass kein Titelbild angezeigt werden soll. Beim Aktualisieren des Standard-Titelbilds werden nur die Profile ohne individuelles Titelbild aktualisiert.',
        faviconImageTooltip: 'Legt das Standard-Favicon fest.',
        profileImageTooltip:
          'Legt den Standard-Avatar fest, wenn kein individuelles Profilbild für den Benutzer hochgeladen wurde. Du kannst auch entscheiden, dass kein Avatar angezeigt werden soll. Beim Aktualisieren des Avatars werden nur die Profile ohne individuelles Profilbild aktualisiert.',
        logoImageTooltip:
          'Wenn diese Option leer ist, können Nutzer:innen ein selbst ausgewähltes Bild als Logo hochladen. Sobald diese Option durch ein Bild gesetzt ist, wird dieses Bild bei jedem Profil als Logo dargestellt, und Nutzer:innen können kein eigenes Bild mehr hochladen.',
        faviconTitle: 'Benutzerdefiniertes Favicon',
        useCustomFavicon: {
          title: 'Benutzerdefiniertes Favicon verwenden',
          tooltip: 'Verwende ein benutzerdefiniertes Favicon im Browser-Tab.',
        },
        defaultFavicon: 'Standard Favicon',
        showForm:
          'Wenn Du diese Funktion deaktivierst, wird das Kontakterfassungsformular im digitalen Visitenkartenprofil nicht mehr angezeigt.',
        showFormAsPopup:
          'Wenn Du diese Funktion aktivierst, dann wird beim öffnen Deines digitalen Visitenkartenprofils das Kontakterfassungsformular direkt als erstes in Form eines Popups angezeigt. Diese Funktion ist hilfreich auf Events, um schnell und einfach die Kontaktinformationen des Gegenübers zu erfassen.',
        themeLinks: {
          tooltip:
            'Die Standard-Links werden auf allen Profilen Deiner Mitarbeiter:innen angezeigt ohne dass diese sie bearbeiten oder löschen können',
          title: 'Position Standardlinks',
          question: 'Konfiguriere hier die Position der Standard-Links',
        },
        themeLinksPosition: {
          before: 'Vor den individuellen Links',
          after: 'Nach den individuellen Links',
          question: 'Wo sollen die Standard-Links angezeigt werden?',
        },
        themeFiles: {
          tooltip:
            'Die Standard-Dateien werden auf allen Profilen Deiner Mitarbeiter:innen angezeigt ohne dass diese sie bearbeiten oder löschen können',
          title: 'Position Standarddateien',
          question: 'Konfiguriere hier die Position der Standard-Dateien',
        },
        themeFilesPosition: {
          before: 'Vor den individuellen Dateien',
          after: 'Nach den individuellen Dateien',
          question: 'Wo sollen die Standard-Dateien angezeigt werden?',
        },
        themeAddresses: {
          tooltip:
            'Die Standard-Adressen werden auf allen Profilen Deiner Mitarbeiter:innen angezeigt ohne dass diese sie bearbeiten oder löschen können',
          title: 'Position Standard-Adressen',
          question: 'Konfiguriere hier die Position der Standard-Adressen',
          settingHasMoved:
            'Die Einstellung wurde in den "Kontaktattribute" Abschnitt verschoben. Bitte aktualisiere Deine Einstellungen dort.',
        },

        linksTooltip: 'Du kannst Linkvorlagen setzen unter Einstellungen -> Globale Firmen Daten',
        filesTooltip: 'Du kannst Dateivorlagen setzen unter Einstellungen -> Globale Firmen Daten',
        additionalLogosTitle: 'Zusätzliche Logos',
        additionalLogosTooltip:
          'Wenn keine Bilder hochgeladen werden, können die Mitarbeiter:innen ihr Logo frei wählen. Bei Upload von einem oder mehreren Bildern werden Deine Mitarbeiter:innen eine Auswahl dieser Bilder sehen, von denen sie eines auswählen müssen. Dann kann kein Bild mehr frei hochgeladen werden',
        additionalLogosDescription:
          'Lade Logos hoch, aus denen die Mitarbeiter:innen auswählen müssen',
        additionalLogosUploadButton: 'Logo hochladen',
        additionalLogosUploadFurtherButton: 'Weiteres Logo hochladen',
        additionalLogosCurrentSettings:
          'Aktuelle Einstellung: Mitarbeiter:innen können ihr Logo frei wählen',
        additionalLogosDefaultLogoIsSet:
          'Aktuelle Einstellung: Ein globales Logo wird auf jedem Profil angezeigt. Entferne das oben festgelegte Standardlogo, damit Du hier mehrere Logos hochladen kannst.',
        moreSettings: 'Weitere Einstellungen',
        nameSuffixConnector: 'Namenssuffix-Konnektor',
        nameSuffixConnectorTooltip:
          'Wie soll der Name mit dem Suffix verbunden werden? Bspw. kann er durch ein Komma verbunden sein.',
        autoVCardDownload: {
          title: 'vCard-Download automatisch auslösen',
          tooltip:
            'Beim Öffnen des Profils wird die vCard automatisch heruntergeladen. Auf Desktop und Android wird das Profil geöffnet und zeitgleich ein automatischer Download ausgelöst. Beim iPhone öffnet sich dann automatisch der Kontakt und kann zum Adressbuch hinzugefügt werden.',
          alertDescription: 'Alle Profile lösen einen automatischen vCard-Download aus.',
          goToSetting: 'Zur Einstellung',
        },
        showLeftBorder: {
          title: 'Gestrichtelten Rand anzeigen (links)',
          tooltip: 'Wenn aktiviert, wird links des Namens eine gestrichelte Linie angezeigt',
        },
        fonts: {
          useCustomFont: 'Benutzerdefinierte Schriftart verwenden',
          familyName: 'Font Family Name',
          fileUploadDescription:
            'Lade die entsprechenden Schriftart-Dateien für die folgenden Varianten hoch. Nur {{requiredVariants}} werden zurzeit auf der Profilseite verwendet,aber Du kannst bereits mehr Varianten hochladen, da sich das in Zukunft ändern könnte.',
          variants: {
            normal: {
              300: 'Normal 300',
              400: 'Normal 400',
              500: 'Normal 500',
              600: 'Normal 600',
              700: 'Normal 700',
              800: 'Normal 800',
            },
            italic: {
              300: 'Kursiv 300',
              400: 'Kursiv 400',
              500: 'Kursiv 500',
              600: 'Kursiv 600',
              700: 'Kursiv 700',
              800: 'Kursiv 800',
            },
          },
          warnings: {
            preferredFormatsNotDefined: 'Weder WOFF- noch WOFF2-Format definiert',
            preferredFormatsNotDefinedDetails:
              'Um eine gute Browser- und Gerätekompatibilität zu erreichen, solltest Du mindestens eines der beiden Formate hinterlegen.',
            invalidFontFile: 'Format ungültig',
          },
          googleFontInfo:
            'Diese Schriftart ist eine Google Font. Beim Auswählen dieser Schriftart werden Google-Server referenziert. Bitte beachte, dass Du möglicherweise Deine Datenschutzerklärung anpassen musst, um dies zu berücksichtigen.',
          adobeFontInfo:
            'Diese Schriftart ist eine Adobe Font. Beim Auswählen dieser Schriftart werden Adobe-Server referenziert. Bitte beachte, dass Du möglicherweise Deine Datenschutzerklärung anpassen musst, um dies zu berücksichtigen.',
          manualFontInfo:
            'Um die Schriftart zu ändern, kontaktiere uns unter support@lemontaps.com',
        },
      },
      customizationFooter: {
        mainTooltip:
          'Die hier einzutragenden Informationen werden im Footer des öffentlichen Profils angezeigt.',
      },
      editEmployee: {
        settings: 'Profil-Einstellungen',
        autoVCardDownload: {
          title: 'vCard-Download automatisch auslösen',
          helperText:
            'Beim Öffnen des Profils wird die vCard automatisch heruntergeladen. Auf Desktop und Android wird das Profil geöffnet und zeitgleich ein automatischer Download ausgelöst. Beim iPhone öffnet sich dann automatisch der Kontakt und kann zum Adressbuch hinzugefügt werden.',
          alertDescription:
            'Beim Öffnen des Profils wird automatisch ein vCard-Download ausgelöst. Um die Funktion zu deaktivieren, öffne die Profil-Einstellungen.',
          alertDescriptionEnabledGlobally:
            'Beim Öffnen des Profils wird automatisch ein vCard-Download ausgelöst. Die Einstellung ist global aktiv. Um sie zu deaktivieren, öffne die Profildesigneinstellungen.',
        },
      },
    },
    preview: 'Vorschau',
    home: 'Home',
    profile: 'Profil',
    contacts: 'Kontakte',
    mdCards: {
      title: 'Karten',
      upgradeToContinue:
        'Leider kannst Du diese Aktion nicht während der Testphase auswählen. Bitte führe ein Upgrade durch, um fortzufahren.',
      noBoxThemeAdmin:
        'Kontaktiere uns um auf dieser Seite Optionen zu sehen, mit der Du NFC-Karten bestellen kannst.',
      noBoxUnitAdmin:
        'Dein Administrator hat ausgeschaltet, von dieser Seite aus neue Karten zu bestellen.',
      order: {
        title: 'NFC-Karten bestellen',
        imageAlt: 'Darstellung von physischen NFC-Karten',
        body: 'Bestelle kostenlose Musterkarten, bestelle weitere Karten mit dem bisherigem Design nach oder bestelle NFC-Karten mit einem neuen Design.',
        actionLabel: 'NFC-Karten bestellen',
        subaction: {
          sampleCards: {
            label: 'Musterkarten bestellen',
            tooltip:
              'Du kannst kostenlos Musterkarten bestellen mit einem Beispieldesign. Die Karten müssen nach dem Test zurückgesendet werden.',
          },
          firstTimeOrder: {
            label: 'Karten erstmalig bestellen',
            tooltip: 'Wenn sich dein Design ändern sollte oder du Karten zum ersten Mal bestellst.',
          },
          reorder: {
            label: 'Karten mit letztem Design nachbestellen',
            tooltip:
              'Wenn du bereits Karten bestellt hast, haben wir dein Design bereit. Du musst nur noch ein Bestellformular ausfüllen.',
          },
        },
        byCountryPopup: {
          title: 'Zielland',
          other: 'In ein anderes Land? Bitte kontaktiere support@lemontaps.com.',
        },
      },
      paperCardsBox: {
        title: 'Papiervisitenkartenbestellsystem',
        description:
          'Verwalte die Administratoreneinstellungen des Papiervisitenkartenbestellsystems, wie bspw. Freigabeprozesse. Du kannst auch neue Papiervisitenkarten für deine Mitarbeiter:innen bestellen.',
        teaserDescription:
          'Wenn Du nicht vollständig auf digitale Visitenkarten umsteigen willst, kannst Du das Bestellsystem für Papiervisitenkarten hinzufügen, mit dem Du die Druckdateien einfach erstellen und automatisch an Deinen Druckdienstleister senden lassen kannst.',
        imageAlt: 'Eine Papiervisitenkarte',
        buttonText: 'Papiervisitenkarten verwalten',
        actions: {
          approval: 'Zum Freigabeportal',
          order: 'Bestellung für Mitarbeiter:in',
          buyAddon: 'Addon kaufen',
        },
      },
    },
    nfcSample: {
      title: 'Musterkarten bestellen',
      subtitle:
        'Probiere unsere NFC-Karten aus. Die Musterkarten kannst Du kostenlos bestellen, wenn Du diese wieder zurücksendest.',
    },
    nfcFirstOrder: {
      title: 'Karten erstmalig bestellen',
      subtitle:
        'Als Teams Nutzer stehen Dir vergünstigte Kartenpreise zur Verfügung. Gestalte die Karten passend zu Deinem Corporate Design.',
    },
    nfcReorder: {
      title: 'Karten mit letztem Design nachbestellen',
      subtitle:
        'Hier hast Du die Möglichkeit einfach weitere Karten nachzubestellen mit demselben Design Deiner letzten Bestellung.',
    },
    settings: {
      main: 'Account-Einstellungen',
      more: 'Mehr',
      managementPlatform: 'Management Plattform',
      changePassword: 'Passwort ändern',
      changeEmail: 'Registrierungs-E-Mail ändern',
      help: 'Hilfe & Support',
      helpCaption: 'Hilfe-Center, Akademie, Support',
      openCookieSettings: 'Cookie-Einstellungen ändern',
      openShopSettings: 'Zu unserem Shop',
      openPaperCardForm: 'Papiervisitenkarte bestellen',
      mycards: 'Karten verwalten',
      changeLanguage: 'Account-Sprache ändern',
      selectLanguage: 'Sprache auswählen',
      paperCardOrder: 'Druckversion',
      paperCardOrderCaption: 'Papiervisitenkarten bestellen',
    },
    moreSettings: {
      title: 'Mehr',
      teamMangement: 'Team-Management',
      teamMangementCaption: 'Verwalte die digitalen Profile Deines Teams',
      analytics: 'Analytics',
      analyticsCaption: 'Profil- & Nachhaltigkeitsstatistiken',
      addApp: 'Homescreen-App',
      addAppCaption: 'Füge ein App-Icon auf dem Homescreen hinzu',
      accountSettings: 'Account-Einstellungen',
      accountSettingsCaption: 'Email oder Passwort ändern',
      nfcCards: 'NFC-Karten',
      nfcCardsCaption: 'Verbinde, verwalte, oder bestelle Karten',
      printCard: 'Papier-Visitenkarte',
      printCardCaption: 'Bestelle neue Papiervisitenkarten',
      signOut: 'Abmelden',
    },
    changeEmail: {
      title: 'Registrierungs-E-Mail ändern',
      currentEmail: 'Aktuelle E-Mail-Adresse',
      newEmail: 'Neue E-Mail-Adresse',
      notAllowed: {
        title: 'E-Mail kann nicht geändert werden',
        text: 'Du bist via {{idp}} authentifiziert und kann daher Deine E-Mail-Adresse hier nicht ändern. Wenn Du dich mit einer anderen Adresse registrieren möchtest, lösche diesen Account und registriere Dich erneut oder kontaktiere einen Administrator.',
      },
      error: {
        invalidFormat: 'Ungültiges Format',
        unchanged: 'E-Mail ist unverändert',
      },
    },
    homePage: {
      toAcademy: 'Zur Academy',
      digitalBusinessCard: 'Digitale Visitenkarte',
      shareProfile: {
        title: 'Profil teilen',
        copyToShare: 'Zum Teilen kopieren',
        actionTitle: 'Alle Optionen anzeigen',
        via: 'per Link, QR-Code, Wallet...',
      },
      addAppToPhone: {
        title: 'App herunterladen',
        popupTitle: 'Lemontaps App herunterladen',
        description:
          'Suche nach "Lemontaps" im App Store/Google Play Store oder scanne den QR-Code:',
      },
      nfcCard: {
        addAndManage: 'NFC-Karten',
        title: 'NFC-Karte',
        allAboutNFC: 'Alles rund um die NFC-Karte',
        manageCards: 'Karten verwalten',
        manageCardsSub: 'Verknüpfe neue Karten oder entferne sie.',
        instruction: 'Anleitung',
        instructionSub:
          'Lerne die best practices, wie man die Karte mit verschiedenen Handys “tapped”.',
        buyNew: 'Neue Karte kaufen',
        buyNewSub:
          'Gestalte die Karte mit Deinem Design. Erhältlich in Bambus, Metall und Kunststoff.',
        multiTitle: 'Entdecke unsere NFC-Karten',
        multiText:
          'Verknüpfe deine NFC-Karte oder gestalte eine neue Karten mit Deinem Design. Erhältlich in Bambus, recyceltem Kunststoff und Metall.',
        btnText: 'Zum Shop',
      },
      leads: {
        recentContacts: 'Neue Kontakte',
        title: 'Leads erfassen',
        manage: 'Zum Kontaktmanagement',
        previewForm: 'Lead-Formular auf meinem Profil ansehen',
      },
      analytics: {
        title: 'Analytics',
        profileViews: 'Profilaufrufe',
        leadsCollected: 'Erfasste Kontakte',
      },
      academy: {
        title: 'Erste Schritte & Academy',
        popupTitle: 'Die Lemontaps Academy ist in Deinem aktuellen Plan nicht verfügbar',
        popupText:
          'Die Lemontaps Academy ist eine Sammlung von Einführungs- und Best-Practice-Videos, beispielsweise zur Verwendung von Lemontaps auf Messen oder bei Einzelgesprächen.\nDiese Funktion ist ein Add-On und in Deinem aktuellen Plan nicht verfügbar.',
      },
      support: {
        title: 'Deine Kontaktperson',
        admin: 'Dein Admin',
        lemontapsSupport: 'Lemontaps Support Team',
      },
      quickActions: {
        title: 'Weitere schnelle Aktionen',
        getApp: 'App herunterladen',
        nfcCards: 'NFC-Karten',
        analytics: 'Analytics',
        scanCard: 'Karte einscannen',
      },
      viewAll: 'Alle ansehen',
      learnMore: 'Mehr erfahren',
      hello: 'Hallo',
      addLemontapsAsAnApp: 'Lemontaps als Homescreen App hinzufügen',
      addAppToHomescreen:
        'Du kannst Lemontaps als App auf Ihren Homescreen hinzufügen. So hast Du immer einfachen Zugang zu Deinem Profil.',
      exampleForIphone: 'Beispiel für iPhone (Android ist ähnlich):',
      gotIt: 'Verstanden!',
      shareProfilePer: 'Profil teilen per...',
      addQrWallpaper: 'QR-Hintergründe erstellen',
      qrCodeWallpaper: 'QR-Code Hintergrund',
      subTitle:
        'Entdecke die verschiedenen Möglichkeiten, wie Du Dein Lemontaps-Profil nutzen kannst:',
      qrTitle: 'QR-Hintergrund',
      qrText: 'Teile Dein Lemontaps-Profil per Handy oder Videokonferenz',
      qrBtnText: 'Hintergründe erstellen',
      shareLink: 'Link teilen',
      shareYourLink: 'Teile Deinen Link',
      tip: '💡Tipp: ',
      tipText: 'Kopiere und füge den Link in Deine Email Signatur ein.',
      qrCode: 'QR-Code',
      profileViews: 'Analytics',
      overviewProfileViews: 'Überblick Profilansichten',
      total: 'Gesamt:',
      thisWeek: 'Diese Woche:',
      howToTap: ' Wie teile ich?',
      help: 'Hilfe',
      desktopSubTxt:
        'Entdecke die verschiedenen Möglichkeiten, wie Du Dein Lemontaps-Profil nutzen kannst:',
      copyLink: 'Profil-Link kopieren',
    },
    leadGen: {
      sendFollowUpEmail: 'Follow-Up E-Mail versenden',
      followUpEmailSent: 'Follow-Up E-Mail erfolgreich versendet',
      followUpEmailError: 'Follow-Up E-Mail konnte nicht versendet werden',
      followUpEmailErrorNoEmail: 'Der Kontakt hat keine E-Mail-Adresse',
      upgradeTitle: 'Jetzt upgraden!',
      upgradeText:
        'Hole Dir jetzt das Lead Generation Feature und sieh alle Deine gesammelten Kontakte!',
      upgradeBtnText: 'Mehr erfahren',
      upgradeBtnClickedText: 'Anfrage gesendet',
      noLeads: 'Keine Kontakte bisher gesammelt.',
      infoFromProfile: 'Informationen vom Profil',
      infoFromContact: 'Informationen vom Kontakt',
      lt2ltNotFound: 'Hoppla! Profil nicht gefunden 🙈',
      uploadNew: 'Neue Datei hochladen',
      businessCardTitle: 'Physische Visitenkarte',
      businessCardSubtitle: 'Lade ein Foto einer Papiervisitenkarte hoch',
      dontShowAgain: 'Nicht mehr anzeigen',
      connectToNfc: 'Mit NFC-Karte verbinden?',
      newFeatureEnrichment: {
        title: '🚀 Neues Beta-Feature: Badge & LinkedIn-Scanner + Enrichment',
        text1: 'Teste jetzt kostenlos unser Tool zur automatisierten Kontaktanreicherung!',
        text2:
          '📌 Hinweis: Nach der Beta-Phase wird das Feature als kostenpflichtiges, optionales Add-on verfügbar sein.',
      },
      noEnrichmentFoundAlert: {
        title: 'Enrichment fehlgeschlagen',
        body: 'Keine weiteren Kontaktinformationen gefunden',
      },
      attachments: {
        unsupportedFile: 'Nicht unterstützter Dateityp. Unterstützte Formate: {{supportedFormats}}',
      },
    },

    showQr: {
      pageTitle: 'QR-Code',
      online: 'online',
      offline: 'offline',
      btnTxt: 'QR-Code herunterladen',
      cardHeadTxt: 'Tipp: ',
      cardDiscTxtOn: 'Benutze den QR-Code in Präsentationen.',
      cardDiscTxtOf:
        'Der Offline QR-Code funktioniert ohne Internet. Durch Scannen wird der Kontakt direkt geöffnet, nicht das Online-Profil.',
      downloadSuccess: 'Erfolgreich heruntergeladen',
      downloadError: 'Bitte aktualisiere die Seite und probiere es noch einmal',
      downloadQrBgsError: 'Du musst erst ein Standard-Bild in den Einstellungen festlegen',
      downloadQrBgsErrorMaxAllowed: 'Es können maximal {{max}} Profile ausgewählt werden.',
    },
    datePicker: {
      options: {
        title: 'Zeitraum wählen',
        today: 'Heute',
        pastWeek: 'Letzte Woche',
        pastMonth: 'Letzter Monat',
        past90Days: 'Letzte 90 Tage',
        pastYear: 'Letztes Jahr',
        allTime: 'Gesamter Zeitraum',
      },
      heading: {
        startDate: 'Startdatum',
        endDate: 'Enddatum',
      },
    },
    analytics: {
      options: {
        title: 'Periode wählen',
        today: 'Heute',
        pastWeek: 'Letzte Woche',
        pastMonth: 'Letzter Monat',
        past90Days: 'Letzte 90 Tage',
        pastYear: 'Letztes Jahr',
        allTime: 'Gesamter Zeitraum',
      },
      saves: {
        title: '🌱 Du bist ein:e nachhaltige:r Leader:in, bis jetzt hast Du schon gespart:',
        cards: 'Papierkarten',
        flyers: 'Flyerseiten',
        subtitle: '... und damit:',
        wood: '🪵 Holz',
        water: '💧 Wasser',
        energy: '🔋 Energie',
        co2: '☁️ CO2',
      },
      networking: {
        title: '{{firstName}}, Du bist ein:e echte:r Networker:in!',
        titleSmall: 'Deine Networking Statistik',
        shares: 'Profile geteilt',
        contacts: 'Leads erfasst',
        vcards: 'vCard gespeichert',
        edits: 'Bearbeitungen',
      },
      clicks: {
        unit_one: '{{count}} Klick',
        unit_other: '{{count}} Klicks',
        title: 'An die Details:',
        links: 'Link Klicks Insgesamt',
        files: 'Datei Klicks Insgesamt',
        oldFileClicks: 'Clicks auf alte Dateien',
        oldLinkClicks: 'Clicks auf alte Links',
      },
      tooltips: {
        vcards: 'So oft wurde der "Kontakt speichern" Button auf Deinem Profil geklickt.',
        edits:
          'Als eine Profilbearbeitung zählt jede Änderung in Deinem Profil (Kontaktinformationen, Bilder, Dateien oder Links). Pro 7-Tage Periode wird höchstens eine Bearbeitung gezählt.',
        contacts: 'So viele Kontakte hast Du erfasst.',
        shares: 'So oft hast Du dein Profil geteilt.',
        cards:
          'Anzahl der Papierkarten, die dafür eingespart wurden, dass Du Dein Profil digital geteilt hast oder einen digitalen Kontakt eingesammelt hast.',
        flyers:
          'Anzahl der Papierseiten, die dadurch eingespart wurden, dass Du anstatt eines Papier-Ausdrucks eine digitale Version genutzt hast (bspw. PDF-Dateien statt Papier-Flyer).',
      },
      share: {
        share: 'Teilen',
        dialogTitle: 'Teile deine Statistiken',
        title: 'Meine nachhaltigen Networking Statistiken',
        text: 'Mein Impact mit meiner digitalen und nachhaltigen Visitenkarte von Lemontaps:\n\n🎫   {{cards}} gesparte Papiervisitenkarten\n📃   {{flyers}} gesparte Flyer\n🪵   {{wood}}kg gespartes Holz\n💧   {{water}}l gespartes Wasser\n🔌   {{energy}}kWh gesparte Energie\n🌫️   {{co2}}kg gespartes CO2 \n\nWerde jetzt Teil der Networking Revolution und sei ein digitaler und nachhaltiger Vorreiter! Registriere dich jetzt selber kostenlos bei Lemontaps!',
      },
    },
    loginOrRegister: {
      title: 'Diese Karte ist mit keinem Visitenkartenprofil verbunden',
      connectNew: 'Neues Profil erstellen',
      connectExisting: 'Karte mit bestehendem Profil verknüpfen',
      linkAsAdmin: 'Als Administrator verknüpfen',
    },
    linkCode: {
      noProfilesFound: 'Keine Profile gefunden',
      searchBy: 'Suchen in',
      selectProfile: 'Profil auswählen',
      searchProfile: 'Profil suchen',
      close: 'Schließen',
      name: 'Name',
      editDate: 'Bearbeitungsdatum',
      createDate: 'Erstellungsdatum',
      sortBy: 'Sortieren nach',
      sortOrder: 'Sortierreihenfolge',
      asc: 'Aufsteigend',
      desc: 'Absteigend',
      filter: 'Filter',
      withoutNFC: 'Nur ohne verknüpfte Karte',
      successLinkTitle: 'Du hast die NFC-Karte erfolgreich mit dem ausgewählten Profil verknüpft.',
      successLinkSubTitle: 'Öffne jetzt die Kamera, um die nächste Karte zu scannen.',
      errorLinkTitle: 'Fehler beim Verknüpfen',
      tryAgain: 'Bitte versuche es noch einmal.',
      dontShowAgain: 'Nicht mehr anzeigen',
      confirmLinkText:
        'Bist Du sicher, dass Du das ausgewählte Profil mit der NFC-Karte verknüpfen möchten?',
      connectToNfc: 'Mit NFC-Karte verbinden?',
    },
    mainAdminOnboarding: {
      video: {
        title: 'Willkommen zur Vollversion von Lemontaps',
        description:
          'Dein Customer Success-Team heißt dich herzlich Willkommen und erklärt dir in dem kurzen Video wie das Onboarding abläuft.',
        buttonTitle: 'Weiter',
        bottomText: 'Zur Info: Diese Onboarding Informationen erhälst nur du als Hauptadmin',
      },
      questions: {
        title: 'Erzähle uns über euren Anwendungsfall',
        description:
          'So weiß dein Customer Success Team genau Bescheid und kann dich bestens betreuen.',
        buttonTitle: 'Jetzt loslegen',
      },
      backToGuides: 'Zurück zu den Guides',
    },
    onboarding: {
      howShareProfile: 'So teilst Du Dein Profil:',
      howMany: 'Wie viele Mitarbeiter:innen sind in Deinem Unternehmen?',
      howManyPotentialUsers: 'Wie viele davon kommen als Lemontaps-Nutzer:innen infrage?',
      whyLemontaps: {
        title: 'Was ist Dein Ziel mit Lemontaps?',
        personal: 'Für den persönlichen Gebrauch',
        company: 'Tests für mein Unternehmen/Team',
      },
      viaQR: 'via QR-Code',
      viaNFC: '...oder via NFC',
      slideVeryTop: 'Am oberen Rand berühren:',
      mustPressNFCbutton:
        'Hier muss die Besitzer:in erst das Kontrollzentrum hoch swipen und auf den NFC-Button klicken: ',
      androidGifText1: 'Frage, ob das NFC des Empfängers aktiviert ist',
      androidGifText2: 'Bewege Deine NFC-Karte von oben nach unten entlang der Rückseite',
      turnOnNFC: 'Wie NFC aktivieren',
      lastAdvice: 'Ein paar letzte Tipps',
      importForNFC: 'Wichtig für NFC:',
      lastAdviceAboutNFC: {
        pointOne: 'Der Bildschirm muss an sein',
        pointTwo: ' Flugmodus darf nicht an sein',
        pointThree: 'Die Kamera darf nicht geöffnet sein',
      },
      advice:
        'Das “Tappen” verlangt etwas Übung, aber keine Sorge wenn es mal nicht funktioniert, Du hast immer noch den QR Code als Backup. 🤗',
      congratsTitle: 'Glückwunsch, Du bist jetzt Bereit zum Netzwerken! 🎉',
      continue: 'Fortsetzen',
      welcome: `Willkommen - Erstelle jetzt Deine digitale Visitenkarte!`,
      addToWallet: {
        title: 'QR-Code zur Wallet hinzufügen',
        description:
          'Um Deine digitiale Visitenkarte zu teilen, füge den QR-Code zu Deiner Wallet hinzu. Wir haben Dir Deine Wallet auch nochmals per E-Mail gesendet.',
      },
      tellUs: 'Erzähle etwas über Dich',
      forPersonalize: 'für eine personalisierte Lemontaps-Experience',

      other: 'andere',
      selectCategory: 'Welche Kategorie beschreibt Dich am besten?',
      enterOtherCategory: 'Gib eine andere Kategorie ein',
      howDidYouhear: 'Wie hast Du von Lemontaps erfahren?',
      EnterOther: 'Andere eingeben',
      letsStart: `Los geht’s`,
      useCasePreferenceTitle: 'Für welche Produkte interessierst Du dich?',
      useCasePreference: {
        'sales-assistant': 'KI-Vertriebsassistent',
        'lead-gen': 'Kontakterfassung',
        'digital-business-cards': 'Digitale Visitenkarten',
        'two-in-one-business-cards': '2-in 1 Digitale- & Papiervisitenkarten',
        'nfc-cards': 'NFC-Karten',
        'email-signature': 'Email-Signatur',
      },
    },
    'sales-manager': 'Verkaufsleiter:in',
    sales: 'Vertrieb',
    'field-representative': 'Außendienstmitarbeiter:in',
    hr: 'HR',
    procurement: 'Beschaffung',
    consultant: 'Berater:in',
    'c-level': 'C-Level',
    it: 'IT',
    freelancer: 'Freiberufler:in',
    marketing: 'Marketing',
    other: 'Andere',
    openCookieSettings: 'Cookie-Einstellungen',
    openShopSettings: 'Zu unserem Shop',
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen',
    optional: 'optional',
    publicProfile: {
      autoConnect: {
        heading: 'Kontakt erstellt',
        subheading: 'Füge nun Notizen hinzu.',
        button: 'Öffnen',
      },
      actionsBar: {
        buttonLabel: 'Zurück zur Plattform',
      },
      profileForced:
        'Wenn Du dein Profil teilst, leitet es gerade auf "{{url}}" weiter, da Du bei einem Deiner Links den Blitz aktiviert hast. Wenn du das nicht mehr möchtest, deaktiviere den Blitz bei dem entsprechenden Link.',
      profileForcedVCard:
        'Beim Öffnen Deines Profils wird die vCard automatisch heruntergeladen. Um das zu ändern, öffne die Profil-Einstellungen.',
      profileForcedVCardGlobal:
        'Beim Öffnen Deines Profils wird die vCard automatisch heruntergeladen. Die Einstellung wurde durch einen Admin global aktiviert.',
    },
    fieldRequired: 'Pflichtfeld',
    cards: {
      card: 'Karte "{{code}}"',
      connect: 'Verbinden',
      alert: {
        title: 'Flexibles Management Deiner Karten',
        subtitle:
          'Weitere Karten können jederzeit mit Deinem Profil verbunden, oder auch daraus entfernt werden. Entfernte Karten können mit neuen Profilen verknüpft werden.',
      },
      orderCard: 'Bestellen',
      reorderCard: 'Nachbestellen',
      connectCard: 'Karte verbinden',
      deletePopup: {
        title: 'Karte entfernen?',
        description:
          'Sobald die Karte entfernt ist, kann sie wieder mit einem beliebigen Profil verbunden werden.',
      },
      enterCodePopup: {
        title: 'Gib zum Verbinden den Code ein',
        description:
          'Hinweis: Dies ist nur eine Backup-Methode, wenn die Kamera nicht funktioniert. Um den Code zu erhalten, wende dich an support@lemontaps.com.',
      },
      scanCardPopup: {
        title: 'Scanne den QR-Code auf der Karte',
        description:
          'QR-Code wird nicht erkannt?\n\n1. Scanne den QR-Code mit Deiner normalen Handykamera\n2. Backup: Kontaktiere support@lemontaps.com und gib dann <0>den Code manuell ein</0>',
      },
      noCardsViewWithShop:
        'Mit Deinem Profil sind noch keine Karten verknüpft. Verbinde jetzt Deine erste Karte oder bestelle eine Karte in unserem Shop.',
      noCardsViewWithoutShop:
        'Mit Deinem Profil sind noch keine Karten verknüpft. Verbinde jetzt Deine erste Karte.',
      cardsHeader: 'Übersicht verknüpfter Karten',
      loadingCards: 'Lade Karten...',
      noCards: 'Keine Karten',
      connectANewCard: ' Neue Karte verknüpfen',
      cards: 'Karten',
      remove: 'entfernen',
      uploadingCode: 'Code prüfen',
      successUpload: 'Code verknüpft',
      errorUpload:
        'Code konnte nicht verbunden werden. Überprüfe die Werte noch einmal. Der Code könnte auch bereits verwendet werden. Bitte wende dich an support@lemontaps.com und sende uns ein Bild des QR-Codes.',
      successDelete: 'Karte entfernt',
      errorDelete: 'Karte konnte nicht entfernt werden',
      codeDelete: 'Karte entfernen',
      areYouSureDelete: 'Möchtest Du die Karte wirklich entfernen?',
      headToolTip:
        'Es können beliebig viele Karten zu einem Profil hinzugefügt werden. Wenn die Karte entfernt ist, ist das Profil nicht mehr auf der Karte und die Karte kann mit einem neuen Profil verknüpft werden.',
      bottomToolTip:
        'Als Admin kannst Du die Karte verknüpfen per Scan des QR-Codes. Du kannst die Karte auch an den:die Mitarbeiter:in verteilen, diese:r kann sich einloggen, um die Karte mit seinem:ihrem Profil zu verknüpfen.',
      cardAlreadyConnected: 'Die Karte ist bereits mit diesem Profil verknüpft.',
      cardFrom: 'Karte vom',
      nodate:
        'Bei Karten, die vor dem 20.10.2022 verknüpft wurden, ist das Datum leider nicht verfügbar.',
      notValid: 'Ungültiger Code',
    },
    md2Phone: {
      popupStep1: 'Schritt 1: Scanne folgenden QR-Code mit Deinem Handy',
      popupStep2:
        'Schritt 2: Befolge nun die Anweisungen auf dem Handy und scanne den QR-Code der Karte. Der QR-Code ist 24h lang gültig.',
      title: 'Scanne den QR-Code der Karte',
      subTitle:
        'Die Karte wird dann automatisch mit dem Profil vom Management Dashboard verknüpft.',
      success:
        'Karte wurde erfolgreich mit dem Profil verknüpft.\n Bitte schließe die Seite, gehe zurück zum Management Dashboard und aktualisiere die Seite, um die Änderungen oder die neu verbundene Karte zu sehen!',
      noCodeToken:
        'Kein Code oder Token gefunden, bitte schließe die Seite und versuche es erneut.',
    },
    csvImport: {
      label: 'Bulk-Aktionen',
      add: 'Profile hinzufügen',
      update: 'Profile aktualisieren',
      delete: 'Profile löschen',
      toast: {
        added: 'Profile erfolgreich hochgeladen',
        backgroundImport:
          'Du erhälst eine E-Mail, sobald die Profile erstellt wurden. Das kann eine Weile dauern.',
        otherCards: 'Neue Karten bestellen',
        selectedCards:
          'Du hast während des .csv-Imports ausgewählt, @amount Karte(n) zu bestellen.',
        cardsMessage:
          'Diese werden im selben Design produziert wie bei Deiner letzten Bestellung. Du erhältst 1 Mal pro Quartal eine Rechnung aller neu bestellten Karten und Lizenzen.',
        addedThenError:
          'Profile wurden hochgeladen, aber das erneute Laden der Profile schlug fehl',
        updated: 'Profile erfolgreich aktualisiert',
        updatedThenError:
          'Profile wurden aktualisiert, aber das erneute Laden der Profile schlug fehl',
        deleted: 'Profile erfolgreich gelöscht',
        deletedThenError: 'Profile wurden gelöscht, aber das erneute Laden der Profile schlug fehl',
        exceedtotalLicensing0: 'Kontingent an Lizenzen überschritten',
        exceedtotalLicensing1: `Wenn Du weitere Profile anlegst, wirst Du die Anzahl Deiner bezahlten Lizenzen überschreiten.
          Du erhältst am Ende des Monats eine Rechnung per E-Mail für die neu hinzugefügten Lizenzen. Die Lizenzgebühren werden Dir nur anteilig zur restlichen Vertragslaufzeit berechnet.

          Willst Du trotzdem fortfahren?`,
        exceedtotalLicensing2: 'Aktuelles Lizenzkontingent',
        exceedtotalLicensing3: `Du hast während des .csv-Imports ausgewählt, @amount Karte(n) zu bestellen.
        Diese werden im selben Design produziert wie bei Deiner letzten Bestellung. Du erhältst 1 Mal pro Quartal eine Rechnung aller neu bestellten Karten und Lizenzen.

        Wenn Du weitere Profile hinzufügst, überschreitest Du die Anzahl Deiner bezahlten Lizenzen.
                  Für die neu hinzugefügten Lizenzen erhältst Du am Monatsende eine Rechnung per E-Mail. Die Lizenzgebühren werden Dir nur anteilig zur verbleibenden Vertragslaufzeit in Rechnung gestellt.

                  Möchtest Du trotzdem fortfahren?`,
        continue: 'Fortfahren',
        employeesLicenses: 'Mitarbeiterlizenzen',
      },
      errors: {
        header: 'Fehler beim Benutzerimport',
        length: {
          header: '-----------------\nBenutzer "{{user}}" hat folgende(n) Fehler: \n',
          field: ' {{field}} darf nicht länger als {{length}} Zeichen sein.\n',
          fields: ' {{fields}} dürfen nicht länger als {{length}} Zeichen sein.\n',
          amount: ' {{field}} darf nicht größer sein als der {{amount}}.',
        },
        invalidEmails: 'Ungültige Emails: \n "{{emails}}"',
        disposableDomains: 'Wegwerf-Emails: \n "{{domains}}"',
        duplicatedEmails: 'Doppelt vorhandene Emails in hochgeladener Datei: \n "{{emails}}"',
        existedEmails:
          'Accounts mit diesen Emails existieren bereits (möglicherweise außerhalb Ihres Teams): \n "{{emails}}"',
        missedParams:
          '"{{params}}" sind erforderliche Parameter, aber sie fehlen in Zeile "{{row}}".',
        invalidParam: 'Ungültiger {{param}} in Zeile {{row}}',
        invalidCodes: 'Ungültige Codes: "{{codes}}"',
        trialUsersExceeded: 'Während des Trials seid ihr auf maximal {{max}} Profile beschränkt.',
      },
    },
    referrals: {
      heading: 'Erhalte kostenlos Deine NFC-Karte',
      subtext:
        'Sammle jetzt Guthaben für Deine kostenlose NFC-Karte oder Teams Lizenz. Lade hierfür einfach Deine Kollegen oder Freunde zu Lemontaps ein oder verfasse einen Linkedin Post. Wenn Du uns mit mehreren Bonusaktionen unterstützt, summieren wir die Punkte.',
      balance: {
        title: 'Dein aktuelles Guthaben ',
        tooltip:
          'Dein Guthaben kannst Du verwenden, um Dir Lemontaps Produkte zu kaufen. Eine Bargeldauszahlung ist nicht möglich.',
      },
      redeem: {
        title: 'Löse Dein Guthaben direkt ein!',
        button: 'Guthaben einlösen',
        popup: {
          title: 'Guthaben einlösen?',
          success:
            'Bitte kontaktiere uns unter <0>support@lemontaps.com</0> indem Du kurz erwähnst, welches Item Du einlösen möchtest.',
          failed: 'Dein aktuelles Guthaben reicht nicht aus. Empfehle uns weiter!',
        },
      },
      collect: {
        title: 'Guthaben sammeln',
        email: {
          title: 'Lade Kontakte ein',
          subtext:
            'Lade Deine Kollegen, Freunde oder Kontakte mit ihrer geschäftlichen E-Mail zu Lemontaps ein und erhalte <0>2€ Guthaben</0> pro verifizierter Registrierung. ',
          tooltip:
            'Nur geschäftliche Emails werden mitgezählt (keine G-Mail etc.), die auch das Onboarding durchgeführt haben.',
          placeholder: 'Geschäftliche Email',
          button: 'Jetzt einladen',
          copyButton: 'Teilbaren Link kopieren',
        },
        linkedin: {
          title: 'Erhalte 15€ Guthaben geschenkt',
          subtext:
            'Markiere uns auf deinem nächsten LinkedIn Post über Lemontaps und erhalte sofort einmalig <0>15€ in Credits</0>. <1></1>Sende uns hierfür einfach den Link zum Post an <2>contact@lemontaps.com</2>, und wir bestätigen dein neues Guthaben.',
        },
      },
      toast: {
        emailError: 'Bitte gib eine gültige Firmen-E-Mail ein',
        emailSuccess: 'E-Mail erfolgreich gesendet',
        linkSuccess: 'Link in die Zwischenablage kopiert',
      },
      menuButton: 'Empfehlungslink',
      card: 'Kostenlose NFC-Karte erhalten',
    },
    shareTo: {
      shareTo: 'Teilen mit..',
      shareDetails: 'Teile Dein Lemontaps mit all Deinen Kontakten, damit jeder davon erfährt',
      shareWhatsapp: 'Per Whatsapp teilen',
      shareLinkedin: 'Per Linkedin teilen',
      shareEmail: 'Per E-Mail teilen',
      shareViaOther: 'Über andere teilen',
      shareDestination: 'Teilen mit..',
      shareFacebook: 'Per Facebook teilen',
      shareTelegram: 'Per Telegram teilen',
      shareMail: 'Per Mail teilen',
      copyAndShare: 'Text kopieren und über {{via}} teilen',
      textCopied: 'Text in die Zwischenablage kopiert',
      shareProfile: {
        shareYourProfile: 'Teile Dein Profil',
        shareYourProfileDetails:
          'Vernetze und verbinde Dich besser, indem Du Dein Lemontaps-Profil überall teilst.',
        userText: 'Verwende Lemontaps in',
        qrCode: 'Mein Lemontaps QR-Code',
        lemonTapsShare: 'Teile meine Lemontaps mit ..',
      },
      presentations: {
        useInPresentations: 'Verwendung in Präsentationen',
        useInPresentationsDetails:
          'Platziere Deinen Lemontaps QR-Code in Präsentationen, damit sich jeder leicht mit Dir vernetzen kann.',
      },
      emailSignature: {
        eMailSignature: 'E-Mail Signatur',
        eMailSignatureDetails:
          'Kopiere Deinen Lemontaps-Link und füge ihn in Deine E-Mail-Signatur ein:',
        management: {
          title: 'E-Mail-Signatur-Verwaltung',
          description:
            'Erstellen und verwalten Sie mehrere E-Mail-Signaturen mit regelbasierter Auswahl.',
        },
        signatures: 'Signaturen',
        noSignatures: 'Keine Signaturen gefunden',
        createFirstSignature: 'Erstellen Sie Ihre erste Signatur, um zu beginnen',
        create: 'Signatur erstellen',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        duplicate: 'Duplizieren',
        activate: 'Aktivieren',
        deactivate: 'Deaktivieren',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        name: 'Name',
        description: 'Beschreibung',
        priority: 'Priorität',
        status: 'Status',
        rules: 'Regeln',
        languages: 'Sprachen',
        created: 'Erstellt',
        actions: 'Aktionen',
        tableView: 'Tabellenansicht',
        cardView: 'Kartenansicht',
        reordering: 'Signaturen werden neu angeordnet...',
        deleteSuccess: 'Signatur erfolgreich gelöscht',
        reorderSuccess: 'Signaturen erfolgreich neu angeordnet',
        updateSuccess: 'Signatur erfolgreich aktualisiert',
        createSuccess: 'Signatur erfolgreich erstellt',
      },
      useInVideoCalls: {
        useInVideoCalls: 'Verwendung in Videoanrufen',
        useInVideoCallsDetails:
          'Generiere Deinen Videocall-Hintergrund mit Deinem Lemontaps QR-Code, damit Du auch bei Online-Meetings eine Visitenkarte hast.',
      },
      useIn: {
        useInPersonalMeetings: 'In persönlichen Meetings verwenden',
        useInVideoCalls: 'In Videoanrufen verwenden',
        useInEmail: 'In E-Mail-Signatur verwenden',
        useInPresentations: 'In Präsentationen verwenden',
      },
      createBackground: 'Hintergrund erstellen',
    },
    selectFromList: 'Aus Liste auswählen',
    send: 'Senden',
    hereIsMyContact: 'Mein Kontakt',
    myContact: 'Mein Kontakt',
    profileImageUpdated: 'Profilbild aktualisiert',
    bannerImageUpdated: 'Banner aktualisiert',
    logoImageUpdated: 'Logo aktualisiert',
    defaultAddresses: 'Standardadressen',
    error: {
      general: 'Etwas ging schief, bitte aktualisiere die Seite und probiere es noch einmal',
      editBio: 'Fehler beim Speichern.',
      defaultAddress: 'Adressen konnten nicht aktualisiert werden',
      defaultLink: 'Link konnte nicht aktualisiert werden',
      defaultFile: 'Datei konnte nicht aktualisiert werden',
      uploadFile: 'Datei konnte nicht hochlgeaden werden',
      updateFile: 'Datei konnte nicht aktualisiert werden',
      updateLink: 'Link konnte nicht aktualisiert werden',
      deleteLink: 'Link konnte nicht gelöscht werden',
      deleteFile: 'Datei konnte nicht gelöscht werden',
      uploadingImage: 'Fehler beim Hochladen',
      updatingImage: 'Fehler beim Aktualisieren des Bildes',
      updateAccounts: 'Fehler beim Aktualisieren der Konten, bitte probiere es noch einmal!',
      errorDownloadQr: 'Es können maximal 10 Profile ausgewählt werden für diese Aktion.',
      successfullySent: 'erfolgreich gesendet',
      disposableEmail: 'Die Verwendung von Wegwerf-E-Mails ist nicht erlaubt!',
      invalidEmail: 'Bitte benutze ein gültiges E-Mail-Format!',
      required: 'Erforderlich',
      existedEmail: 'E-Mail bereits verwendet! Bitte verwende eine andere E-Mail.',
      socialEmail:
        'Du bist mit einem Social Provider authentifiziert. Um deine E-Mail anzupassen, logge dich dort ein.',
      requiredFieldGeneral: 'Feld ist erforderlich',
      invalidFieldGeneral: 'Format ist ungültig',
      minOneFieldRequired: 'Mindestens ein Feld erforderlich',
      pleaseFillOutRequired: 'Bitte fülle alle Felder aus',
      maxLength: 'Maximal {{value}} Zeichen',
      cantDowngradeMainAdmin:
        'Es ist nicht möglich, die Rolle "Admin" für den Team Owner zu entfernen.',
    },
    teaser: {
      starterBullets: [
        'Digitale Visitenkarte für Mobil & Desktop',
        'Unbegrenzt Links & Dateien hochladen',
        'Apple Wallet, QR-Code, QR-Hintergründe',
        'Analytics & Insights',
      ],
      proBullets: [
        'Zentrale Nutzerverwaltung',
        'Individuelle Firmendomain nutzen',
        'Unterteilung in Untergruppen',
        'Profil nach Corporate Design',
        'Templates & Bilder hinterlegen',
        'Rollen- & Rechte verteilen',
        'Massen-Export von QR-Codes/Wallet',
        'Kontakterfassung und Verwaltung',
        'KI-Visitenkartenscanner für Leads',
        'Schnittstellen: SSO, MS AD, CRM möglich',
        'Schulungsvideos & Prio-Support',
      ],
      enterpriseBullets: [
        'Whitelabel Funktionalitäten wie internes Design, Favicon, Email Editor usw.',
        'Unterteilung in Untergruppen mit spezifischen Design & Einstellungen',
        'Übersetzung der Profil-Inhalte in jede beliebige Sprachen',
        'Lead-Reporting Funktionen für Messen',
        'Persönliche Beratung & Onboarding',
        'Rollout & Best-Practice Beratung',
        'Lemontaps Academy Videoreihe',
        'Dedizierter Support und SLA',
        'Custom Code Anpassungen',
      ],

      starterShortDescr:
        'Erstelle für Dich einfach & kostenlos Dein digitales Visitenkartenprofil.',
      teamsShortDescr:
        'Nutze Lemontaps im Team (1-50 Nutzer) und nach Euren corporate Richtlinien.',
      enterpriseShortDescr:
        'Empfohlen für Teams ab 50 Personen mit erweiterten Sicherheits-, Kontroll- und Supportfunktionen.',

      testItXDaysForFree: 'Jetzt kostenlos {{days}} Tage testen',
      centralUserAdministration: 'Zentrale Nutzerverwaltung',
      easilyDataOfAllEmployees:
        'Daten aller Mitarbeiter:innen für die Profilerstellung einfach einpflegen, bearbeiten und verwalten.',
      leadRecording: 'Lead-Erfassung',
      noCredit: '  Keine Kreditkarte oder Kündigung erforderlich.',
      noInstallation: 'Keine Installation notwendig',
      contacts:
        'Über das Lead-Formular auf Deinem Profil oder in Deiner eigenen Ansicht können Kontakte direkt digital aufgenommen werden und automatische Follow-Up Emails gesendet werden.',
      contactsLand:
        ' Die Kontakte landen chronologisch nach Zeit und Datum sortiert im Kontaktmanagementsystem. Hier können weitere Infos ergänzt werden (wie Notizen und Bilder), um die Person nicht zu vergessen.',
      manageContacts: 'Kontakte verwalten ',
      makeContacts: 'Kontakte aufnehmen',
      packageComparison: 'Alle Pakete im Vergleich',
      starter: 'Anlasser',
      individualUser: ' Für Einzelnutzer',
      noPayment: 'Für immer kostenlos. Keine Kreditkarte nötig.',
      currentPlan: 'Aktueller Plan',
      basicFeature: 'Grundfunktionen:',
      teamEssential: 'Teams unerlässlich',
      groupUsers: '1 - 50 Nutzer:innen',
      peruserpermonth: 'Pro Nutzer/Monat im Jahrespaket.',
      graduatedprices: 'Staffelpreise für Lizenzen und NFC-Karten.',
      costless: 'Kostenlos testen',
      allStarterFeatures: 'Starter Funktionen, plus:',
      allProFeatures: 'Teams Funktionen, plus:',
      allFeatures: 'Alle Teams Features, plus:',
      platformManagment: 'Management Plattform zur zentralen Nutzerverwaltung',
      trading: 'Profil nach Corporate Branding ',
      contact: 'Kontakterfassung ',
      fiftygroupUsers: 'Empfohlen ab 50 Nutzern',
      recievedError: 'Angebot erhalten',
      allTeamsFeature: 'Alle Teams Features plus:',
      settelment: ' Einteilung in Mehrere Einheiten / Standorte',
      individualAdjustment: 'Individuelle Anpassungen wie Emails und internes Design',
      standard: 'Standard Links/Adressen Templates',
      askUs: 'Frage uns für ein Angebot an.',
      contactSales: 'Vertrieb kontaktieren',
      hunderdsgroupUsers: 'Firmen ab 50 Nutzer:innen',
      allCompanyFeatures: 'Alle Company Features, plus:',
      premiumSupport: 'Premium Support und SLA',
      comparison: 'Alle Preispläne und Funktionsumfang vergleichen',
      popular: 'Am beliebtesten für Teams',
      adminManagment: 'Admin Managment',
      importantFunction: 'Die wichtigsten Funktionen im Überblick',
      centralUser: 'Zentrale Nutzerverwaltung',
      easyData:
        'Daten aller Mitarbeiter für die Profilerstellung einfach einpflegen, bearbeiten und verwalten. ',
      corporateIdentity: ' Profil nach Corporate Identity ',
      designDigitalProfile:
        'Gestalte das digitale Profil nach Deinen Farben, Formen, Logo und Standard Hintergrundbilder.',
      individualProcessing: 'Individuelle Bearbeitungsrechte',
      access: 'Entscheide wer welche Zugriffe und welche Bearbeitungsrechte haben soll.',
      leader: 'Leaderfassung ',
      efficientContact:
        'Dein Team kann über das Profil effizient Kontakte aufnehmen, verwalten und automatische Follow-Up Emails versenden.',
      myProfile: 'Mein Profil',
      noCancellation: 'Und keine Kündigung erforderlich',
      expired: 'Deine Testphase ist abgelaufen.',
      moreInfo: 'Mehr Infos zu den Paketen',
      companyName: 'Wie heißt deine Organisation?',
      potentialUser: ' Um wie viele potentielle Nutzer handelt es sich?',
      stratNow: 'Jetzt loslegen!',
      upgradeSubtext: 'oder upgraden',
      salesSubtext: 'oder Vertrieb kontaktieren',
      collectLeadsWithLt: 'Leads erfassen mit Lemontaps',
      leadGen: {
        header: 'Lemontaps Pro kostenlos ausprobieren',
        subheader:
          'Scanne effizient Papiervisitenkarten oder nehme Kontakte über das Leadformular auf. Verwalte deine Kontakte und übertrage diese in dein CRM System (Salesforce, Hubspot, Pipedrive und Dynamics).',
      },
      teams: {
        header: 'Lemontaps Teams kostenlos ausprobieren',
        subheader:
          'Die effizienteste Lösung Dein gesamtes Team mit digitalen Visitenkarten auszustatten. Teste unsere beliebtesten Funktionen kostenlos.',
      },
    },
    upgradeTeaser: {
      upgradeYourPlan: 'Upgrade erforderlich - Möchtest Du dieses Feature kostenlos testen?',
      contactUs: 'Kontaktiere uns.',
      enableForTrial: 'Mehr Features aktivieren für die Testphase!',
      feature: {
        bioFieldsConfig: 'Konfiguriere, welche Felder auf der Profilseite angezeigt werden sollen.',
        profiles:
          'Erstelle ein Team und verwalte die Profile aller Deiner Mitarbeitenden aus unserem zentralen Dashboard heraus.',
        leadGenInternalContactForm: 'Konfiguriere die intern verfügbaren Felder für Kontakte.',
        vcardConfig:
          'Konfiguriere, welche Informationen in heruntergeladenen Kontakten angezeigt werden sollen.',
        units:
          'Gruppiere Nutzer in Units. Diese können durch Sub-Admins auch selbst verwaltet werden, sowie Unit-spezifische Einstellungen erhalten. Units sind in Deinem aktuellen Paket nicht verfügbar.',
        leadgenMd:
          'Finde alle erfassten Kontakte/Leads aller Mitarbeiter:innen an einem Ort, welche mithilfe des Kontaktformulars unten im öffentlichen Profil erfasst wurden. Bearbeite und exportiere die Kontakte. Die Kontaktansicht ist in Deinem aktuellen Paket nicht verfügbar.',
        leadgenIndividual:
          'Finde alle von Dir mithilfe des Kontaktformulars im öffentlichen Profil erfassten Kontakte/Leads. Die Kontaktansicht ist in Deinem aktuellen Paket nicht verfügbar.',
        themeLinks: 'Standardlinks sind in Deinem aktuellen Paket nicht verfügbar',
        themeFiles: 'Standarddateien sind in Deinem aktuellen Paket nicht verfügbar',
        themeAddresses: 'Standardadressen sind in Deinem aktuellen Paket nicht verfügbar',
        dataTemplates:
          'Erstelle Vorlagen für Standard Adressen, Links und Dateien. Wenn diese Vorlagen hier geändert werden, werden die Änderungen direkt bei allen Profilen übernommen, bei denen diese Vorlage hinzugefügt wurde. Datei Vorlagen sind in Deinem aktuellen Paket nicht verfügbar',
        globalData:
          'Konfiguriere Links, Dateien oder Adressen, die global auf allen Profilen angezeigt werden.',
        emailTemplates:
          'Passe die von Lemontaps versendeten E-Mails mit eurem eigenen Design und Text an. Du kannst die Einladungs-E-Mail und die E-Mails für das Kontaktformular bearbeiten. Diese Funktion ist in Deinem aktuellen Paket nicht enthalten.',
        leadGenContactForm:
          'Passe das Kontaktformular auf der Profilseite Deiner Teammitglieder an. Entscheide, welche Felder verpflichtend ausgefüllt werden müssen, welche Felder optional abgefragt werden, und welche Felder gar nicht angezeigt werden. Dieses Feature ist in Deinem aktuellen Paket nicht enthalten.',
        mdAnalytics:
          'Analysiere profilübergreifende, aggregierte Statistiken zur Nutzung deiner Mitarbeiter:innen.',
        analyticsIndividual: 'Analysiere Statistiken zu Deinem Profil.',
        internalDesign: 'Das Interne Design ist in Deinem aktuellen Paket nicht verfügbar. ',
        unitHierarchies: {
          visibilityConfig: 'Passe die Sichtbarkeit einzelner Seiten und Elemente an.',
          leadGenInternalContactForm:
            'Konfiguriere ein eigenes internes Formular für diese Unit. Diese Funktion ist in Deinem aktuellen Paket nicht enthalten.',
          leadGenContactForm:
            'Konfiguriere ein eigenes externes Formular für diese Unit. Diese Funktion ist in Deinem aktuellen Paket nicht enthalten.',
          editRightsTheme:
            'Überschreibe Bearbeitungsrechte für diese Theme. Diese Funktion ist in Deinem aktuellen Paket nicht enthalten.',
          editRights:
            'Überschreibe Bearbeitungsrechte für diese Unit. Diese Funktion ist in Deinem aktuellen Paket nicht enthalten.',
          editRightsGeneral:
            'Entscheide, welche Unit-spezifischen Einstellungen von Unit-Admins selbst verwaltet werden dürfen. Diese Funktion ist in Deinem aktuellen Paket nicht enthalten.',
          profileDesign:
            'Überschreibe das Profildesign für diese Unit. Diese Funktion ist in Deinem aktuellen Paket nicht enthalten.',
          emailSignature:
            'Erstelle eine eigene E-Mail-Signatur für diese Unit. Diese Funktion ist in Deinem aktuellen Paket nicht enthalten.',
          walletConfig:
            'Überschreibe die Wallet-Einstellungen für diese Unit. Diese Funktion ist in Deinem aktuellen Paket nicht enthalten.',
          qrCodeBackgroundConfig:
            'Überschreibe die QR-Code-Hintergrund-Einstellungen für diese Unit. Diese Funktion ist in Deinem aktuellen Paket nicht enthalten.',
        },
        translations:
          'Übersetze die digitalen Visitenkartenprofile Deines Teams. Du kannst den Standardtext, Kontaktinformationen, Linknamen, Links und Dateinamen übersetzen. Du kannst auch festlegen, dass Informationen in bestimmten Sprachen nicht angezeigt werden. Diese Funktion ist in Deinem aktuellen Tarif nicht verfügbar.',
        businessCardScanner:
          'Digitalisiere und importiere Kontaktdaten aus Papiervisitenkarten zu Lemontaps, ins CRM oder in Outlook. Natürlich DSGVO-konform und in Sekundenschnelle.',
        visibilityConfig: 'Passe die Sichtbarkeit einzelner Seiten und Elemente an.',
        idp: 'Integriere euren Identitätsanbieter. Richte Single Sign-On und Benutzersynchronisierung ein.',
        emailSignature:
          'Erstelle eine eigene E-Mail-Signatur. Diese Funktion ist in Deinem aktuellen Paket nicht enthalten.',
        profileDesign: 'Bearbeite das Profildesign für alle Profile Deines Teams.',
        walletConfig: 'Konfiguriere die Apple und Google Wallet-Einstellungen für Dein Team.',
        qrCodeBackgroundConfig: 'Konfiguriere die QR-Code-Hintergrund-Einstellungen für Dein Team.',
      },
    },
    globalSettings: 'Weitere globale Einstellungen',
    integrations: {
      title: 'Integrationen',
      subtitle:
        'Lemontaps lässt sich optimal in Deine Systemlandschaft integrieren. Die folgenden Integrationen können optional hinzugebucht werden.',
      connect: 'Verbinden',
      configure: 'Konfigurieren',
      connected: 'Verbunden',
      inProgress: 'In Bearbeitung',
      customDomain: {
        title: 'Firmendomain',
        description: 'Verbinde die digitalen Profile mit Deiner eigenen Subdomain/URL.',
        popupDescription:
          'Wähle eine Subdomain aus. Dann sende eine E-Mail mit Deiner Entscheidung an {{email}}.',
      },
      sso: {
        title: 'SSO Login',
        description: 'Integriere einen sicheren SSO/SAML-Unternehmenszugang.',
      },
      activeDirectory: {
        title: 'Active Directory',
        description: 'Die Profildaten können mit Deinem Active Directory synchronisiert werden.',
      },
      crm: {
        title: 'CRM',
        description: 'Synchronisiere erfasste Kontakte.',
      },
    },
    contactsTable: 'Kontakte',
    findOutMore: 'Mehr erfahren',
    manual: 'Manuell',
    businessCardScanner: {
      automaticallySendContactToEmailHelperText:
        'Ein Admin hat diese Option fixiert. Die Follow-Up-E-Mail wird nach dem Speichern des Kontakts versendet.',
      noDataFoundBusinessCard: 'Keine Daten gefunden',
      noDataFoundBadge: 'Keine Daten gefunden',
      noDataFoundLinkedIn: 'QR-Code konnte nicht ausgelesen werden',
      noDataFound: 'Keine Daten gefunden',
      edit: {
        nothingDetectedAlertTitle: 'Nichts erkannt',
        nothingDetectedAlertBody: 'Bitte lasse die Kontaktinformationen ausfüllen',
        missinContactInfoAlertTitle: 'Kontaktinformationen fehlen',
        missinContactInfoAlertBody:
          'Wir benötigen mindestens den Vor- und Nachnamen, sowie den Unternehmensnamen, um die Anreicherung zu starten.',
      },
      title: 'Visitenkartenscanner',
      infoText: {
        businessCard:
          'Lege die Visitenkarte auf einen Tisch, achte auf vollständige Sichtbarkeit und fotografiere sie.',
        badge: 'Nimm ein Foto von einem Messe-Badge auf',
        linkedin: 'Nimm ein Foto von einem QR-Code auf',
      },
      noEnrichmentFoundAlert: {
        title: 'Keine Informationen gefunden',
        body: 'Für diesen Kontakt konnten keine Informationen gefunden werden',
      },
      infoTextFront: 'Vorderseite aufnehmen',
      infoTextBack: 'Rückseite aufnehmen',
      enterMinOne: 'Fülle mindestens ein Feld aus, um fortzufahren',
      infoEmailWillBeSent:
        'Wenn du auf "Speichern" klickst, wird eine E-Mail mit deinen Kontaktinformationen an diesen Kontakt gesendet.',
      cameraNotAvailable: 'Du musst den Kamerazugriff erlauben, um den Scanner zu nutzen.',
      fileCaptureError: 'Error. Versuch es noch einmal.',
      addContactSuccess: 'Kontakt gespeichert',
      addContactError: 'Error beim Speichern',
      upload: 'Hochladen',
      loadingTitle: 'Analysiert',
      savingTitle: 'Speichern',
      loadingSubtitle: 'Dauert meistens wenige Sekunden',
      businessCardTitle: 'Richtige Treffer auswählen',
      businessCardSubtitle: 'Diese Details können auch später bearbeitet werden.',
      retake: 'Neu aufnehmen',
      next: 'Weiter',
      sendContactToEmail: 'Meine digitale Visitenkarte an {{email}} senden',
      gdprTitle: 'DSGVO',
      gdprSubtitle:
        'Bitte wähle eine rechtliche Grundlage für die Verarbeitung dieses Kontakts aus.',
      noFieldsAvailable:
        'Leider wurde nichts erkannt. Klicke auf "Weiter", um den Kontakt manuall anzulegen.',
      fileSelectSizeError: 'Bitte lade eine Datei hoch, die kleiner als 10MB ist.',
      fileSelectMaxFileSelectError: 'Du kannst maximal {{count}} Dateien auf einmal hochladen.',
      permissionDenied: {
        preText: 'Folge den Anweisungen, um den Kamerazugriff zu aktivieren',
        desktop: {
          firefox:
            "Klicke auf das Schutzschild-Symbol in der Adressleiste, wähle 'Berechtigungen', finde 'Kamera verwenden' und wähle 'Zulassen'. Aktualisiere die Seite danach.",
          chrome:
            "Klicke auf das Vorhängeschloss-Symbol in der Adressleiste, wähle 'Kamera', wähle 'Zulassen' und aktualisiere dann die Seite.",
          safari:
            "Klicke auf das 'aA'-Symbol in der Adressleiste, wähle 'Website-Einstellungen', wähle 'Zulassen' neben 'Kamera' und aktualisiere dann die Seite.",
          edge: "Klicke auf das Vorhängeschloss-Symbol in der Adressleiste, wähle 'Kamera', wähle 'Zulassen' und aktualisiere dann die Seite.",
          opera:
            "Klicke auf das Vorhängeschloss-Symbol in der Adressleiste, wähle 'Kamera', wähle 'Zulassen' und aktualisiere dann die Seite.",
        },
        mobile: {
          firefox:
            "Klicke auf das Schutzschild-Symbol in der Adressleiste, wähle 'Berechtigungen', finde 'Kamera verwenden' und wähle 'Zulassen'. Aktualisiere die Seite danach.",
          chrome:
            "Tippe auf das Dreipunkt-Menü oder das 'Mehr'-Symbol, gehe zu 'Einstellungen', finde 'Website-Einstellungen', tippe auf 'Kamera' und stelle sicher, dass es auf 'Erst fragen' oder 'Erlaubt' steht.",
          safari:
            "Gehe zur iOS 'Einstellungen'-App, scrolle nach unten zu 'Safari', tippe auf 'Kamera' und wähle 'Zulassen'",
          edge: "Tippe auf das Dreipunkt-Menü, gehe zu 'Einstellungen', tippe auf 'Website-Berechtigungen', wähle 'Kamera' und setze es auf 'Vor dem Zugriff fragen'.",
          opera:
            "Öffne das Menü, gehe zu 'Einstellungen', finde 'Website-Einstellungen', wähle 'Kamera' und stelle es auf 'Erst fragen' oder 'Erlaubt' ein.",
        },
      },
      showFront: 'Vorderseite anzeigen',
      showBack: 'Rückseite anzeigen',
      captureFront: 'Vorderseite scannen',
      captureBack: 'Rückseite scannen',
    },
    freeTrialBanner: {
      ongoing: {
        line1_one:
          'Du hast {{count}} Tag Deiner kostenlosen {{days}}-tägigen Testphase von Lemontaps übrig. ',
        line1_other:
          'Du hast {{count}} Tage Deiner kostenlosen {{days}}-tägigen Testphase von Lemontaps übrig. ',
        line2:
          ', um alle Features von Lemontaps nach Ablauf der Testphase weiterhin nutzen zu können. <0>Was passiert nach Ablauf der Testphase?</0>',
      },
      finished: {
        line1: 'Deine {{days}}-tägige Testphase ist abgelaufen',
        line2:
          ', um wieder Zugang zu allen Funktionen zu erhalten. Alle Deine Ressourcen und Einstellungen sind weiterhin gespeichert und du kannst nach einem Upgrade wieder darauf zugreifen.',
      },
    },
    mobilePopupText:
      'Die Bildschirmbreite ist zu klein. Bitte öffne diese Seite auf einem Desktop-Gerät oder vergrößere die Browserbreite auf mindestens {{pixel}}px.',

    onboardingReferrer: {
      google: 'Google',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      referral: 'Empfehlung / Referral',
      event: 'Event',
      email: 'E-Mail',
      friends: 'Freunde',
      bing: 'Bing',
      recommendation: 'Empfehlung',
      chatgpt: 'ChatGPT / Bing Copilot',
      blog: 'Blog Post',
    },
    option: 'Option',
    custom: 'Benutzerdefiniert',
    scannable: 'Scannbar',
    contactFormEdit: {
      tooltips: {
        upstreamLeadObjectType:
          'Nur sichtbar wenn eine CRM-Verbindung aktiv ist und die Export-Einstellung "Ermögliche Benutzer:innen die Auswahl zwischen Kontakt und Lead" aktiv ist.',
        email: 'An diese E-Mail werden Follow-Up E-Mails versendet.',
      },
      resetToDefaultLabel: 'Standardbezeichnung:',
      saveTooltip: 'Mindestens ein Feld muss erforderlich sein',
      fullName: 'Name',
      required: 'Pflichtfeld',
      optional: 'Optionales Feld',
      notShown: 'Nicht anzeigen',
      shown: 'Anzeigen',
      title: 'Konfiguration des Kontakterfassungsformulars',
      description: 'Diese Einstellungen gelten für alle Profile deines Teams.',
      atLeastOneRequired: 'Mindestens ein Feld muss als Pflichtfeld markiert sein.',
      usedInExternal:
        'Du kannst keine Felder im internen Formular ausblenden, die im externen Formular sichtbar sind.',
      deletingUsedInExternal:
        'Das Feld, das du löschen möchtest, ist noch im externen Formular sichtbar.',
      sortRequiredFields: 'Sortiere Pflichtfelder',
      sortOptionalFields: 'Sortiere optionale Felder',
      businessCardUrls: 'Visitenkarten',
      external: {
        title: 'Externes Formular',
      },
      internal: {
        title: 'Internes Formular',
        deletePopupTitle: 'Möchtest Du dieses Feld wirklich löschen?',
        deletePopupBody:
          'Sämtliche mit diesem Feld gesammelten Informationen werden gelöscht und können nicht wiederhergestellt werden.',
        questionTitle: 'Feldname',
        answerOptions: 'Feldoptionen',
        addOption: 'Option hinzufügen',
        editField: 'Feld bearbeiten',
        deleteField: 'Feld löschen',
        editSystemField: 'Systemfeld bearbeiten',
        customFields: {
          crmCustomFields: {
            title: 'CRM Custom Field',
            tooltip: 'CRM Custom Field tooltip.',
            addDialogTitle: 'CRM Custom Field hinzufügen',
            addDialogDescription:
              'Finde alle verfügbaren CRM Custom Fields und füge sie zu deinem Lead-Formular hinzu - sie werden automatisch synchronisiert, wenn ein Lemontaps-Kontakt gepusht wird.',
            chipTitle: 'Synchronisiert',
          },
          text: {
            title: 'Text',
            tooltip: 'Einzeiliges Textfeld',
          },
          textarea: {
            title: 'Textarea',
            tooltip: 'Mehrzeiliges Textfeld',
          },
          checkbox: {
            title: 'Checkboxes',
            tooltip: 'Mehrfachauswahl durch Checkboxen',
          },
          dropdown: {
            title: 'Dropdown',
            tooltip: 'Einfachauswahl durch ein Dropdown',
          },
          radio: {
            title: 'Radio Buttons',
            tooltip: 'Einfachauswahl durch Radio Buttons',
          },
          'checkbox-single': {
            title: 'Checkbox',
            tooltip: 'Einfachauswahl (Ja/Nein) durch eine einzelne Checkbox',
          },
          'multi-select': {
            title: 'Multi-Select',
            tooltip: 'Mehrfachauswahl durch ein Dropdown',
          },
          date: {
            title: 'Datum',
            tooltip: 'Datumsauswahl (ohne Uhrzeit)',
          },
          datetime: {
            title: 'Datum und Uhrzeit',
            tooltip: 'Datumsauswahl (mit Uhrzeit)',
          },
          number: {
            title: 'Zahl',
            tooltip: 'Numerische Eingabe',
          },
          attachments: {
            title: 'Anhänge',
            tooltip: 'Unterstützt png, HEIC, mp4, mov, pdf',
          },
          signature: {
            title: 'Signatur',
            description:
              'Ich stimme der Verarbeitung meiner personenbezogenen Daten gemäß der Datenschutzerklärung zu. Dies umfasst die Erhebung, Nutzung und Weitergabe meiner Daten zum Zweck der Bereitstellung von Dienstleistungen, der Abwicklung von Transaktionen und der Kommunikation mit mir. Mir ist bewusst, dass ich meine Einwilligung jederzeit widerrufen kann.',
            tooltip: 'Unterschriftfeld-Tooltip.',
          },
        },
        alert: {
          title: 'Feld für Visitenkartenscanner.',
          body: 'Solche Felder, die als "Scannbar" markiert sind, sind die Felder, die der Visitenkartenscanner erkennen kann. Solche Felder, die als "KI" markiert sind, können durch KI angereichert werden.',
        },
      },
    },
    signature: {
      add: 'Signatur hinzufügen',
      delete: 'Signatur löschen',
      download: 'PDF herunterladen',
    },
    deleteAccount: {
      title: 'Account löschen',
      pageTitle: 'Gefahrenzone',
      buttonText: 'Meinen Account löschen',
      popupTitle:
        'Bist Du sicher, dass Du Deinen Account löschen willst? Das kann nicht rückgängig gemacht werden!',
      popupBody:
        'Alle Daten, die mit diesem Konto verbunden sind, werden dauerhaft gelöscht. Dies kann nicht rückgängig gemacht werden.',
      popupEmailLabel: 'Gib die Email-Adresse ein, mit der Du registriert bist',
      success: 'Dein Account wurde erfolgreich gelöscht.',
      emailMismatch: 'Die E-Mail stimmt nicht mit der überein, mit der Du registriert bist.',
      confirm: 'Ja, Account löschen',
    },
    emailTemplates: {
      settings: {
        title: 'E-Mail-Einstellungen',
        addLangTitle: 'Neue Sprache konfigurieren',
        confirmDeleteLang: 'Bist Du sicher, dass Du die Sprache für E-Mails löschen möchtest?',
        enableDisableEmails: 'E-Mails aktivieren/deaktivieren',
        enableDisableEmailsDescr: 'Möchtest Du bestimmte E-Mails nicht mehr senden?',
        enableDisableEmailsTooltip:
          'Hier kannst du bestimmte E-Mails deaktivieren. Deaktiviert E-Mails werden nicht mehr versendet.',
        externalEmailLanguages: 'Externe E-Mail-Sprachen',
        externalEmailLanguagesTooltip:
          'Wähle aus, für welche Sprachen du E-Mail-Templates für externe Empfänger wie Kontakte außerhalb deiner Organisation erstellen möchtest. Diese Sprachen werden im Template-Editor verfügbar sein. Um eine neue Sprachoption hinzuzufügen, musst du diese zuerst in den Übersetzungseinstellungen konfigurieren.',
        internalEmailLanguages: 'Interne E-Mail-Sprachen',
        internalEmailLanguagesTooltip:
          'Wähle aus, für welche Sprachen du E-Mail-Templates für interne Empfänger (Teammitglieder mit Lemontaps-Konten) erstellen möchtest. Diese Sprachen werden im Template-Editor verfügbar sein. Du kannst hier nur zwischen deutsch und englisch auswählen.',
        setFallback: 'Als Fallback festlegen',
        addLang: 'Sprache hinzufügen',
        emailRecipients: 'E-Mail-Empfänger',
        emailRecipientsDescr: 'Konfiguriere die Empfänger der E-Mails.',
        changeRequestsEmailRecipients: 'E-Mail-Empfänger für Änderungsanfragen',
        editRecipients: 'Empfänger bearbeiten',
        addRecipient: 'Empfänger hinzufügen',
        recipient: 'E-Mail-Adresse des Empfängers',
        invalidEmail: 'Ungültige E-Mail-Adresse',
        automaticallySendFollowUpEmail:
          'Immer die Follow-Up-E-Mail senden, nachdem ein neuer Kontakt gespeichert wurde',
        automaticallySendFollowUpEmailTooltip:
          'Wenn diese Option aktiviert ist, wird die Follow-Up-E-Mail automatisch versendet, sobald ein neuer Kontakt erstellt wird, unabhängig davon, ob der Kontakt manuell über das Dashboard, durch den Visitenkartenscanner oder über das Kontaktformular auf der Profilseite erstellt wurde.',
      },
      contentCopied: 'Inhalt kopiert',
      errorCopying: 'Fehler beim Kopieren',
      contentPasted: 'Inhalt eingefügt',
      errorPasting: 'Fehler beim Einfügen',
      noContentToPaste: 'Es gibt keinen Inhalt zum Einfügen',
      copyTooltip: 'Inhalt der E-Mail kopieren',
      pasteTooltip: 'Inhalt der E-Mail einfügen',
      upgradeAlertTitle: 'Eingeschränkter E-Mail-Editor',
      upgradeAlertBody:
        'Du hast keine vollständigen Bearbeitungsrechte für den E-Mail-Editor und kannst daher die Schriftart und Farben nicht ändern, sowie keine Bilder hochladen und das Lemontaps Branding nicht entfernen.',
      noSetPasswordUrlAlert:
        'Der Platzhalter $SET_PASSWORD_URL$ ist aktuell nicht Teil der E-Mail. Ohne diese URL wird der*die eingeladene*r Benutzer*in nicht in der Lage sein, ein Passwort zu setzen, und sich damit einzuloggen.',
      selectTemplate: 'E-Mail auswählen',
      selectLanguage: 'Sprache auswählen',
      errorUploadingImage: 'Fehler beim Hochladen des Bildes',
      errorSaving: 'Fehler beim Speichern',
      errorSendingTestEmail: 'Fehler beim Senden der Test-E-Mail',
      successfullySaved: 'Erfolgreich gespeichert',
      testEmailSuccessfullySent: 'Test-E-Mail erfolgreich versendet',
      standardLocale: 'Standard',
      enLocale: 'Englisch',
      deLocale: 'Deutsch',
      'welcome-email-template': 'Einladungsemail an Mitarbeitende',
      'contact-share-email-template': 'Kontaktformular: E-Mail an Kontakt',
      'contact-received-email-template': 'Kontaktformular: Interne Notification',
      'generic-status-email': 'Generische Statusemail',
      'qr-bg-complete-email-template': 'Statusemail: Erstellung QR-Code-Hintergründe',
      'qr-complete-email-template': 'Statusemail: Erstellung QR-Codes',
      'card-order-confirmation-email-template': 'Kartenbestellungsbestätigungsemail',
      'referral-email-template': 'Empfehlungs-/Referral-E-Mail',
      'referral-referrer-template': 'Referral erfolgreich: E-Mail an Empfehlenden',
      'referral-recipient-template': 'Referral erfolgreich: E-Mail an Empfohlenen',
      'wallet-pass-mail-template': 'Wallet E-Mail',
      'onboarding-email-template': 'Onboarding E-Mail',
      testEmailSendPopupTitle: 'Test-E-Mail senden an',
      testEmailSendPopupSubtitle:
        'Die dynamischen Informationen in der E-Mail basieren auf den Daten aus deinem Profil.',
      sendTestEmail: 'Test-E-Mail senden',
      content: 'Inhalt',
      layout: 'Layout',
      columns: 'Spalten',
      column: 'Spalte',
      editView: 'Bearbeitungsansicht',
      desktopPreview: 'Desktop-Vorschau',
      mobilePreview: 'Mobil-Vorschau',
      duplicateTitle: 'Inhalt duplizieren nach',
      attachments: 'Anhänge',
      attachmentKeys: {
        'offline-apple-wallet': 'Offline Apple Wallet',
        'online-apple-wallet': 'Online Apple Wallet',
      },
    },
    emailSignature: {
      title: 'E-Mail-Signatur',
      management: {
        title: 'E-Mail-Signatur-Verwaltung',
        description:
          'Erstellen und verwalten Sie mehrere E-Mail-Signaturen mit regelbasierter Auswahl.',
        createSignature: 'Signatur erstellen',
        orderDescription:
          'Die Signaturen werden unten in der Reihenfolge angezeigt, in der sie ausgewertet werden.',
        noSignatures:
          'Keine Signaturen gefunden. Erstellen Sie Ihre erste Signatur, um zu beginnen.',
        fetchError: 'Fehler beim Abrufen der Signaturen',
        deleteSuccess: 'Signatur erfolgreich gelöscht',
        deleteError: 'Fehler beim Löschen der Signatur',
        deleteConfirmation:
          'Sind Sie sicher, dass Sie diese Signatur löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
        reorderSuccess: 'Signaturen erfolgreich neu angeordnet',
        reorderError: 'Fehler beim Neuordnen der Signaturen',
        lastEdited: 'Zuletzt bearbeitet',
        createdAt: 'Erstellt am',
        draft: 'Entwurf',
        actions: {
          edit: 'Bearbeiten',
          duplicate: 'Duplizieren',
          delete: 'Löschen',
        },
      },
      signatures: 'Signaturen',
      noSignatures: 'Keine Signaturen gefunden',
      createFirstSignature: 'Erstellen Sie Ihre erste Signatur, um zu beginnen',
      create: 'Signatur erstellen',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      duplicate: 'Duplizieren',
      activate: 'Aktivieren',
      deactivate: 'Deaktivieren',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      name: 'Name',
      description: 'Beschreibung',
      priority: 'Priorität',
      status: 'Status',
      rules: 'Regeln',
      languages: 'Sprachen',
      created: 'Erstellt',
      actions: 'Aktionen',
      tableView: 'Tabellenansicht',
      cardView: 'Kartenansicht',
      reordering: 'Signaturen werden neu angeordnet...',
      deleteSuccess: 'Signatur erfolgreich gelöscht',
      reorderSuccess: 'Signaturen erfolgreich neu angeordnet',
      updateSuccess: 'Signatur erfolgreich aktualisiert',
      createSuccess: 'Signatur erfolgreich erstellt',
      editSuccess: 'Signatur erfolgreich aktualisiert',
      duplicateSuccess: 'Signatur erfolgreich dupliziert',
      saveAsDraftSuccess: 'Signatur als Entwurf gespeichert',
      publishSuccess: 'Signatur erfolgreich veröffentlicht',
      wizard: {
        loadingSignature: 'Signatur wird geladen...',
        title: {
          create: 'Neue Signatur erstellen',
          edit: 'Signatur bearbeiten',
          duplicate: 'Signatur duplizieren',
        },
        saveAsDraft: 'Als Entwurf speichern',
        saveAndConvertToDraft: 'Speichern und in Entwurf umwandeln',
        publish: 'Veröffentlichen',
        next: 'Weiter',
        designSignature: 'Design Signatur',
        saveAndDesign: 'Speichern und gestalten',
        steps: {
          basicInfo: 'Name',
          senderRules: 'Absender',
          receiverRules: 'Empfänger',
          temporalRules: 'Scheduler',
          templateLogic: 'Template-Logik',
          languageConfig: 'Übersetzungen',
          signatureDesign: 'Design',
        },
        basicInfo: {
          title: 'Name',
          description: 'Um zu beginnen, benennen Sie Ihre Signatur und klicken Sie auf Weiter.',
          nameLabel: 'Name Ihrer Signatur',
          namePlaceholder: 'Global (Standard)',
          nameHelp: 'Geben Sie einen beschreibenden Namen für diese Signatur ein.',
          descriptionHelp: 'Optionale Beschreibung zur Identifizierung dieser Signatur.',
          priorityHelp:
            'Niedrigere Zahlen haben höhere Priorität (0 = höchste für Einheiten, 1 = Theme-Fallback).',
        },
        senderRules: {
          description: 'Wähle aus, welche Nutzer die Signatur verwenden können.',
          includeTitle: 'Folgende Absender einschließen:',
          excludeTitle: 'Folgende Absender ausschließen:',
          ruleType: 'Folgende Absender einschließen:',
          includeType: 'Einschlusstyp:',
          excludeType: 'Ausschlusstyp:',
          allSenders: 'Alle Absender',
          specificSenders: 'Bestimmte Absender',
          noExclusions: 'Keine Ausschlüsse',
          specificExclusions: 'Bestimmte Ausschlüsse',
          accounts: 'Accounts',
          units: 'Units',
          excludeAccounts: 'Accounts ausschließen',
          excludeUnits: 'Folgende Absender ausschließen:',
          selectAccounts: 'Accounts auswählen...',
          selectUnits: 'Units auswählen...',
          selectExcludeAccounts: 'Auszuschließende Accounts auswählen...',
          selectExcludeUnits: 'Auszuschließende Units auswählen...',
        },
        receiverRules: {
          title: 'Empfänger-Regeln',
          description:
            'Die Signatur kann auf alle gesendeten E-Mails oder nur auf bestimmte Empfänger angewendet werden.',
          comingSoon: 'Empfänger-Regeln-Konfiguration kommt bald...',
          receiverType: 'Empfängertyp',
          allReceivers: 'Alle Empfänger',
          internalOnly: 'Nur intern',
          externalOnly: 'Nur extern',
          specificEmails: 'Nur spezielle E-Mail-Adressen',
          includePatterns: 'Einschlussmuster (optional)',
          excludePatterns: 'Ausschlussmuster (optional)',
          includeReceivers: 'E-Mail-Adressen einschließen (optional)',
          includeReceiversHelp:
            'Geben Sie eine oder mehrere E-Mail-Adressen getrennt durch Semikolons ein.',
          includeReceiversLabel: 'E-Mail-Adressen einschließen',
          includeReceiversPlaceholder: 'E-Mail-Adressen eingeben...',
          includeReceiversExample: 'Beispiel: info@lemontaps.com; *@lemontaps.com; *@onmicrosoft.*',
          includePatternsHelp:
            'Geben Sie ein oder mehrere E-Mail-Muster getrennt durch Semikolons ein. Verwenden Sie * als Platzhalter.',
          excludePatternsHelp:
            'Geben Sie ein oder mehrere E-Mail-Muster zum Ausschließen ein, getrennt durch Semikolons. Verwenden Sie * als Platzhalter.',
          includePatternsLabel: 'E-Mail-Muster einschließen',
          excludePatternsLabel: 'E-Mail-Muster ausschließen',
          includePatternsPlaceholder: 'E-Mail-Muster eingeben...',
          excludePatternsPlaceholder: 'Auszuschließende E-Mail-Muster eingeben...',
          includePatternsExample: 'Beispiel: info@lemontaps.com; *@lemontaps.com; *@onmicrosoft.*',
          excludePatternsExample: 'Beispiel: noreply@lemontaps.com; *@spam.com',
        },
        temporalRules: {
          title: 'Zeit-Regeln',
          description: 'Konfigurieren Sie zeitbasierte Regeln für die Signaturauswahl.',
          comingSoon: 'Zeit-Regeln-Konfiguration kommt bald...',
          schedulerEnabled: 'Scheduler aktivieren',
          schedulerHelp:
            'Sie können diese Signaturregel kontinuierlich aktiv halten oder Zeitbereiche angeben, in denen diese Regel gilt.',
          timezone: 'Zeitzone auswählen',
          timeFrame: 'Zeitrahmen auswählen',
          selectTimeFrame: 'Zeitrahmen auswählen...',
          activeHours: 'Aktive Stunden',
          from: 'Von',
          to: 'Bis',
          info: 'Sie können diese Signaturregel kontinuierlich aktiv halten oder den Scheduler aktivieren, um Zeitbereiche anzugeben, in denen diese Regel Signaturen hinzufügt. Dieser Schritt ist optional und Sie können ihn überspringen.',
        },
        templateLogic: {
          title: 'Template-Logik',
          description: 'Konfigurieren Sie, wie diese Signatur als Template verfügbar sein soll.',
          templateAvailabilityQuestion:
            'Soll diese Signatur als Template für die ausgewählten Absender verfügbar sein, falls die Signatur nicht standardmäßig angewendet wird?',
          templateAvailabilityYes: 'Ja',
          templateAvailabilityYesWithRules: 'Ja, aber nur wenn die anderen Regeln zutreffen',
          templateAvailabilityNo: 'Nein',
          info: 'Dieser Schritt bestimmt, ob Benutzer diese Signatur manuell als Template-Option auswählen können.',
        },
        languageConfig: {
          title: 'Sprachkonfiguration',
          description:
            'Du kannst verschiedene Sprachversionen hinzufügen. Standardmäßig ist die Signatur in der Sprache des Nutzers. Dieser Schritt ist optional und du kannst ihn überspringen.',
          comingSoon: 'Sprachkonfiguration kommt bald...',
          active: 'Aktiv',
          contentPlaceholder: 'Signatur-Inhalt',
          contentHelp:
            'Geben Sie den Signatur-Inhalt für diese Sprache ein. Sie können HTML-Formatierung verwenden.',
          inactiveMessage:
            'Diese Sprache ist derzeit inaktiv. Aktivieren Sie sie, um Inhalte hinzuzufügen.',
          info: 'Konfigurieren Sie die Signatur-Inhalte für jede Sprache. Nur aktive Sprachen werden bei der Generierung von Signaturen verwendet.',
          enableTranslations: 'Übersetzungen aktivieren',
          fallbackLanguage: 'Fallback-Sprache',
          setAsFallback: 'Als Fallback festlegen',
          translationsDisabled:
            'Übersetzungen sind deaktiviert. Die Signatur verwendet die Standardsprache.',
        },
        signatureDesign: {
          title: 'Design',
          description: 'Gestalten Sie den Inhalt und das Layout Ihrer E-Mail-Signatur.',
          comingSoon: 'Signatur-Design-Konfiguration kommt bald...',
          contentEditor: 'Inhaltseditor',
          htmlContent: '{{language}} Inhalt',
          htmlPlaceholder: 'Geben Sie HTML-Inhalt für Ihre Signatur ein...',
          htmlHelp:
            'Sie können HTML-Tags für die Formatierung verwenden. Grundlegende Tags wie <b>, <i>, <a>, <img> werden unterstützt.',
          noActiveLanguages:
            'Keine aktiven Sprachen gefunden. Bitte aktivieren Sie mindestens eine Sprache im Schritt Sprachkonfiguration.',
          customHtml: 'Benutzerdefinierte HTML-Überschreibung',
          customHtmlHelp:
            'Optional: Überschreiben Sie das Template mit benutzerdefiniertem HTML. Dies ersetzt das Template vollständig.',
          customHtmlLabel: 'Benutzerdefiniertes HTML',
          customHtmlPlaceholder: 'Geben Sie benutzerdefinierten HTML-Code ein...',
          customHtmlHelper:
            'Erweitert: Verwenden Sie dies, um Ihre Signatur-HTML vollständig anzupassen.',
          previewInfo:
            'Sie können Ihre Signatur im nächsten Schritt oder nach dem Speichern in der Vorschau anzeigen.',
          readyToDesign: 'Bereit zum Designen Ihrer Signatur',
          designDescription:
            'Ihre Signatur-Konfiguration ist abgeschlossen. Klicken Sie auf die Schaltfläche unten, um zu speichern und den vollständigen E-Mail-Signatur-Designer zu öffnen, wo Sie schöne, professionelle Signaturen erstellen können.',
          saveAndDesign: 'Speichern und Designen',
          templateAvailabilityQuestion:
            'Soll diese Signatur als Template für die ausgewählten Absender verfügbar sein, falls die Signatur nicht standardmäßig angewendet wird?',
          templateAvailabilityYes: 'Ja',
          templateAvailabilityYesWithRules: 'Ja, aber nur wenn die anderen Regeln zutreffen',
          templateAvailabilityNo: 'Nein',
        },
      },
      branding: {
        title: 'E-Mail-Signatur Branding',
        font: 'Schriftart',
        textColor: 'Primäre Textfarbe',
        secondaryTextColor: 'Sekundäre Textfarbe',
        qrCodeColor: 'QR-Code Farbe',
        configureQrCode: 'QR-Code Farben konfigurieren',
        infoAlert:
          'Die Einstellungen gelten nur für neue Vorlagen. Bestehende Vorlagen werden nicht aktualisiert.',
      },
      overview: {
        videoTitle: 'Einführung in das Lemontaps Signatur-Tool',
        videoPlaceholder: 'Video-Tutorial',
        videoDescription:
          'Erfahre, wie du E-Mail-Signaturen mit Outlook einrichtest und verwendest',
        getStarted: 'Erste Schritte',
        connectOutlook: 'Mit Outlook verbinden',
        brandingSettings: 'Branding-Einstellungen',
        signatures: 'Signaturen',
      },
      setup: {
        title: 'Mit Outlook verbinden',
        step1: {
          title: 'Schritt 1: Integration testen - Lokale Installation für mein MS Outlook',
          description:
            'Teste das Add-in zuerst selbst - Team-Installation erfordert Outlook-Admin-Rechte und kann bis zu 6 Stunden zur Aktivierung dauern.',
          downloadTitle: '1. Manifest herunterladen',
          openAddin: '2. Öffne',
          openAddinInstructions: 'Dies öffnet das Add-in-Pop-up in Outlook.',
          downloadButton: 'Herunterladen',
          uploadManifest: '3. Manifest hochladen',
          uploadInstructions:
            "Wähle 'Meine Add-ins', gehe zu 'Benutzerdefiniertes Add-in hinzufügen' und klicke auf 'Aus Datei hinzufügen'",
          testAddin: '4. Add-in testen & Pop-up bestätigen',
          testInstructions: [
            'Schreibe eine neue E-Mail:',
            'Du siehst "Authentifizierung für Signatur fehlgeschlagen"',
            'ein Pop-up erscheint → erlaube es',
            'Jetzt sollte es funktionieren, du kannst mit dem Design der Signatur beginnen und sie sofort testen.',
          ],
        },
        step2: {
          openMsAdmin: '1. Gehe zu',
          insertManifest: '2. Füge den Manifest-Link ein',
          selectMemebers: '3. Wähle Mitglieder',
          selectMembersInstructions:
            'Für Testzwecke empfehlen wir, dass du das Add-in zunächst nur für dich oder ausgewählte Mitglieder verfügbar machst.',
          title: 'Schritt 2: Installation für dein Team',
          description: 'Du benötigst Administrator-Rechte in Microsoft 365',
          installationSteps:
            'Gehe zu Einstellungen → "Integrierte Apps" → "Benutzerdefinierte Apps hochladen" → Wähle "Office Add-In" unter App-Typ → Wähle "Link zur Manifest-Datei bereitstellen" → Füge den folgenden Link ein und klicke "Validieren" → klicke "weiter"',
          manifestLink: 'Manifest-Link',
          testRecommendation:
            'Für Testzwecke empfehlen wir, dass du das Add-in zunächst nur für dich oder ausgewählte Mitglieder verfügbar machst.',
          grantAccess: '4. Option: Zugriff für alle Mitglieder gewähren',
          grantInstructions:
            'Gehe zu Identität > Unternehmensanwendungen, suche nach "Outlook Signature Addin", klicke darauf, dann unter Sicherheit > Berechtigungen, klicke "Administrator-Zustimmung gewähren" um es für alle Benutzer zu aktivieren.',
        },
        helpArticle:
          'Für detailliertere Anweisungen (mit Screenshots) siehe bitte unseren Hilfeartikel',
        helpArticleLink: 'hier.',
      },
    },
    export: {
      refresh: 'Aktualisieren',
      title: 'Export',

      infoCard: {
        title: 'Export-Datei wird generiert',
        body: 'Dies kann etwas Zeit in Anspruch nehmen. Wir werden Dich per Email benachrichtigen, sobald diese zum Export bereitstehen.<0/><1>Hinweis</1>: Es könnte passieren, dass die Email von Deiner Firmen-IT blockiert wird. In diesem Fall schau bitte direkt auf der Export-Seite nach dem Status.',
      },
      emptyCard: {
        title: 'Keine Dateien gefunden',
        body: 'Du hast in den letzten 14 Tagen keine Dateien exportiert.',
      },
      fileCard: {
        errorTitle: 'Export fehlgeschlagen.',
        runningTitle: 'Export-Datei wird generiert...',
        date: 'Exportiert {{date}}',
        status: {
          running: 'Export läuft...',
          finished: 'Export abgeschlossen',
          failed: 'Fehlgeschlagen',
        },
        action: {
          download: 'Herunterladen',
          retry: 'Erneut versuchen',
          contact: 'Unerwarteter Fehler. Bitte kontaktiere: <0>support@lemontaps.com</0>',
        },
        header: {
          qrPlain_one: '{{count}} {{type}} QR-Code',
          qrPlain_other: '{{count}} {{type}} QR-Codes',
          qrBg_one: '{{count}} QR-Code Hintergrund',
          qrBg_other: '{{count}} QR-Code Hintergründe',
          appleWallet_one: '{{count}} {{type}} Apple Wallet-Pass',
          appleWallet_other: '{{count}} {{type}} Apple Wallet-Pässe',
          googleWallet_one: '{{count}} {{type}} Google Wallet-Pass',
          googleWallet_other: '{{count}} {{type}} Google Wallet-Pässe',
        },
      },
    },
    verify: 'Verifizieren',
    domains: {
      confirmClaimTitle: 'Bestätige, um fortzufahren',
      confirmClaimDescription: 'Bestätige, dass Du die ausgewählten Accounts importieren möchtest.',
      infoNotAvailable: 'Erst nach Verifizierung verfügbar',
      infoManagedAccountsCount:
        'Anzahl der Accounts in deinem Team, die mit dieser E-Mail-Domäne registriert sind.',
      infoAvailableToClaimCount:
        'Anzahl der Accounts, die mit dieser E-Mail-Domäne außerhalb deines Teams registriert sind, und die du in dein Team importieren kannst. Diese Information ist nur nach der Domänenverifizierung verfügbar.',
      infoAllAccountsCount: 'Summe der beiden anderen Spalten.',
      pageTitle: 'E-Mail-Domänen',
      domain: 'Domäne',
      settings: 'Einstellungen',
      autoClaimUserTooltipText:
        'Alte Benutzer können durch Klicken auf die Schaltfläche „Accounts importieren" importiert werden.',
      searchPlaceholder: 'Nach einer Domäne suchen',
      add: 'Domäne hinzufügen',
      edit: 'Domäne bearbeiten',
      allAccounts: 'Alle Accounts',
      availableToClaim: 'Importieren möglich',
      managedAccounts: 'Kontrollierte Accounts',
      domainInvalid: 'Falsch formatiert',
      verifyDomain: 'Domäne verifizieren',
      claimAccounts: 'Accounts importieren',
      noDomainsFound: 'Keine Domänen gefunden',
      noDomainsAreAdded: 'Es wurden noch keine Domäne hinzugefügt',
      verifySuccess: 'Domäne erfolgreich verifiziert',
      verifyError:
        'Fehler bei der Verifizierung der Domäne. Stelle sicher, dass die Domäne erreichbar und korrekt eingerichtet ist und die DNS-Einträge stimmen.',
      errorSaving: 'Fehler beim Speichern der Domäne',
      successClaimingAccounts: 'Accounts erfolgreich importiert',
      errorClaimingAccounts: 'Fehler beim Importieren der Accounts',
      deleteMsg: 'Bist Du sicher, dass Du diese Domäne löschen möchtest?',
      nameHostAlias: 'Name des Datensatzes',
      enterDomain: 'Domäne eingeben',
      ttl: 'Gültigkeitsdauer (TTL)',
      recordType: 'Art des Datensatzes',
      recordOrData: 'Wert',
      accountsToClaim: 'Zu importierende Accounts',
      reviewAccounts: 'Accounts überprüfen',
      exportDescription_one:
        'Exportiere eine Excel-Datei, um den Account zu sehen, der eine @{{domain}}-E-Mail verwendet, und den Du in Dein Team importieren kannst.',
      exportDescription_other:
        'Exportiere eine Excel-Datei, um die {{count}} Accounts zu sehen, die eine @{{domain}}-E-Mail verwenden, und die Du in Dein Team importieren kannst.',
      exportDescription_:
        'Exportiere eine Excel-Datei, um die {{count}} Accounts zu sehen, die eine @{{domain}}-E-Mail verwenden., und die Du in Dein Team importieren kannst.',
      exportAccounts: 'Account-E-Mails herunterladen',
      chooseAccounts: 'Wähle die zu importierenden Accounts aus',
      accountClaimTypes: {
        all_one: '1 Account importieren',
        all_other: 'Alle {{count}} Accounts importieren',
        specific: 'Bestimmte Accounts importieren',
      },
      createTxtRecord: 'Einen neuen TXT-Record erstellen',
      createTxtRecordDescription:
        'Kopiere die Informationen aus allen Feldern und füge sie in den Einstellungen Deines DNS-Managementsystems ein.',
      verifyTxtRecord: 'Den TXT-Eintrag verifizieren',
      verifyTxtRecordDescription:
        'Nachdem Du den TXT-Eintrag hinzugefügt hast, kannst Du die Domäne verifizieren.',
      verifyAlertTitle: 'Belasse den DNS-Eintrag auf dem Server.',
      verifyAlertDescription:
        'Denke daran, den DNS-Eintrag auf dem Server zu belassen (nicht löschen). Er wird möglicherweise regelmäßig überprüft.',
      settingsOf: 'Einstellungen von {{domain}}',
      newUsers: 'Neue Benutzer:innen',
      autoClaimUsersTitle: 'Neue Benutzer automatisch importieren',
      autoClaimUsersDescription:
        'Füge Benutzer:innen, die sich bei Lemontaps anmelden, automatisch zu Deinem Team hinzu.',
      autoClaimToUnit: 'Neue Benutzer:innen der folgenden Unit hinzufügen:',
      deleteError: 'Fehler beim Löschen der Domäne',
      deleteSuccess: 'Domäne erfolgreich gelöscht',
      notifyOnAccountClaimTitle: 'Freigabeprozess aktivieren',
      notifyOnAccountClaimDescription:
        'Erhalte eine Benachrichtigung für jede:n automatisch importierte:n Benutzer:in, um deren Informationen zu überprüfen.',
    },
    idp: {
      manageDomains: 'E-Mail-Domänen verwalten',
      active: 'Aktiv',
      notActive: 'Nicht aktiv',
      setupScim: 'Setup SCIM',
      teaserDescription:
        'Setze SSO und Nutzer:innenprovisionierung auf. Kompatibel mit den meisten Identitätsanbietern.',
      identityProvider: 'Identitätsanbieter',
      listPageTitle: 'Wähle einen Identitätsanbieter',
      listPageDescription:
        'Integriere euren Identitätsanbieter. Richte Single Sign-On und Benutzersynchronisierung ein.',
      settingsPageDescription:
        'Verwalte die Integration deines Identity Providers. Konfiguriere Single Sign-On und SCIM-Provisionierung.',
      choose: 'Wählen',
      addIdentityProviderDirectory: 'Identitätsanbieterverzeichnis hinzufügen',
      directoryName: 'Verzeichnisname',
      createSuccess: 'Verzeichnis des Identitätsanbieters erfolgreich erstellt',
      createError: 'Fehler beim Erstellen des Identitätsanbieterverzeichnisses',
      updateSucess: 'Identitätsanbieterverzeichnis erfolgreich aktualisiert',
      updateError: 'Fehler beim Aktualisieren des Identitätsanbieterverzeichnisses',
      settings: 'Einstellungen',
      renameDirectory: 'Verzeichnis umbenennen',
      dirName: 'Verzeichnisname',
      deleteConfiguration: 'Konfiguration löschen',
      edit: 'Bearbeiten',
      try: 'Testen',
      deleteSuccess: 'Identitätsanbieterverzeichnis erfolgreich gelöscht',
      deleteError: 'Fehler beim Löschen des Identitätsanbieterverzeichnisses',
      deleteMessage: 'Are you sure you want to delete this directory?',
      disconnect: {
        title: 'Bevor Du die Verbindung trennen kannst',
        description: 'Bevor Du den Identitätsanbieter trennen kannst, musst Du dies tun:',
        bulletPoints: '• SSO-Konfiguration löschen\n• Benutzerbereitstellungskonfiguration löschen',
        anchorText: 'Erfahren Sie mehr darüber, wie Sie die Verbindung trennen',
      },
      scim: {
        schemaRefresh: 'Neu laden',
        openProfile: 'Profil öffnen',
        openUserSchemaAnalyzer: 'User Schema Analyzer',
        openLtAttributesSidebar: 'Verfügbare Attribute',
        ltAttributesSidebarDescription:
          'Hier findest du alle Attribute, die du ins das SCIM Mapping einfügen kannst.',
        userSchemaAnalyzerInfo:
          'Hier kannst du das SCIM User Schema von per SCIM provisionierten Benutzer:innen anzeigen und analysieren. Das sind die Rohdaten, wie sie von deinem Identitätsanbieter an Lemontaps gesendet wurden. Bearbeiten ist hier nicht möglich.',
        noSchemaFound:
          'Diese:r Benutzer:in wurde nicht per SCIM provisioniert. Es ist also kein Schema verfügbar.',
        settings: 'Weitere Einstellungen',
        editAttributeMapping: 'Mapping bearbeiten',
        attributeMappingTitle: 'Attribut-Mapping',
        attributeMappingDescription:
          'Hier kannst du das Mapping von SCIM-Attributen (rechts) auf Lemontaps-Attribute (links) bearbeiten.',
        inviteUserUponProvisioning: 'Einladung automatisch bei Provisionierung versenden',
        title: 'SCIM-Provisionierung',
        description:
          'Hier kannst du die automatische Benutzerprovisionierung und -deprovisionierung per SCIM einrichten und verwalten.',
        isActive:
          'SCIM ist aktiv. Um Provisionierungseinstellungen anzupassen, verwalte die SCIM-Konfiguration in deinem Identitätsanbieter.',
        setupProvisioning: 'Jetzt Einrichtung starten',
        syncedUsers: 'Synchronisierte Benutzer:innen',
        regenerateApiKey: 'API-Schlüssel neu generieren',
        deleteConfigurationConfirmation:
          'Bist Du sicher, dass Du diese Konfiguration löschen möchtest?',
        deleteConfigurationSuccess: 'SCIM-Konfiguration gelöscht',
        deleteConfigurationError: 'Fehler beim Löschen der SCIM-Konfiguration',
        stupScimProvisioning: 'SCIM-Einrichtung',
        saveConfig: 'SCIM-Konfiguration speichern',
        learnMoreAboutScim: 'Erfahren Sie mehr über die SCIM-Bereitstellung',
        regenerateKey: 'Schlüssel neu generieren',
        updateSuccess: 'SCIM-Konfiguration erfolgreich aktualisiert',
        updateError: 'Fehler beim Aktualisieren der SCIM-Konfiguration',
        applyMapping: 'Mapping erneut anwenden',
        applyMappingInfo:
          'Wenn du das Mapping erneut anwendest, werden alle Profil-Attribute, die im oben definierten Mapping definiert sind, entsprechend ihrer Zuordnung neu beschrieben. Dabei werden keine Werte geleert, es werden bloß Werte überschrieben.',
        applyMappingConfirmationDescription:
          'Das Mapping wird neu angewendet, was in unerwünschten Änderungen bei den Profilen führen kann. Möchtest du fortfahren?',
        applyMappingSuccess: 'Mapping erfolgreich angewendet',
        reApplyMappingOnSave: 'Mapping anwenden nach Speichern',
        updateMappingError: {
          unrecognized_keys: 'Ungültige Lemontaps-Attribute: {{keys}}',
          custom: 'Aktualisieren des Mappings fehlgeschlagen',
          invalid_union: 'Werte sollten eine Zeichenkette oder ein Array von Zeichenketten sein',
        },
        steps: {
          beforeYouBegin: {
            stepperTitle: 'Vor dem Start',
            title: 'Vor dem Start',
            description:
              'Bevor Sie die Benutzerbereitstellung über SCIM einrichten, empfehlen wir Ihnen: \nErstellen Sie Testkonten und -gruppen bei Ihrem Identitätsanbieter, um zu verhindern, dass bestehende Benutzer den Produktzugriff verlieren. Wenn Sie Ihren Identitätsanbieter zum ersten Mal verbinden und synchronisieren, können Sie diese Testkonten und -gruppen verwenden, um sicherzustellen, dass alles funktioniert.',
            description2: 'Nachdem die Einrichtung abgeschlossen ist, wird Folgendes möglich sein:',
            description3:
              '• Benutzer:innendetails über den IdP verwalten \n• Automatische Provisionierung von Nutzer:innen \n• Automatische De-Provisionierung von Nutzer:innen',
          },
          setupScim: {
            stepperTitle: 'SCIM einrichten',
            title: 'Details',
            description:
              'Um die Benutzerbereitstellung über SCIM einzurichten und Deinen Identity Provider mit Lemontaps zu verbinden, kopiere die SCIM Base-URL und den API Key in Deinen Identity Provider. Trage "userName" als Unique Identifier ein, falls Du danach gefragt wirst.',
            scimBaseUrl: 'SCIM-Base-URL',
            apiKey: 'API-Key',
            apiKeyHelperText:
              'Wir speichern den API-Key nicht. Wir empfehlen, ihn an einem sicheren Ort aufzubewahren.',
          },
          saveConfig: {
            stepperTitle: 'Konfiguration speichern',
            title: 'SCIM-Konfiguration speichern',
            description:
              'Du hast gerade die Einrichtung von SCIM abgeschlossen. Jetzt kannst Du Benutzer:innen aus deinem Identity Provider heraus verwalten.',
          },
          regenerate: {
            stepperTitle: 'Schlüssel neu generieren',
            title: 'API-Schlüssel neu generieren',
            description:
              'Durch das Generieren eines neuen API-Schlüssels wird der vorhandene Schlüssel deaktiviert. Aktualisiere die Authentifizierungsinformationen in Deinem Identity Provider mit den neuen Details, um die Provisionierung mit Deinem Identity Provider fortzusetzen.',
          },
          apiKeys: {
            stepperTitle: 'API-Schlüssel',
          },
        },
      },
      sso: {
        selfServiceTicketPopup: {
          title: 'Self-Service Ticket URL',
          description:
            'Kopiere die folgende URL und stelle sie deiner IT-Abteilung zur Verfügung. Mit dieser URL können sie die SSO-Konfiguration einrichten oder bearbeiten.',
          inputLabel: 'Self-Service Ticket URL',
          buttonLabel: 'Self-Service Ticket URL generieren',
          buttonGenerateLabel: 'Self-Service Ticket URL generieren',
          error: 'Fehler beim Abrufen der Self-Service Ticket URL',
        },
        successEnabled:
          'SSO ist aktiv. Alle Benutzer:innen der konfigurierten E-Mail-Domänen müssen SSO verwenden, um sich einzuloggen.',
        renewSecret: 'Secret erneuern',
        editDomains: 'E-Mail-Domänen bearbeiten',
        editConfiguration: 'Konfiguration bearbeiten',
        test: 'Testen',
        disable: 'SSO deaktivieren',
        enable: 'SSO aktivieren und erzwingen',
        warningNoDomainsConfigured:
          'SSO ist aktiviert, aber wird zurzeit durch keine Benutzer:innen verwendet, da keine E-Mail-Domänen hinzugefügt wurden.',
        warningNotEnabled:
          'SSO wurde konfiguriert, ist aber noch nicht aktiviert. Aktiviere SSO nur, nachdem du einen erfolgreichen Test ausgeführt hast und alle benötigten E-Mail-Domänen hinzugefügt wurden. Du kannst dich ansonsten aus deinem Account aussperren.',
        warningNotEnabled2:
          'Nachdem SSO aktiviert ist, müssen alle Benutzer:innen mit den konfigurierten E-Mail-Domänen SSO verwenden, um sich einzuloggen.',
        noDomainsAvailable:
          'Mindestens eine verifizierte E-Mail-Domain muss eingerichtet werden, um mit der Konfiguration zu beginnen.',
        selfServiceStarted: 'Schließe die Einrichtung in dem separaten Tab ab...',
        recover: {
          title: 'SSO-Zugriff wiederherstellen',
          description:
            'Gib deine E-Mail-Adresse ein, um Anweisungen zur Wiederherstellung des SSO-Zugangs zu erhalten. Die E-Mail-Adresse muss mit der eines Admin-Accounts übereinstimmen.',
          emailLabel: 'E-Mail-Adresse',
          submit: 'Wiederherstellungsanweisungen senden',
        },
        testSuccess: 'SSO-Konfiguration erfolgreich getestet.',
        testError: 'Fehler beim Testen der SSO-Konfiguration. Überprüfe die Einstellungen.',
        testInProgress: 'SSO-Setup wird in separatem Tab getestet. Warte auf schließen des Tabs...',
        testCanceled: 'Test abgebrochen.',
        testCancelButtonLabel: 'Abbrechen',
        testDialog: {
          title: 'SSO-Setup Testen',
          description: 'Um die SSO-Verbindung zu testen, folge diesen Schritten:',
          steps: `<0>Kopiere den folgenden Link:</0>
          <1></1>
          <0>Öffne ein Inkognito-Fenster und öffne dort den Link.</0>
          <2>Du solltest den Link in einem anderen Browser-Kontext öffnen, da du ansonsten aus deiner hier bestehenden Session abgemeldet wirst.</2>
          <0>Authentifiziere dich dort mit der konfigurierten SSO-Strategie.</0>
          <0>Dort kannst du debuggen. Wenn du eine erfolgreiche Authentifizierung abgeschlossen hast, siehst du einen Success-Screen. Dann kannst du diesen Dialog schließen und SSO aktivieren.</0>
          <2>Aktiviere SSO nur dann, wenn du einen erfolgreichen Test ausgeführt hast. Du kannst dich ansonsten aus deinem Account aussperren.</2>`,
          copyValueLabel: 'SSO-Test-Link',
        },
        pasteJson: 'JSON einfügen',
        enterUrl: 'URL eingeben',
        enterDiscoveryUrlOrJson: 'Discovery URL oder JSON einfügen',
        discoveryUrl: 'Discovery URL',
        discoveryJson: 'Discovery JSON',
        notSupportedStrategyTitle: 'Anpassung nicht möglich',
        notSupportedStrategyDescription:
          'Die aktuelle SSO-Strategy wird derzeit nicht vollständig unterstützt. Um Änderungen vorzunehmen, kontaktiere unseren Support.',
        connectionEnabled: 'SSO aktiviert',
        cardTitle: 'Single Sign-On',
        cardDescription: 'Hier kannst du Single Sign-On (SSO) einrichten und verwalten.',
        buttonText: 'Jetzt Einrichtung starten',
        setupSaml: 'Richte Single Sign-On ein',
        pageTitle: 'SSO-Konfiguration',
        entityId: 'Entity Id',
        singleSignOnUrlForCopy: 'Single Sign-On URL',
        signInUrl: 'Sign-in URL',
        signOutUrl: 'Sign-out URL',
        certificate: 'x509 Certificate',
        signInUrlHelper: 'signInUrlHelper',
        signOutUrlHelper: 'signOutUrlHelper',
        certificateHelper: 'certificateHelper',
        selectDomains: 'Domänen auswählen',
        oktaDomain: 'Okta Domain',
        oktaDomainHelper: 'oktaDomainHelper',
        clientID: 'Client ID',
        clientIDHelper: 'clientIDHelper',
        clientSecret: 'Client Secret',
        clientSecretHelper: 'clientSecretHelper',
        entraIdDomain: 'Entra ID Domain',
        entraIdDomainHelper: 'entraIdDomainHelper',
        metaDataUrl: 'Metadata URL',
        metaDataUrlHelper: 'metaDataUrlHelper',
        identityAPI: 'Identity API',
        azureActiveDirectoryV1: 'Azure Active Directory v1',
        microsoftIdentityPlatformV2: 'Microsoft Identity Platform v2',
        updateSuccess: 'Die SSO-Konfiguration wurde erfolgreich aktualisiert',
        updateError: 'Error updating SSO configuration',
        deleteSuccess: 'Fehler beim Aktualisieren der SSO-Konfiguration',
        deleteError: 'Fehler beim Löschen der SSO-Konfiguration',
        deleteConfigurationConfirmation:
          'Bist Du sicher, dass Du diese Konfiguration löschen möchtest?',
        learnMoreAboutSaml: 'Learn more about Single Sign-On',
        learnMoreAboutDomains: 'Learn more about linking domains',

        copySection: {
          title: 'URLs zu Identitätsanbieter kopieren',
          description: 'description',
        },
        editSection: {
          title: 'Bearbeite die SSO-Konfiguration',
          description: 'description',
        },
        domainSection: {
          title: 'Domänen',
          description: 'E-Mail-Domänen, die via SSO authentifiziert werden sollen.',
        },
        steps: {
          beforeYouBegin: {
            stepperTitle: 'Vor dem Start',
            title: 'Vor dem Start',
            description: 'Beachte folgende Hinweise:',
            description2:
              '• SSO erlaubt es euren Nutzer:innen, sich mit den Firmenzugangsdaten bei Lemontaps zu authentifizieren.\n• Achte darauf, dass auch die IdP-Seite korrekt konfiguriert ist.',
            description3:
              'Nach dem Setup-Wizard kann die SSO-Verbindung getestet werden. Erst danach darf SSO aktiviert werden.',
            selectStrategy: 'Strategie wählen',
            setupDomainFirst: 'Verifiziere zuerst mindestens eine Domain',
          },
          copyUrls: {
            stepperTitle: 'Werte kopieren',
            title: 'Werte kopieren',
            description:
              'Copy the values and enter them in the appropriate place in the identity provider.',
          },
          addSaml: {
            stepperTitle: 'Werte eintragen',
            title: 'Werte eintragen',
            description: 'Trage die benötigten Werte hier ein:',
            setupUsingMetadata: 'Trage einfach die Metadaten-URL Deines Identitätsanbieters ein',
            or: 'ODER',
            setupManually: 'Manuell eintragen',
          },
          linkDomain: {
            stepperTitle: 'Domain verknüpfen',
            title: 'Domain verknüpfen',
            description: 'Verknüpfe mindestens eine Domain mit dieser SSO-Konfiguration.',
            manageDomains: 'Domains verwalten',
          },
          save: {
            stepperTitle: 'Speichern und fortfahren',
            title: 'Konfiguration gespeichert',
            description:
              'Du hast gerade die Einrichtung von SSO abgeschlossen. Jetzt kannst Du SSO erzwingen.',
          },
        },
      },
    },
    crmIntegration: {
      campaignConfigurator: {
        title: 'Kampagnenzuordnung',
        subheader: 'Möchtest du beim Export von Kontakten nach Salesforce eine Kampagne zuweisen?',
        selectCampaign: 'Wähle eine Kampagne aus',
        assignment: {
          noAssignment: 'Keine Kampagne zuweisen',
          letUserChoose: 'Du kannst bei jedem Export eine Kampagne auswählen',
          autoAssign: 'Automatisch einer Kampagne zuweisen',
        },
        success: 'Die Kampagnenzuordnung wurde erfolgreich aktualisiert.',
        error: 'Beim Aktualisieren der Kampagnenzuordnung ist ein Fehler aufgetreten.',
      },
      title: 'CRM Integration',
      description:
        'Verbinde Euer CRM mit Lemontaps, um Lemontaps Kontakte automatisch oder manuell an Euer CRM als Kontakte oder Leads zu senden. Bitte lese Dir den Hilfeartikel durch, um zu sehen, welche Attribute gesendet werden.',
      settingsCard: {
        additionalSettings: 'Weitere Einstellungen',
        pushNonSupportedCustomFields: 'Benutzerdefinierte Felder',
        shouldPushNonSupportedCustomFields: 'Antworten als Text ins Notizfeld übetragen',
        title: 'Allgemeine CRM-Integrationseinstellungen',
        autoSync:
          'Automatischer Export: Aktiviere diesen Workflow, um neue Kontakte sofort nach der Erstellung automatisch an das CRM zu senden.',
        manualSync:
          'Manueller Push: Aktiviere diesen Workflow, um zu entscheiden, welche Kontakte an das CRM gesendet werden sollen.',
        headerSyncType: 'Manueller oder Automatischer Export',
        headerUseLeads: 'Als Kontakte oder Leads exportieren',
        contacts: 'Kontakte: Lemontaps-Kontakte in CRM-Kontakte umwandeln',
        leads: 'Leads: Lemontaps-Kontakte in CRM-Leads umwandeln',
        notSpecified: 'Ermögliche Benutzer:innen die Auswahl zwischen „Kontakt“ und „Lead“.',
      },
      crmListCard: {
        title: 'Verwalte Deine CRM-Integrationen',
        subheader:
          'Wir unterstützen nachfolgende CRM Systeme. Klicke auf ein CRM System, um mit der Konfigurierung zu beginnen oder es zu bearbeiten.',
      },
      upgradeAlert: {
        title:
          'Verbinde Euer CRM mit Lemontaps, um per Lemontaps gesammelte Kontakte als CRM-Leads zu exportieren.',
        description:
          'Wähle zwischen einer automatischen Synchronisierung und einem manuellen Push.',
        learnMore: 'Erfahre mehr über die CRM-Integration',
      },
      exportStarted: 'Export zu {{crm}} gestartet am {{datetime}}',
      exportErrorDetails: 'Error-Details',
      exportFailedAuthorization:
        'Export zu {{crm}} fehlgeschlagen am {{datetime}} aufgrund eines Authorisierungsfehlers',
      exportedWithoutOwner: {
        lead: 'Am {{datetime}} zu {{crm}} als Lead exportiert (ohne Owner).',
        contact: 'Am {{datetime}} zu {{crm}} als Kontakt exportiert (ohne Owner).',
        notSpecified: 'Am {{datetime}} zu {{crm}} exportiert (ohne Owner).',
      },
      exportedWithOwner: {
        lead: 'Am {{datetime}} zu {{crm}} als Lead exportiert (mit Owner).',
        contact: 'Am {{datetime}} zu {{crm}} als Kontakt exportiert (mit Owner).',
        notSpecified: 'Am {{datetime}} zu {{crm}} exportiert (mit Owner).',
      },
      exportFailed: {
        lead: 'Export zu {{crm}} als Lead fehlgeschlagen am {{datetime}}',
        contact: 'Export zu {{crm}} als Kontakt fehlgeschlagen am {{datetime}}',
        notSpecified: 'Export zu {{crm}} fehlgeschlagen am {{datetime}}',
      },
      exportFailedDuplicate: {
        lead: 'Export zu {{crm}} als Lead fehlgeschlagen am {{datetime}} (Duplikat)',
        contact: 'Export zu {{crm}} als Kontakt fehlgeschlagen am {{datetime}} (Duplikat)',
        notSpecified: 'Export zu {{crm}} fehlgeschlagen am {{datetime}} (Duplikat)',
      },
      exportedOutlook:
        'Am {{datetime}} zu {{crm}} exportiert (mit Owner). Es kann mehrere Stunden dauern, bis der Kontakt in Outlook sichtbar wird',
      status: {
        notConnected: 'Nicht verbunden',
        added: 'Konfiguration erforderlich',
        authorized: 'Konfiguration erforderlich',
        invalid: 'Falsche Konfiguration',
        callable: 'Verbunden',
        disabled: 'Deaktiviert',
      },
    },
    selectAllTexts: {
      profile: 'Alle {{count}} Profile auswählen?',
      lead: 'Alle {{count}} Leads auswählen?',
    },
    dropzone: {
      title: 'Datei hier ablegen oder klicken, um hochzuladen',
      errors: {
        'file-invalid-type': 'Ungültiges Dateiformat. Akzeptierte Formate: {{formats}}',
        'file-too-large': 'Die Datei ist zu groß (<{{maxSize}}MB für .{{ext}}).',
        'file-too-small': 'Die Datei ist zu klein.',
        'too-many-files': 'Zu viele Dateien hochgeladen.',
      },
    },
    filter: {
      title: 'Filter',
      addFilter: 'Filter hinzufügen',
      searchLabel: 'Suche',
      operators: {
        is_in: 'ist in',
        is_not_in: 'ist nicht in',
        is_equal: 'ist gleich',
        is_not_equal: 'ist nicht gleich',
        is_like: 'enthält',
        is_not_like: 'enthält nicht',
        is_greater: 'ist größer als',
        is_greater_or_equal: 'ist größer oder gleich',
        is_less: 'ist kleiner als',
        is_less_or_equal: 'ist kleiner oder gleich',
        has_value: 'ist nicht leer',
        has_no_value: 'ist leer',
      },
      crmExportStatusOptions: {
        success: 'Erfolgreich',
        error: 'Fehler',
        pending: 'Im Export-Prozess',
        errorDuplicate: 'Fehler (Duplikat)',
      },
    },
    ariaOpenSettings: 'Profil-Einstellungen öffnen',
    ariaPreviewProfile: 'Profilvorschau',
    ariaCopyProfileUrl: 'Profil-URL kopieren',
    ariaDownloadProfileQrCodePNG: 'QR-Code herunterladen PNG',
    ariaDownloadProfileQrCodeSVG: 'QR-Code herunterladen SVG',
    ariaViewAllAnalytics: 'Gesamte Statistiken anzeigen',
    ariaviewAllLeads: 'Alle Kontakte anzeigen',
    ariaSendInviteAfterUserCreate: 'Einladung nach Benutzererstellung senden',
    ariaSendInviteToSelected: 'Einladung an ausgewählte Benutzer senden',
    ariaBulkEditSelected: 'Ausgewählte Benutzer in großen Mengen bearbeiten',
    ariaExportSelected: 'Ausgewählte exportieren',
    ariaUnitAssignSelected: 'Ausgewählte Benutzer der Einheit zuweisen',
    ariaDeleteNfcCard: '{{name}} NFC-Karte löschen',
    ariaShareAnalytics: 'Analysen teilen',
    ariaOpenDateRangeSelector: 'Datumsbereichsselektor öffnen. Aktuell ausgewählt: ',
    ariaCloseDrawer: 'Schublade schließen',
    ariaBulkOverride: 'Ausgewählte Massenoption: Überschreiben',
    ariaBulkDelete: 'Ausgewählte Massenoption: Löschen',
    ariaShareQrInfo: 'QR-Anweisungen teilen',
    ariaQrDownloadPNG: '{{type}} QR-Code herunterladen PNG',
    ariaQrDownloadSVG: '{{type}} QR-Code herunterladen SVG',
    ariaQrDownloadAppleWallet: '{{type}} QR-Code für Apple Wallet herunterladen',
    ariaQrDownloadGoogleWallet: '{{type}} QR-Code für Google Wallet herunterladen',
    ariaShareWhatsApp: 'Über WhatsApp teilen',
    ariaShareEmail: 'Per E-Mail teilen',
    ariaShareLinkedIn: 'Über LinkedIn teilen',
    ariaWebShare: 'Über Web Share API teilen',
    ariaSaveContactColor: 'Farbe "Kontakt speichern" - {{color}}',
    ariaFilesColor: 'Dateifarbe - {{color}}',
    ariaGenericWebsiteLinkColor: 'Allgemeine Website-Link-Farbe - {{color}}',
    ariaCoverImageSettings: 'Coverbild-Einstellungen öffnen',
    ariaProfileImageSettings: 'Profilbild-Einstellungen öffnen',
    ariaLogoImageSettings: 'Logo-Einstellungen öffnen',
    ariaFaviconImageSettings: 'Favicon-Einstellungen öffnen',
    ariaDelete: '{{name}} löschen',
    ariaEdit: '{{name}} bearbeiten',
    ariaAddLinkTemplate: 'Linkvorlage hinzufügen',
    ariaAddAddressTemplate: 'Adressvorlage hinzufügen',
    ariaAddBioContent: 'Standard-Profilattribut hinzufügen',
    ariaAddFileTemplate: 'Dateivorlage hinzufügen',
    ariaSelect: '{{name}} auswählen',
    ariaUnitViewMembers: 'Mitglieder der Unit {{name}} anzeigen',
    ariaSettings: '{{name}} - Weitere Optionen anzeigen',
    ariaProfileStatusActions: 'Statusaktionen von {{name}} anzeigen',
    ariaEditUser: '{{name}} bearbeiten',
    ariaEditContact: '{{name}} bearbeiten',
    ariaBusinessCardImageSettings: 'Visitenkartenbild-Einstellungen öffnen',
    ariaCloseScanner: 'Visitenkartenscanner schließen',
    ariaGoBackToPreviewsScreen: 'Zurück zum vorherigen Bildschirm',
    ariaBusinessCardImagesToggler: 'Sichtbarkeit von Visitenkartenbildern umschalten',
    ariaRefreshCampaigns: 'Kampagnen aktualisieren',
    ariaSaveCrmConfiguration: 'CRM-Konfiguration speichern',
    ariaOpenIdpSettings: 'IDP-Einstellungen öffnen',
    ariaOpenScimSettings: 'SCIM-Einstellungen öffnen',
    ariaOpenSsoSettings: 'SSO-Einstellungen öffnen',
    ariaClickToCopy: 'Klicken, um zu kopieren',
    ariaRefreshCrmConfigurations: 'CRM-Konfigurationen aktualisieren',
    ariaToggleVCardFieldVisibility: 'Toggle "{{field}}" field visibility',
    ariaRedirectBusinesssCardTo: '{{name}} als Ziel für Visitenkarte festlegen',
    ariaHideLinkFromProfile: '{{link}} auf Visitenkarte ausblenden',
    ariaEditMessage: '{{name}} - Bearbeiten',
    ariaDeleteMessage: '{{name}} - Löschen',
    ariaHideMessage: '{{name}} - Ausblenden auf Visitenkarte',
    ariaShowMessage: '{{name}} - Einblenden auf Visitenkarte (wird zurzeit nicht angezeigt)',
    ariaRedirectMessage: '{{name}} - Als Ziel für Visitenkarte festlegen.',
    ariaRedirectOffMessage: '{{name}} - Als Ziel für Visitenkarte deaktivieren.',
    ariaDisabledFieldHelpButton: '{{fieldName}} - Hilfe',
    ariaLeadsTableCaption: 'Leads-Tabelle, Spaltenüberschriften mit Schaltflächen sind sortierbar',
    ariaDomainsTableCaption: 'Domain-Tabelle',
    ariaUnitsTableCaption:
      'Einheitentabelle, Spaltenüberschriften mit Schaltflächen sind sortierbar',
    ariaProfilesTableCaption:
      'Profile-Tabelle, Spaltenüberschriften mit Schaltflächen sind sortierbar',
    ariaThemeLinkFileEdit: '{{name}} (global durch Admin festgelegt) - Bearbeiten',
    showNextPage: 'Nächste Seite anzeigen',
    showPreviousPage: 'Vorherige Seite anzeigen',
    ariaShowColumn: '{{name}} - Spalte anzeigen',
    ariaToggleVisibilityElement: '{{name}} - Sichtbar',
    ariaOpenActionFor: '{{name}} - Aktionen öffnen',
    ariaToggleBioAttributeVisibility: '{{name}} - Sichtbarkeit ändern',
    ariaDnd: {
      draggableItem: 'Manuell sortierbares Element',
      draggableDescription:
        'Drücke die Leertaste, um den Sortiervorgang zu starten. Beim Sortieren kannst Du die Pfeiltasten verwenden, um das Element zu verschieben, und die Escape-Taste, um den Vorgang abzubrechen. Bei einigen Bildschirmlesegeräten musst Du möglicherweise den Fokusmodus aktivieren oder die Durchreichtaste verwenden.',
      onDragStart:
        'Du hast das Element "{{itemName}}" in Position {{position}} angehoben. Verwende die Pfeiltasten, um es zu bewegen.',
      onDragUpdate:
        'Du hast das Element von Position {{fromPosition}} zu Position {{toPosition}} bewegt. Drücke die Leertaste, um es abzulegen.',
      onDragEnd:
        'Du hast das Element {{itemName}} abgelegt. Du hast das Element von Position {{fromPosition}} zu Position {{toPosition}} verschoben.',
    },
    ariaLeadCustomFieldOption: 'Option für benutzerdefiniertes Lead-Feld',
    'contactDetailsBox.boxLabel': 'Meine Kontaktdaten',
    'urlsBox_files.boxLabel': 'Meine Dateien',
    'urlsBox_links.boxLabel': 'Meine Links',
    'contactFormBox.boxLabel': 'Kontakt-Formular',
    'customBioTextBox.boxLabel': 'Über mich',
    'teamDirectoryBox.boxLabel': 'Teamverzeichnis',
    boxOrder: 'Anordnung der Boxen',
    loginError: 'Login fehlgeschlagen',
    loginErrorInfo:
      'Versuche dich aus- und wieder einzuloggen. Wenn der Fehler bestehen bleibt, kontaktiere Deine interne Kontaktperson oder unseren Support über das Formular.',
    sent: 'Gesendet',
    sendMail: 'E-Mail senden',
    teamDirectory: 'Teamverzeichnis',
    showTeamDirectoryBoxDescription:
      'Aktiviere diese Option, um ein Element mit allen Teamprofilen anzuzeigen. Wenn das Profil einer Unit zugewiesen ist, erscheinen nur die Profile der Haupt-Unit.',
    teamDirectoryGloballyActive:
      'Das Teamverzeichnis wird aufgrund der Profildesigneinstellungen auf diesem Profil bereits angezeigt.',
    teamDirectoryShowAll: 'All Profile aus dem Teamverzeichnis anzeigen',
    autoVCardDownloadGloballyActive:
      'Diese Einstellung ist bereits über die Profildesigneinstellungen global aktiviert und kann nur durch einen Admin angepasst werden.',
    crmCustomFieldsImported: 'CRM-Felder erfolgreich importiert',
    importCrmCustomFields: 'CRM-Felder re-importieren',
    voiceNote: {
      transcriptionDisabled: 'Transkription ist nicht verfügbar. Upgrade, um sie zu aktivieren.',
      failedToTranscribe: 'Fehler beim Transkribieren der Aufnahme',
      deleteSuccess: 'Aufnahme gelöscht erfolgreich',
      deleteError: 'Fehler beim Löschen der Aufnahme',
      addSuccess: 'Aufnahme hinzugefügt erfolgreich',
      addError: 'Fehler beim Hinzufügen der Aufnahme',
      deleteConfirmation: 'Bist Du sicher, dass Du diese Aufnahme löschen möchtest?',
      maxLimitReached: 'Du hast das Maximum an Aufnahmen erreicht',
      recordingNotAllowedLeadMustBeCreatedFirst:
        'Aufnahme ist nicht erlaubt. Bitte erstelle ein Lead.',
      updateSuccess: 'Aufnahmen aktualisiert erfolgreich',
      updateError: 'Fehler beim Aktualisieren der Aufnahmen',
      transcript: 'Transkript',
      reTranscribe: 'Erneut transkribieren',
      copy: 'Kopieren',
      edit: 'Bearbeiten',
      copyToNotesField: 'In Notizenfeld kopieren',
      copySuccess: 'Text in Zwischenablage kopiert',
      copyToNotesFieldSuccess: 'Text in Notizenfeld kopiert',
      showTranscript: 'Transkript anzeigen',
      viewEdit: 'Anzeigen/Bearbeiten',
      transcriptionLoading: 'Aufnahme wird transkribiert...',
      quotaExceeded: 'Nicht genug Credits für AI-Aktionen',
    },
    ariaVoiceNoteSettings: 'Aufnahmen-Einstellungen öffnen',
    ariaVoiceNoteAiActions: 'Aufnahmen-AI-Aktionen öffnen',
    billingPage: {
      title: 'Abrechnung',
      alertTitle: 'Wichtige Information',
      alertDescription:
        'Nur Nutzer*innen, deren E-Mail bei uns als Rechnungskontakt hinterlegt ist, können die Informationen einsehen. Falls Du die Informationen nicht einsehen kannst, schreib bitte an support@lemontaps.com',
      licenseCard: {
        yourSubscription: 'Dein Abo',
        licenses: '{{count}} Lizenzplätze',
        licensesInUse: 'aktuell {{count}} Plätze belegt',
        licenseDescription:
          'Die Vertragslaufzeit kannst Du aus Deinen letzten Rechnungen entnehmen.',
        showSubscriptionDetails: 'Abonnementdetails anzeigen',
        unlimitedLicenses: 'Unbegrenzte Lizenzplätze',
      },
      showInvoices: 'Rechnungen anzeigen',
      changeBillingAddress: 'Rechnungsadresse ändern',
      changePaymentMethod: 'Zahlungsmethode ändern',
      changePlan: 'Plan ändern oder Add-on hinzubuchen?',
      changePlanDescription: 'Wir können Dir helfen, das richtige Abo für Dich zu finden.',
      changePlanButton: 'Mit Vertrieb sprechen',
      showSubscription: 'Abo kündigen',
      subscriptionDialogTitle: 'Abo kündigen',
      subscriptionDialogContent:
        'Bitte sende Deine Kündigung an support@lemontaps.com. Die Kündigung muss mindestens zwei Monate vor Ablauf des Vertragsjahres erfolgen, da sich das Abonnement sonst automatisch um ein weiteres Jahr verlängert. \nDetails zum aktuellen Leistungszeitraum findest Du in Deiner letzten Rechnung.',
      limitAccededDialogTitle: 'Lizenzlimit überschritten',
      limitAccededDialogContent:
        'Du hast Dein Lizenzlimit überschritten – kein Problem! Die zusätzlichen Lizenzen werden automatisch erfasst, und Du erhältst einmal im Monat eine Rechnung dafür. Diese Lizenzen werden anteilig zur Jahresgebühr für die verbleibenden Monate berechnet.',
      popupClose: 'Fertig',
    },
    ariaUnitSettings: 'Unit-Einstellungen öffnen',
    ariaFaviconImageDelete: 'Favicon löschen',
    ariaDeleteBioAttribute: 'Attribut "{{name}}" löschen',
  },
};
